import { useState, useEffect } from "react";
import Header from "./Header";
import SideMenu from "./SideMenu";
import Modal from "react-modal";
import { getRequerimientoModal } from './requerimientos/index.js';
import { getEstadoPagoModal } from './eepp_gt/index.js';
import { useNavigate, useLocation } from "react-router-dom";
import { format, parse } from 'date-fns';
import Select from 'react-select';
import { PDFDocument } from 'pdf-lib';
import { validate } from 'rut.js';
import config from './config';
import './App.css';

Modal.setAppElement("#root");

function Dashboard() {
  const location = useLocation();
  const [dataLogin, setDataLogin] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [isSecondModalOpen, setSecondModalOpen] = useState(false);
  const [secondModalContent, setSecondModalContent] = useState(null);
  const [UFmensual, setUFmensual] = useState(null);
  const [indicadorUF, setIndicadorUF] = useState(null);
  const [UFmensualPasado, setUFmensualPasado] = useState(null);
  const [indicadorUFPasado, setIndicadorUFPasado] = useState(null);  
  const [diasFestivos, setDiasFestivos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const QRCode = require('qrcode');

  /* Start Inicializa modulos y variables globales */
  const generarQR = async (url) => {
    try {
      return await QRCode.toDataURL(url);
    } catch (err) {
      console.error('Error generando código QR', err);
    }
  }

  const insertarQR = async (pdfDoc, qrImageUrl, x, y, width, height) => {
    const qrImage = await pdfDoc.embedPng(qrImageUrl);
    const page = pdfDoc.getPage(0);
    page.drawImage(qrImage, {
      x: x,
      y: y,
      width: width,
      height: height
    });
  }

  useEffect(() => {
    if (location.state) {
      const receivedData = location.state;
      setDataLogin(receivedData); // Aquí tienes los datos enviados desde Login

      obtenerIndicadorUF();
      obtenerDiasFestivos();
      obtenerCotizaciones();
      obtenerRequerimientos();
      obtenerEstadosPagoBH();
      obtenerEstadosPagoGH();
      obtenerEstadosPagoGT();
      obtenerEstadosPagoEstado();

      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [location]);

  //Para inputs de fechas
  const today = new Date();

  const obtenerDiasEnMes = (mes, anio) => {
    return new Date(anio, mes, 0).getDate();
  }

  const [requerimientosData, setRequerimientosData] = useState([]);
  const obtenerRequerimientos = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/requerimiento.php`
      );
      const data = await response.json();

      if (data) {
        setRequerimientosData(data);
      }
    } catch (error) {
      setRequerimientosData([]);
    }
  };

  const [cotizacionesData, setCotizacionesData] = useState([]);
  const obtenerCotizaciones = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/cabecera_cotizacion.php`
      );

      const data = await response.json();

      if (data && data[0].folio) {
        setCotizacionesData(data);
      }
    } catch (error) {
      setCotizacionesData([]);
    }
  };

  const [estadosPagoBHData, setEstadosPagoBHData] = useState([]);
  const obtenerEstadosPagoBH = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_bh.php`
      );
      const data = await response.json();

      if (data && data[0].id_estado_pago_bh) {
        setEstadosPagoBHData(data);
      }
    } catch (error) {
      setEstadosPagoBHData([]);
    }
  };

  const [estadosPagoGHData, setEstadosPagoGHData] = useState([]);
  const obtenerEstadosPagoGH = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_gh.php`
      );
      const data = await response.json();

      if (data && data[0].id_estado_pago_gh) {
        setEstadosPagoGHData(data);
      }
    } catch (error) {
      setEstadosPagoGHData([]);
    }
  };

  const [estadosPagoGTData, setEstadosPagoGTData] = useState([]);
  const obtenerEstadosPagoGT = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_gt.php`
      );
      const data = await response.json();

      if (data && data[0].id_estado_pago_gt) {
        setEstadosPagoGTData(data);
      }
    } catch (error) {
      setEstadosPagoGTData([]);
    }
  };

  // Estados sugeridos (manteniendo nombres existentes y agregando sufijo Pasado)
  const obtenerIndicadorUF = async () => {
    try {
      const anioActual = new Date().getFullYear();
      const anioPasado = anioActual - 1;

      // Pedir ambos años en paralelo
      const [resActual, resPasado] = await Promise.all([
        fetch(`https://mindicador.cl/api/uf/${anioActual}`),
        fetch(`https://mindicador.cl/api/uf/${anioPasado}`)
      ]);

      const [dataActual, dataPasado] = await Promise.all([resActual.json(), resPasado.json()]);

      // Guardar los objetos completos en estado (manteniendo nombre original y agregando Pasado)
      setUFmensual(dataActual);
      setUFmensualPasado(dataPasado);

      // Fecha actual en formato chileno
      const fechaActual = new Date().toLocaleDateString('es-CL');

      // Función auxiliar para buscar valor por fecha en la serie
      const buscarValorPorFecha = (data) => {
        if (!data || !data.serie || data.serie.length === 0) return null;
        const encontrado = data.serie.find(item => {
          const itemDate = new Date(item.fecha).toLocaleDateString('es-CL');
          return itemDate === fechaActual;
        });
        return encontrado ? encontrado.valor : null;
      };

      // Obtener valores para cada año y guardarlos en los estados con los nombres existentes
      const valorActual = buscarValorPorFecha(dataActual);
      const valorPasado = buscarValorPorFecha(dataPasado);

      setIndicadorUF(valorActual);
      setIndicadorUFPasado(valorPasado);
    } catch (error) {
      console.error('Error al obtener el indicador UF:', error);
      // Mantener consistencia con nombres existentes y limpiar los estados Pasado también
      setUFmensual(null);
      setUFmensualPasado(null);
      setIndicadorUF(null);
      setIndicadorUFPasado(null);
    }
  };


  const obtenerDiasFestivos = async () => {
    try {
      const response = await fetch(`${config.apiBaseUrl}/obtieneFestivos.php`);
      const data = await response.json();

      if (data && data.length > 0) {
        setDiasFestivos(data);
      } else {
        setDiasFestivos([]);
      }
    } catch (error) {
      setDiasFestivos([]);
    }
  };

  //Obtener estado de estados de pago
  const [estadosPagoEstado, setEstadosPagoEstado] = useState([]);
  const obtenerEstadosPagoEstado = async () => {
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/estado_pago_estado.php`
      );
      const data = await response.json();

      if (data && data[0].id_estado_pago_estado) {
        setEstadosPagoEstado(data);
      }
    } catch (error) {
      setEstadosPagoEstado([]);
    }
  };

  const handleCardClick = (columnTitle, cardData) => {
    setModalOpen(true);
    // console.info(columnTitle, cardData)
    switch (columnTitle) {
      case "Requerimientos":
        setModalContent(getRequerimientoModal('view', {
          onClose: closeModal,
          dataLogin: dataLogin,
          requerimiento: cardData,
          onImageClick: (id_visita) => {
            console.log("Abrir modal de imágenes para visita:", id_visita);
            setModalContent(getRequerimientoModal('images', {
              onClose: closeModal,
              requerimiento: cardData,
              visita: id_visita
            }))
          },
          onAnularClick: (cardData) =>
            setModalContent(getRequerimientoModal('anular', {
              onClose: closeModal,
              dataLogin: dataLogin,
              requerimiento: cardData,
              closeSecondModal: closeSecondModal,
              obtenerRequerimientos: obtenerRequerimientos,
              navigate: navigate
            })),
          onReenviarClick: (cardData) => {
            setSecondModalContent(getRequerimientoModal('reenviar', {
              requerimiento: cardData,
              closeSecondModal
            }));
            setSecondModalOpen(true); // 👈 aquí lo abrís
          },
          handleEditButtonClick
        }));
        break;
      case "Cotización":
        setModalContent(<CotizacionModalContent data={cardData} />);
        break;
      case "Estado de pago BH":
        setModalContent(<EstadoPagoBHModalContent data={cardData} />);
        break;
      case "Estado de pago GH":
        setModalContent(<EstadoPagoGHModalContent data={cardData} />);
        break;
      case "Estado de pago GT":
      default:
        setModalContent(getEstadoPagoModal('GT', {
          dataLogin: dataLogin,
          data: cardData,
          obtenerEstadosPagoGT: obtenerEstadosPagoGT,
          estadosPagoEstado: estadosPagoEstado,
          setSecondModalOpen: setSecondModalOpen,
          setSecondModalContent: setSecondModalContent,
          closeSecondModal: closeSecondModal,
          onClose: closeModal,
          navigate: navigate,
          handleVerPDFep: handleVerPDFep,
          handleEnviaEP: handleEnviaEP
        }));
    }
  };

  const handleAddButtonClick = (columnTitle) => {
    setModalOpen(true);
    switch (columnTitle) {
      case "Requerimientos":
        setModalContent(getRequerimientoModal('add', {
          onClose: closeModal,
          dataLogin: dataLogin,
          setSecondModalOpen,
          setSecondModalContent
        }));
        break;
      case "Cotización":
        setModalContent(<AgregarCotizacionModalContent />);
        break;
      case "Estado de Pago BH":
        setModalContent(<AgregarEstadoPagoModalContent />);
        break;
      case "Estado de Pago GH":
        setModalContent(<AgregarEstadoPagoGHModalContent />);
        break;
      // default:
      //   setModalContent(<EstadoPagoGTModalAgregar />);
      case "Estado de pago GT":
      default:
        setModalContent(getEstadoPagoModal('GT_ADD', {
          dataLogin: dataLogin,
          indicadorUF: indicadorUF,
          indicadorUFPasado: indicadorUFPasado,
          obtenerDiasEnMes: obtenerDiasEnMes,
          UFmensual: UFmensual,
          UFmensualPasado: UFmensualPasado,
          diasFestivos: diasFestivos,
          navigate: navigate,
          onClose: closeModal,
          Select: Select,
          today: today
        }));
    }
  };

  const handleEditButtonClick = (columnTitle, data, detalle, cabeceraCot) => {
    setModalOpen(true);
    switch (columnTitle) {
      case "Requerimientos":
        setModalContent(getRequerimientoModal('edit', {
          onClose: closeModal,
          dataLogin: dataLogin,
          requerimiento: data,
          visitas: detalle,
          modoEdicion: true,
          setSecondModalOpen,
          setSecondModalContent
        }));
        break;
      case "Cotización":
        const serviciosCotizacion = detalle;

        setModalContent(<EditarCotizacionModalContent datos={data} cabecera={cabeceraCot} servicios={serviciosCotizacion} />);
        break;
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  const closeSecondModal = () => {
    setSecondModalOpen(false);
    setSecondModalContent(null);
  };

  //Búsquedas
  const [filtroRequerimiento, setFiltroRequerimiento] = useState('');
  const [filtroCotizacion, setFiltroCotizacion] = useState('');
  const [filtroEstadoPago, setFiltroEstadoPago] = useState('');

  const handleFiltrosDashboard = (event, title) => {
    switch (title) {
      case 'Requerimientos':
        setFiltroRequerimiento(event.target.value);
        break;
      case 'Cotización':
        setFiltroCotizacion(event.target.value);
        break;
      default:
        setFiltroEstadoPago(event.target.value);
    }
  };

  const requerimientosFiltrados = requerimientosData.filter((item) =>
    item.nombre_cliente.toLowerCase().includes(filtroRequerimiento.toLowerCase())
  );

  const cotizacionesFiltradas = cotizacionesData.filter((item) =>
    item.nombre_cliente.toLowerCase().includes(filtroCotizacion.toLowerCase())
  );

  const estadosPagoFiltrados = [
    ...estadosPagoBHData.filter((item) =>
      item.nombre_cliente.toLowerCase().includes(filtroEstadoPago.toLowerCase())
    ),
    ...estadosPagoGHData.filter((item) =>
      item.nombre_cliente.toLowerCase().includes(filtroEstadoPago.toLowerCase())
    ),
    ...estadosPagoGTData.filter((item) =>
      item.nombre_cliente.toLowerCase().includes(filtroEstadoPago.toLowerCase())
    ),
  ];

  const data = [
    {
      title: "Requerimientos",
      color: "#e53a13",
      cards: requerimientosFiltrados
    },
    {
      title: "Cotización",
      color: "#d986f8",
      cards: cotizacionesFiltradas
    },
    {
      title: "Estado de pago",
      color: "#00a7b5",
      cards: [{
        bh: estadosPagoBHData,
        gh: estadosPagoGHData,
        gt: estadosPagoGTData
      }]
    },
  ];

  const formatearRut = (rut) => {
    const rutFormateado = `${rut.slice(0, 2)}.${rut.slice(2, 5)}.${rut.slice(5)}`;
    return rutFormateado;
  };

  // Primera letra mayúscula
  const capitalizeFirstLetter = (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

  /* End Inicializa modulos y variables globales */

  /* Cotizaciones */
  function AgregarCotizacionModalContent() {
    const [clientes, setClientes] = useState([]);
    const [clienteSelected, setClienteSelected] = useState('');
    const [obras, setObras] = useState([]);
    const [datosCliente, setDatosCliente] = useState([]);
    const [obraSelected, setObraSelected] = useState('');
    const [maquinaria, setMaquinaria] = useState([]);
    const [idFolio, setIdFolio] = useState(null);
    const [requerimientos, setRequerimientos] = useState([]);
    const [servicios, setServicios] = useState([]);
    const [equipos, setEquipos] = useState([]);

    useEffect(() => {
      obtenerClientes();
      obtenerMaquinaria();
      obtenerIdFolio();
      obtenerRequerimientos();
      obtenerServicios();
      obtenerEquipos();
    }, []);

    const obtenerClientes = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente.php`
        );
        const data = await response.json();

        if (data && data[0].id_cliente) {
          setClientes(data);
        }
      } catch (error) {
        setClientes([]);
      }
    };

    const handleClienteSelect = async (clienteSelected) => {
      setClienteSelected(clienteSelected.value);
      await obtenerObras(clienteSelected.value);
      await obtenerDatosCliente(clienteSelected.value);

      var cliente = clienteSelected.value.toString();

      setFormCotizacionData({
        ...formCotizacionData,
        ["cliente_add"]: cliente
      });

      setFormDatosEmailData(prevState => ({
        ...prevState,
        cliente: clienteSelected.label
      }));
    };

    const handleClienteFinalSelect = async (clienteSelected) => {
      var cliente = clienteSelected.value.toString();

      setFormCotizacionData({
        ...formCotizacionData,
        ["cliente_final_add"]: cliente
      });
    };

    const obtenerObras = async (cliente) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente_obra.php?id_cliente=${cliente}`
        );
        const data = await response.json();

        if (data && data[0].id_obra) {
          setObras(data);
        }
      } catch (error) {
        setObras([]);
      }
    };

    const obtenerDatosCliente = async (cliente) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente.php?id_cliente=${cliente}`
        );
        const data = await response.json();

        if (data && data[0].id_cliente) {
          setDatosCliente(data);

          formCorreo.razon_social = data[0].razon_social;
        }
      } catch (error) {
        setDatosCliente([]);
      }
    };

    const obtenerMaquinaria = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/maquinaria.php`
        );
        const data = await response.json();

        if (data && data[0].id_maquinaria) {
          setMaquinaria(data);
        }
      } catch (error) {
        setMaquinaria([]);
      }
    };

    const optionsClientes = clientes.map((cliente) => ({
      value: cliente.id_cliente,
      label: cliente.nombre_cliente,
    }));

    const obtenerServicios = async (idMaquinaria) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/servicio.php?id_maquinaria=${idMaquinaria}`
        );
        const data = await response.json();

        if (data && data[0].id_servicio) {
          setServicios(data);
        }
      } catch (error) {
        setServicios([]);
      }
    };

    const obtenerEquipos = async (idMaquinaria) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/equipo.php?id_maquinaria=${idMaquinaria}`
        );
        const data = await response.json();

        if (data && data[0].id_equipo) {
          setEquipos(data);
        }
      } catch (error) {
        setEquipos([]);
      }
    };

    const obtenerIdFolio = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/folio.php`
        );

        const data = await response.json();

        if (data && data[0].id_folio) {
          const id_folio = data[0].id_folio + 1;
          setIdFolio(id_folio);
        }
      } catch (error) {
        setIdFolio(null);
      }
    };

    const obtenerRequerimientos = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/requerimiento.php`
        );
        const data = await response.json();

        if (data) {
          setRequerimientos(data);
        }
      } catch (error) {
        setRequerimientos([]);
      }
    };

    const [formCotizacionData, setFormCotizacionData] = useState({
      folio: "",
      cliente_add: "",
      obra_add: "",
      maquinaria_add: "",
      nombre_maquinaria_add: "",
      requerimiento_add: "",
      nombre_requerimiento_add: "",
      cliente_final_add: "",
      equipo_add: "",
      nombre_equipo_add: "",
      nombre_solicitante_add: "",
      observaciones_add: "",
      rut_solicitante_add: "",
      email_solicitante_add: "",
      fecha_estimada_inicio_add: "",
      fecha_estimada_fin_add: "",
      id_contacto: "",
      id_usuario: dataLogin.id_usuario,
      imagen: ""
    });

    //Datos para envío de correo electrónico
    const [formDatosEmail, setFormDatosEmailData] = useState({
      folio: "",
      obra: "",
      comuna: "",
      cliente: ""
    });

    const handleFormCotizacionData = (e) => {
      const textOnly = /^[A-Za-z\s]+$/;
      const { name, value, selectedIndex, options } = e.target;

      if (name === "obra_add") {
        setObraSelected(value);

        const idObra = parseInt(value, 10);
        const datosObra = obtenerDatosObra(idObra);

        formCotizacionData.id_contacto = datosObra ? datosObra.id_contacto : null;

        formCotizacionData.nombre_solicitante_add = datosObra.nombre_contacto;
        formCotizacionData.rut_solicitante_add = datosObra.rut_contacto;
        formCotizacionData.email_solicitante_add = datosObra.email_contacto;

        setFormDatosEmailData(prevState => ({
          ...prevState,
          obra: e.target.options[selectedIndex].text,
          comuna: datosObra ? datosObra.comuna_obra : null
        }));
      }

      if (name === "requerimiento_add") {
        const nombreRequerimiento = options[selectedIndex].text;

        formCotizacionData.nombre_requerimiento_add = nombreRequerimiento;
      }

      if (name === "equipo_add") {
        const nombreEquipo = options[selectedIndex].text;

        formCotizacionData.nombre_equipo_add = nombreEquipo;
      }

      if (name === "email_solicitante_add") {
        formCorreo.para = e.target.value;
      }

      if (e.target.name === "nombre_solicitante_add") {
        if (textOnly.test(value) || value === '') {
          setFormCotizacionData({
            ...formCotizacionData,
            [name]: value,
          });
        }
      } else {
        setFormCotizacionData({
          ...formCotizacionData,
          [name]: value,
        });
      }
    };

    const obtenerDatosObra = (idObra) => {
      const obra = obras.find(obra => obra.id_obra === idObra);
      return obra ? { id_contacto: obra.id_contacto, nombre_contacto: obra.nombre_contacto, rut_contacto: obra.rut, email_contacto: obra.email, comuna_obra: obra.comuna_obra } : null;
    };

    const [base64String, setBase64String] = useState('');
    const handleFileChange = (file) => {
      if (file) {
        // Verifica el tamaño del archivo (no mayor a 6 MB)
        if (file.size > 6 * 1024 * 1024) {
          alert("El archivo adjunto es demasiado grande (No exceder los 6 MB)");
          document.getElementById("formFile").value = "";
          return;
        }

        // Verifica el largo del nombre del archivo cargado
        if (file.name.length > 50) {
          alert("El nombre del archivo no debe exceder los 50 caracteres");
          document.getElementById("formFile").value = "";
          return;
        }

        // Verifica si el nombre del archivo contiene caracteres especiales
        const regex = /^[a-zA-Z0-9_.-\s]+$/; // Solo permite letras, números, guiones bajos, puntos, guiones y espacios
        if (!regex.test(file.name)) {
          alert("El nombre del archivo contiene caracteres no permitidos");
          document.getElementById("formFile").value = "";
          return;
        }

        // Verifica si el archivo es un PDF
        if (file.type !== "application/pdf") {
          alert("Solo se permiten archivos PDF");
          document.getElementById("formFile").value = "";
          return;
        }

        const reader = new FileReader();

        reader.onloadend = () => {
          // Convierte el contenido del archivo a base64
          const base64String = btoa(reader.result);
          setBase64String(base64String);

          setFormCotizacionData({
            ...formCotizacionData,
            ["imagen"]: base64String,
          });
        };

        reader.readAsBinaryString(file);
      }
    };

    const [dataServiciosCotizacion, setServiciosCotizacionData] = useState({});
    const handleServiciosCotizacionChange = (e, servicio) => {
      const { name, value } = e.target;

      const idServicio = servicio.id_servicio;
      const idUnidadMedida = servicio.id_unidad_medida;
      const IdMaquinariaNombre = "id_maquinaria_" + idServicio;
      const nombreMaquinariaNombre = "nombre_maquinaria_" + idServicio;
      const tipoMaquinariaNombre = "tipo_maquinaria_" + idServicio;
      const tipoArriendoNombre = "tipo_arriendo_" + idServicio;
      const glosaServicioNombre = "glosa_servicio_" + idServicio;
      const inputFolioNombre = "folio_" + idServicio;
      const inputUnidadMedidaNombre = "id_unidad_medida_" + idServicio;
      const unidadMedidaNombre = "unidad_medida_" + idServicio;
      const itemOrdenNombre = "item_orden_" + idServicio;

      if (/^\d*([\.]\d*)?$/.test(value)) {
        setServiciosCotizacionData(prevData => ({
          ...prevData,
          [idServicio]: {
            ...prevData[idServicio],
            [inputFolioNombre]: folioCotizacion,
            [IdMaquinariaNombre]: servicio.id_maquinaria,
            [nombreMaquinariaNombre]: servicio.nombre_maquinaria,
            [tipoMaquinariaNombre]: servicio.tipo_maquinaria,
            [tipoArriendoNombre]: servicio.tipo_arriendo,
            [glosaServicioNombre]: servicio.glosa_servicio,
            [name]: value,
            [inputUnidadMedidaNombre]: idUnidadMedida,
            [unidadMedidaNombre]: servicio.unidad_medida,
            [itemOrdenNombre]: servicio.item_orden
          },
        }));
      }
    };

    const modificaLlavesServiCot = (objetoOriginal) => {
      const nuevoObjeto = {};

      Object.keys(objetoOriginal).forEach((clave) => {
        const nuevoNombreFolio = `folio`;
        const nuevoNombreIdMaquinaria = `id_maquinaria`;
        const nuevoNombreMaquinaria = `nombre_maquinaria`;
        const nuevoNombreTipoMaquinaria = `tipo_maquinaria`;
        const nuevoNombreTipoArriendo = `tipo_arriendo`;
        const nuevoNombreGlosaServicio = `glosa_servicio`;
        const nuevoNombreCantidad = `cantidad_minima`;
        const nuevoNombreIdUnidadMedida = `id_unidad_medida`;
        const nuevoNombreValor = `valor_unitario_neto`;
        const nuevoNombreValorPM = `valor_unitario_neto_pm`;
        const nuevoNombreItemOrden = `item_orden`;
        const nuevoNombreUnidadMedida = `unidad_medida`;
        const nuevoNombreIdUsuario = `id_usuario`;

        nuevoObjeto[clave] = {
          [nuevoNombreFolio]: objetoOriginal[clave][`folio_${clave}`],
          [nuevoNombreIdMaquinaria]: objetoOriginal[clave][`id_maquinaria_${clave}`],
          [nuevoNombreMaquinaria]: objetoOriginal[clave][`nombre_maquinaria_${clave}`],
          [nuevoNombreTipoMaquinaria]: objetoOriginal[clave][`tipo_maquinaria_${clave}`],
          [nuevoNombreTipoArriendo]: objetoOriginal[clave][`tipo_arriendo_${clave}`],
          [nuevoNombreGlosaServicio]: objetoOriginal[clave][`glosa_servicio_${clave}`],
          [nuevoNombreCantidad]: objetoOriginal[clave][`cantidad_minima_${clave}`],
          [nuevoNombreIdUnidadMedida]: objetoOriginal[clave][`id_unidad_medida_${clave}`],
          [nuevoNombreUnidadMedida]: objetoOriginal[clave][`unidad_medida_${clave}`],
          [nuevoNombreValor]: objetoOriginal[clave][`valor_unitario_neto_${clave}`],
          [nuevoNombreValorPM]: objetoOriginal[clave][`valor_unitario_neto_pm_${clave}`],
          [nuevoNombreItemOrden]: objetoOriginal[clave][`item_orden_${clave}`],
          [nuevoNombreIdUsuario]: objetoOriginal[clave][`id_usuario_${clave}`],
        };
      });

      return nuevoObjeto;
    };

    const modificaLlavesServiCotOrdenado = (objetoOriginal) => {
      const nuevoArray = Object.keys(objetoOriginal).map((clave) => {
        const idServicio = parseInt(clave);
        const nombreMaquinaria = objetoOriginal[clave][`nombre_maquinaria_${clave}`];
        const itemOrden = objetoOriginal[clave][`item_orden_${clave}`];

        // Extrae las iniciales de maquinaria
        const iniciales = itemOrden.split('-')[0];

        // Alias de unidad de medida
        let unidadMedidaAlias;
        switch (objetoOriginal[clave][`unidad_medida_${clave}`]) {
          case "Horas Reloj Día":
            unidadMedidaAlias = "HRD";
            break;
          case "Mensual":
            unidadMedidaAlias = "MM";
            break;
          default:
            unidadMedidaAlias = "N/A";
            break;
        }

        return {
          id_servicio: idServicio,
          sku: `${iniciales}${idServicio}`, // Concatenar iniciales con id_servicio
          folio: objetoOriginal[clave][`folio_${clave}`],
          item_orden: itemOrden,
          descripcion: objetoOriginal[clave][`glosa_servicio_${clave}`],
          iniciales,
          nombre_maquinaria: nombreMaquinaria,
          id_maquinaria: objetoOriginal[clave][`id_maquinaria_${clave}`],
          id_tipo_maquinaria: 0, // Campo estático como en tu ejemplo
          tipo_maquinaria: objetoOriginal[clave][`tipo_maquinaria_${clave}`],
          tipo_arriendo: objetoOriginal[clave][`tipo_arriendo_${clave}`],
          cantidad_minima: parseFloat(objetoOriginal[clave][`cantidad_minima_${clave}`]).toFixed(2),
          id_unidad_medida: objetoOriginal[clave][`id_unidad_medida_${clave}`],
          unidad_medida: objetoOriginal[clave][`unidad_medida_${clave}`],
          unidad_medida_alias: unidadMedidaAlias,
          valor_unitario_neto: parseFloat(objetoOriginal[clave][`valor_unitario_neto_${clave}`]).toFixed(4),
          valor_unitario_neto_pm: parseFloat(objetoOriginal[clave][`valor_unitario_neto_pm_${clave}`]).toFixed(4),
        };
      });

      // Ordenar por item_orden
      return nuevoArray.sort((a, b) => {
        const numA = parseInt(a.item_orden.split('-')[1].replace('A', ''));
        const numB = parseInt(b.item_orden.split('-')[1].replace('A', ''));

        return numA - numB; // Ordenar por número
      });
    };

    const [folioCotizacion, setFolioCotizacionData] = useState('');
    const [checkboxStates, setCheckboxStates] = useState({});
    const toggleCheckbox = (filaId, servicio) => {
      setCheckboxStates((prevState) => ({
        ...prevState,
        [filaId]: !prevState[filaId],
      }));

      //Agrega folio
      const currentYear = new Date().getFullYear();

      const idMaquinaria = Number(maquinariaFiltro);
      const maquinariaEncontrada = maquinaria.find(maquinaria => maquinaria.id_maquinaria === idMaquinaria);
      let inicialesMaquinaria = maquinariaEncontrada.iniciales;

      const folio = currentYear + "-" + idFolio + "-" + inicialesMaquinaria + "-" + dataLogin.iniciales;

      setFolioCotizacionData(folio);

      setFormCotizacionData({
        ...formCotizacionData,
        ["folio"]: folio,
      });

      setFormDatosEmailData(prevState => ({
        ...prevState,
        folio: folio
      }));

      //Valores iniciales de cantidad minima y valor unitario neto
      const idServicio = servicio.id_servicio;
      const idUnidadMedida = servicio.id_unidad_medida;
      const unidadMedidaNombre = "unidad_medida_" + idServicio;
      const IdMaquinariaNombre = "id_maquinaria_" + idServicio;
      const nombreMaquinariaNombre = "nombre_maquinaria_" + idServicio;
      const tipoMaquinariaNombre = "tipo_maquinaria_" + idServicio;
      const tipoArriendoNombre = "tipo_arriendo_" + idServicio;
      const glosaServicioNombre = "glosa_servicio_" + idServicio;
      const inputFolioNombre = "folio_" + idServicio;
      const inputUnidadMedidaNombre = "id_unidad_medida_" + idServicio;
      const inputCantidadMinimaNombre = "cantidad_minima_" + idServicio;
      const inputCantidadMinima = document.getElementById(inputCantidadMinimaNombre);
      const inputValorUnitarioNombre = "valor_unitario_neto_" + idServicio;
      const inputValorUnitario = document.getElementById(inputValorUnitarioNombre);
      const inputValorUnitarioPMNombre = "valor_unitario_neto_pm_" + idServicio;
      const inputValorUnitarioPM = document.getElementById(inputValorUnitarioPMNombre);
      const inputItemOrdenNombre = "item_orden_" + idServicio;
      const idUsuario = "id_usuario_" + idServicio;

      // Comprobar si el atributo "disabled" está presente
      if (inputCantidadMinima && inputCantidadMinima.disabled) {
        //Agrega valores iniciales si el input se habilita
        setServiciosCotizacionData(prevData => ({
          ...prevData,
          [idServicio]: {
            ...prevData[idServicio],
            [inputFolioNombre]: folio,
            [IdMaquinariaNombre]: servicio.id_maquinaria,
            [nombreMaquinariaNombre]: servicio.nombre_maquinaria,
            [tipoMaquinariaNombre]: servicio.tipo_maquinaria,
            [tipoArriendoNombre]: servicio.tipo_arriendo,
            [glosaServicioNombre]: servicio.glosa_servicio,
            [inputCantidadMinima.name]: inputCantidadMinima.value,
            [inputValorUnitario.name]: inputValorUnitario.value,
            [inputValorUnitarioPMNombre]: inputValorUnitarioPM ? inputValorUnitarioPM.value : "0",
            [inputUnidadMedidaNombre]: idUnidadMedida,
            [unidadMedidaNombre]: servicio.unidad_medida,
            [inputItemOrdenNombre]: servicio.item_orden,
            [idUsuario]: dataLogin.id_usuario
          },
        }));
      } else {
        //Elimina valores si el input se deshabilita
        const newData = { ...dataServiciosCotizacion };
        delete newData[idServicio];
        setServiciosCotizacionData(newData);
      }
    };

    const navigate = useNavigate();
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const handleSubmitCotizacion = async (event, mostrarTablaCC, filas) => {
      event.preventDefault();

      setSubmitDisabled(true);

      try {
        //Valida los email ingresados
        const validaEmail = filas.every(item => validarEmail(item.email_cc));

        if (mostrarTablaCC && !validaEmail) {
          alert('Debe ingresar el o los email y comprobar si están correctos');
        } else {
          //Inserción de folio
          const folioData = {
            id_folio: idFolio,
            folio: folioCotizacion
          };

          const responseFolioCotizacion = await fetch(
            `${config.apiBaseUrl}/folio.php`,
            {
              method: "POST",
              headers: {
                'Accept': 'application/json', // Indica que esperas una respuesta JSON
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(folioData),
            }
          );

          const dataFolioCotizacion = await responseFolioCotizacion.json();
          if (dataFolioCotizacion.message === "Folio agregado con éxito.") {

            const responseCabeceraCotizacion = await fetch(
              `${config.apiBaseUrl}/cabecera_cotizacion.php`,
              {
                method: "POST",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formCotizacionData),
              }
            );

            const dataCabeceraCotizacion = await responseCabeceraCotizacion.json();
            if (dataCabeceraCotizacion.message === "Cabecera de cotización agregada con éxito.") {
              const objetoTransformado = modificaLlavesServiCot(dataServiciosCotizacion);
              const responseServiciosCotizacion = await fetch(
                `${config.apiBaseUrl}/detalle_cotizacion.php`,
                {
                  method: "POST",
                  headers: {
                    'Accept': 'application/json', // Indica que esperas una respuesta JSON
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(objetoTransformado),
                }
              );

              const dataServCotizacion = await responseServiciosCotizacion.json();
              if (dataServCotizacion.message === "Detalle de cotización agregado con éxito.") {
                closeSecondModal();
                closeModal();

                crearDescargarPDFCotizacion(filas, mostrarTablaCC);

                setFormCotizacionData({
                  folio: "",
                  cliente_add: "",
                  obra_add: "",
                  maquinaria_add: "",
                  nombre_maquinaria_add: "",
                  requerimiento_add: "",
                  nombre_requerimiento_add: "",
                  cliente_final_add: "",
                  equipo_add: "",
                  nombre_equipo_add: "",
                  nombre_solicitante_add: "",
                  observaciones_add: "",
                  rut_solicitante_add: "",
                  email_solicitante_add: "",
                  fecha_estimada_inicio_add: "",
                  fecha_estimada_fin_add: "",
                  id_contacto: "",
                  id_usuario: "",
                  imagen: ""
                });

                setServiciosCotizacionData([]);

                navigate("/dashboard", { state: dataLogin });
              }
            }
          } else {
            throw new Error();
          }
        }
      } catch (error) {
        //alert(error);
        console.log("Error");
      }
    }

    const validaFormulario = () => {
      if (formCotizacionData.cliente_add === "") {
        alert('Debe seleccionar un cliente');
        return false;
      }

      if (formCotizacionData.obra_add === "") {
        alert('Debe seleccionar una obra');
        return false;
      }

      if (formCotizacionData.cliente_final_add === "") {
        alert('Debe seleccionar un cliente final');
        return false;
      }

      if (formCotizacionData.maquinaria_add === "") {
        alert('Debe seleccionar una maquinaria');
        return false;
      }

      if (formCotizacionData.equipo_add === "") {
        setFormCotizacionData({
          ...formCotizacionData,
          ["equipo_add"]: 0,
        });
      }

      if (formCotizacionData.nombre_solicitante_add === "") {
        alert('Debe ingresar un nombre de solicitante');
        return false;
      }

      if (formCotizacionData.rut_solicitante_add === "") {
        alert('Debe ingresar un rut de solicitante');
        return false;
      }

      if (formCotizacionData.email_solicitante_add === "" || !validarEmail(formCotizacionData.email_solicitante_add)) {
        alert('Debe ingresar un email de solicitante y compruebe si está correcto');
        return false;
      }

      if (formCotizacionData.email_solicitante_add === "") {
        alert('Debe ingresar un email de solicitante');
        return false;
      }

      if (formCotizacionData.fecha_estimada_inicio_add === "") {
        alert('Debe ingresar una fecha estimada de inicio');
        return false;
      }

      if (formCotizacionData.fecha_estimada_fin_add === "") {
        alert('Debe ingresar una fecha estimada de fin');
        return false;
      }

      return true;
    }

    //Filtro Por Servicio
    const [maquinariaFiltro, setMaquinariaFiltro] = useState('');
    const handleFiltroMaquinariaData = (event) => {
      const { value, selectedIndex, options } = event.target;

      setCheckboxStates({});
      setServiciosCotizacionData({});
      setMaquinariaFiltro(value);
      obtenerServicios(value);
      obtenerEquipos(value);

      setFormCotizacionData({
        ...formCotizacionData,
        ["maquinaria_add"]: value,
        ["nombre_maquinaria_add"]: options[selectedIndex].text,
      });
    };

    //Filtro Servicios Cotización
    const [filtroServiciosCotizacion, setFiltroServiciosCotizacion] = useState('');
    const manejarCambioFiltro = (event) => {
      setFiltroServiciosCotizacion(event.target.value);
    };

    const serviciosFiltrados = servicios.filter((item) =>
      item.glosa_servicio.toLowerCase().includes(filtroServiciosCotizacion.toLowerCase())
    );

    //Valida Rut
    const validarRut = (rut) => {
      return validate(rut);
    }

    //Valida Email
    const validarEmail = (email) => {
      // Expresión regular para validar el formato del correo electrónico
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    //Datos PDF
    const [datosPDF, setDatosPDF] = useState(null);

    useEffect(() => {
      const idCliente = parseInt(clienteSelected);
      const clienteEncontrado = clientes.find(c => c.id_cliente === idCliente);

      const idObra = parseInt(obraSelected);
      const obraEncontrada = obras.find(o => o.id_obra === idObra);

      obtenerContacto(clienteSelected);

      setDatosPDF({
        cliente: clienteEncontrado,
        obra: obraEncontrada,
        contacto: {}
      });
    }, [clienteSelected, obraSelected]);

    const obtenerContacto = async (cliente) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/contacto_2.php/?id_cliente=${cliente}`
        );
        const data = await response.json();

        if (data && data[0].id_contacto) {
          setDatosPDF(prevState => ({
            ...prevState,
            contacto: data[0]
          }));
        }
      } catch (error) {
        setDatosPDF(prevState => ({
          ...prevState,
          contacto: {}
        }));
      }
    };

    const [pdfBytes, setPdfBytes] = useState(null);
    const crearDescargarPDFCotizacion = async (filas, mostrarTablaCC) => {
      //Agrega Datos Email
      formCorreo.para = formCotizacionData.email_solicitante_add;
      formCorreo.cliente = formCotizacionData.nombre_solicitante_add;

      if (!mostrarTablaCC) {
        formCorreo.cc = [];
      } else {
        const filasEmail = filas.map(({ email_cc, ...rest }) => ({
          ...rest,
          email: email_cc
        }));
        formCorreo.cc = filasEmail;
      }

      //formCorreo.asunto = formCorreo.asunto + formCotizacionData.folio;
      formCorreo.asunto = "Cotización N°: " + formDatosEmail.folio + " - Vittamaq / " + formDatosEmail.obra + " / " + formDatosEmail.comuna + " / " + formDatosEmail.cliente;

      const existingPdfBytes = await fetch(`${config.apiBaseUrl}/obtienePlantillaCotizacion.php`).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      // Generar código QR
      // const urlQR = 'www.google.cl';
      const urlQR = 'https://vittamaq.cl/';
      const qrImageUrl = await generarQR(urlQR);

      // Insertar código QR en el PDF
      console.info('ver qr')
      await insertarQR(pdfDoc, qrImageUrl, 340, 680, 50, 50);

      // Obtener el formulario del PDF
      const form = pdfDoc.getForm();

      // Fecha Cotización
      let fechaActual = new Date();
      const formatDate = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
      };
      const fechaCotizacion = formatDate(fechaActual);
      // Cabecera Cotización
      form.getTextField('Folio').setText(formCotizacionData.folio);
      form.getTextField('Cotizador').setText(dataLogin.nombres + ' ' + dataLogin.apellido_paterno + ' ' + dataLogin.apellido_materno + ' ' + dataLogin.telefono);
      form.getTextField('Nombre_Cliente').setText(datosPDF.cliente.nombre_cliente);
      form.getTextField('Rut_Cliente').setText(formatearRut(datosPDF.cliente.rut));
      form.getTextField('Razon_Social').setText(datosPDF.cliente.razon_social);
      form.getTextField('Giro_Cliente').setText(datosPDF.cliente.giro);
      form.getTextField('Direccion_Cliente').setText(datosPDF.cliente.direccion);
      form.getTextField('Obra_Cliente').setText(datosPDF.obra.nombre);
      form.getTextField('Direccion_Obra').setText(datosPDF.obra.direccion + " (" + datosPDF.obra.comuna_obra + ")");

      form.getTextField('Fecha_Cotizacion').setText(fechaCotizacion);
      form.getTextField('Contacto').setText(datosPDF.obra.nombre_contacto);
      form.getTextField('Cargo_Contacto').setText(datosPDF.obra.cargo);


      form.getTextField('Telefono_Contacto').setText(datosPDF.obra.telefono);
      form.getTextField('Email_Contacto').setText(datosPDF.obra.email);
      form.getTextField('Observaciones').setText(formCotizacionData.observaciones_add ? formCotizacionData.observaciones_add : "");

      if (formCotizacionData.maquinaria_add === "1") {
        form.getTextField('Equipo').setText(
          `${formCotizacionData.nombre_maquinaria_add} (${formCotizacionData.nombre_requerimiento_add})`
        );
      } else {
        form.getTextField('Equipo').setText(
          `${formCotizacionData.nombre_maquinaria_add} - ${formCotizacionData.nombre_equipo_add} (${formCotizacionData.nombre_requerimiento_add})`
        );
      }

      // Servicios Cotización
      const objetoTransformado = modificaLlavesServiCotOrdenado(dataServiciosCotizacion);

      let pmInserted = false;

      objetoTransformado.forEach((detalle, index) => {
        form.getTextField(`Item_Orden_${index + 1}`).setText(detalle.item_orden.split('-')[1]);
        if (detalle.descripcion !== "") {
          form.getTextField(`Descripcion_${index + 1}`).setText(detalle.descripcion);
        } else {
          form.getTextField(`Descripcion_${index + 1}`).setText(detalle.nombre_maquinaria + " " + detalle.tipo_maquinaria + " " + detalle.tipo_arriendo);
        }
        form.getTextField(`Cantidad_Minima_${index + 1}`).setText(detalle.cantidad_minima);
        form.getTextField(`Unidad_Medida_${index + 1}`).setText(detalle.unidad_medida);

        if (detalle.id_maquinaria === 1) {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(detalle.valor_unitario_neto + " UF");
        } else if (detalle.id_maquinaria === 2) {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(String("$ " + parseInt(detalle.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')));
        } else {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(String(parseFloat(detalle.valor_unitario_neto).toFixed(2) + " UF"));
        }

        if (detalle.id_maquinaria === 1 && !pmInserted) {
          form.getTextField(`Valor_Unitario_Neto_PM_${index + 1}`).setText(detalle.valor_unitario_neto_pm + " UF (PM)");
          pmInserted = true;
        }
      });

      // Guardar el PDF modificado
      const modifiedPdfBytes = await pdfDoc.save();

      // Convierte los bytes en base64
      const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      };

      // Convertir a base64 el PDF modificado y añadirlo al Email como adjunto
      const pdfBase64 = arrayBufferToBase64(modifiedPdfBytes);
      //formCorreo.adjunto[0].Base64 = pdfBase64;

      const adjuntoCotizacion = {
        NombreAdjunto: "Cotización Vittamaq " + formDatosEmail.folio,
        TipoDocumento: "pdf",
        Base64: pdfBase64
      };

      //Condiciones Generales
      const existingPdfBytesCG = await fetch(`${config.apiBaseUrl}/obtienePlantillaCondicionesGenerales.php?id_maquinaria=${formCotizacionData.maquinaria_add}`).then((res) => res.arrayBuffer());

      const pdfDocCG = await PDFDocument.load(existingPdfBytesCG);

      // Obtener el formulario del PDF
      const formCG = pdfDocCG.getForm();

      formCG.getTextField('FOLIO').setText(formCotizacionData.folio);

      const modifiedPdfBytesCG = await pdfDocCG.save();

      const pdfBase64CG = arrayBufferToBase64(modifiedPdfBytesCG);

      const adjuntoCondGen = {
        NombreAdjunto: "Condiciones Generales " + formDatosEmail.folio,
        TipoDocumento: "pdf",
        Base64: pdfBase64CG
      };

      if (formCotizacionData.imagen) {
        const adjuntoDocumento = {
          NombreAdjunto: "Documento Vittamaq " + formDatosEmail.folio,
          TipoDocumento: "pdf",
          Base64: formCotizacionData.imagen
        };

        formCorreo.adjuntos = [adjuntoCotizacion, adjuntoCondGen, adjuntoDocumento];
      } else {
        formCorreo.adjuntos = [adjuntoCotizacion, adjuntoCondGen];
      }

      // Actualizar el estado para que React renderice el PDF modificado
      setPdfBytes(modifiedPdfBytes);

      // Crear un objeto Blob con los bytes del PDF modificado
      const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });

      guardarPDF(blob, formCotizacionData.folio);
      handleEnviarCorreo();
    };

    const guardarPDF = async (blob, folio) => {
      const formData = new FormData();
      formData.append('pdf', blob, folio);

      try {
        const response = await fetch(`${config.apiBaseUrl}/guardar_pdf.php`, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          const responseData = await response.text();
          //console.log('Respuesta del servidor:', responseData);
        } else {
          console.error('Error al enviar el PDF al servidor:', response.status);
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };

    /* Envío de Correo: Cotización */
    const [formCorreo, setFormCorreo] = useState({
      para: "",
      asunto: "Cotización: ",
      cliente: "",
      razon_social: "",
      texto_cuerpo: "A continuación, adjuntamos la cotización detallada que hemos preparado para proporcionarles una oferta que se ajuste a sus necesidades y expectativas. Por favor, revisar y no dude en ponerse en contacto con nosotros si tiene alguna pregunta o necesita más información.",
      cc: {},
    });

    const handleEnviarCorreo = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/envio_correos.php`,
          {
            method: "POST",
            headers: {
              'Accept': 'application/json', // Indica que esperas una respuesta JSON
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formCorreo),
          }
        );

        const data = await response.json();
        //console.log("Respuesta: " + JSON.stringify(data,null,2));

        if (data.message === "El correo electrónico ha sido enviado correctamente.") {
          const estadoData = [{ folio: formCotizacionData.folio, id_estado_cotizacion: 2, id_usuario_actualizacion: dataLogin.id_usuario }];
          const responseCambioEstado = await fetch(
            `${config.apiBaseUrl}/cabecera_cotizacion.php`,
            {
              method: "PUT",
              headers: {
                'Accept': 'application/json', // Indica que esperas una respuesta JSON
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(estadoData),
            }
          );

          const dataResponseCambioEstado = await responseCambioEstado.json();
          if (dataResponseCambioEstado.message === "Estado de cotización modificado con éxito.") {
            alert("Se ha registrado exitosamente la cotización y ha sido enviada por correo electrónico.");
            obtenerCotizaciones();
          }

        }
      } catch (error) {
        alert("Hubo un error al enviar el correo electrónico 1: " + error);
      }
    };

    // Valida que se registre al menos 1 servicio combinado (También que solo debe haber 1 servicio combinado) por cotización
    function validarTiposMaquinarias(data) {
      let countTipoMaquinaria = 0;

      for (const key in data) {
        if (data.hasOwnProperty(key) && data[key].hasOwnProperty("tipo_maquinaria_" + key)) {
          const tipoMaquinariaValue = data[key]["tipo_maquinaria_" + key];
          const idMaquinariaValue = data[key]["id_maquinaria_" + key];

          // Verificar si idTipoMaquinariaValue es 3
          if (idMaquinariaValue === 3) {
            return true;
          }

          if (tipoMaquinariaValue !== null && tipoMaquinariaValue !== "") {
            countTipoMaquinaria++;
            if (countTipoMaquinaria > 1) {
              //return false;
              return true;
            }
          }
        }
      }

      return countTipoMaquinaria === 1; // Retorna true solo si hay exactamente un tipo de maquinaria asignado
    }

    /* Confirmación de cotización y envío de correo */
    const handleConfirmaCotizacion = (e, folio, email) => {
      const esFormularioValido = validaFormulario();

      if (Object.keys(dataServiciosCotizacion).length === 0) {
        alert('Debe agregar al menos un servicio');
      }
      if (Object.keys(dataServiciosCotizacion).length > 30) {
        alert('Se permiten hasta 30 items por cotización');
      }
      else if (!validarTiposMaquinarias(dataServiciosCotizacion)) {
        alert('Se debe seleccionar al menos un servicio combinado (Solo 1 por cotización).');
      } else if (esFormularioValido) {
        const esRutValido = validarRut(formCotizacionData.rut_solicitante_add);
        if (!esRutValido) {
          alert("Rut No Válido");
        } else {
          setSecondModalOpen(true);
          setSecondModalContent(<ConfirmaCotizacionModalContent folio={folio} email={email} />);
        }
      }
    };

    function ConfirmaCotizacionModalContent({ folio, email }) {
      const [filas, setFilas] = useState([]);

      useEffect(() => {
        obtenerEmailCC();
      }, []);

      const obtenerEmailCC = async () => {
        try {
          const response = await fetch(
            `${config.apiBaseUrl}/email_cc.php`
          );
          const data = await response.json();
          if (data && data[0].id_email_cc) {
            setFilas(data);
          }
        } catch (error) {
          setFilas([]);
        }
      };

      /* Agregar CC */
      const [mostrarTablaCC, setMostrarTablaCC] = useState(true);
      const [mostrarBotonCC, setMostrarBotonCC] = useState(true);

      const handleRadioChange = (event) => {
        setMostrarTablaCC(event.target.value === "1");

        setMostrarBotonCC(!mostrarBotonCC);

        setFilas([{
          "id_email_cc": 1,
          "email_cc": ""
        }]);
      }

      const handleAgregarFila = () => {
        let siguienteId = 1;

        while (filas.some(fila => fila.id_email_cc === siguienteId)) {
          siguienteId++;
        }

        const nuevaFila = {
          id_email_cc: siguienteId,
          email_cc: ''
        };

        setFilas([...filas, nuevaFila]);
      };

      const handleInputChange = (id, campo, valor) => {
        const nuevasFilas = filas.map((fila) =>
          fila.id_email_cc === id ? { ...fila, [campo]: valor } : fila
        );

        setFilas(nuevasFilas);
      };

      const handleEliminarFila = (id) => {
        // Verificar que haya más de una fila antes de eliminar
        if (filas.length > 1) {
          const nuevasFilas = filas.filter((fila) => fila.id_email_cc !== id);
          setFilas(nuevasFilas);
        } else {
          alert("Debe agregar al menos un email, de lo contrario seleccione 'NO'.");
        }
      };

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Confirmar Cotización</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5 mb-2">¿Está seguro que desea ingresar la cotización: <span className="text-orange">{folio}</span>?</p>
              <p>Se enviará mediante correo electrónico a la dirección indicada: <span className="text-orange">{email}.</span></p>
              <p>¿Requiere copiar cotización a otras direcciones de correo electrónico (CC)?</p>
              <div className="d-flex justify-content-md-between">
                <div>
                  <input
                    type="radio"
                    className="btn-check"
                    name="email_cc"
                    id="email-cc-si"
                    autoComplete="off"
                    value="1"
                    checked={mostrarTablaCC}
                    onChange={handleRadioChange}
                  />
                  <label className="btn" htmlFor="email-cc-si">Si</label>
                  <input
                    type="radio"
                    className="btn-check"
                    name="email_cc"
                    id="email-cc-no"
                    autoComplete="off"
                    value="0"
                    checked={!mostrarTablaCC}
                    onChange={handleRadioChange}
                  />
                  <label className="btn" htmlFor="email-cc-no">No</label>
                </div>
                {mostrarBotonCC && (
                  <button type="button" className="btn btn-dark btn-sm" onClick={handleAgregarFila}>
                    <i className="bi-plus-circle"></i> Agregar
                  </button>
                )}
              </div>
              {mostrarTablaCC && (
                <div className="mt-3">
                  <table className="table mb-0">
                    <thead>
                      <tr className="table-active">
                        <th>Email</th>
                        <th>Eliminar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filas.map((fila, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              id={"email_cc_" + index}
                              value={fila.email_cc}
                              onChange={(e) =>
                                handleInputChange(fila.id_email_cc, 'email_cc', e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id_email_cc)}>
                              <i className="bi bi-trash3"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-yellow" onClick={(e) => handleSubmitCotizacion(e, mostrarBotonCC, filas)} disabled={submitDisabled}>
                <i className="bi bi-floppy"></i> Guardar
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Agregar Cotización</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body py-3 px-5">
            <div className="row row-cols-1 row-cols-md-2 mb-3">
              {clientes ? (
                <div className="col">
                  <label className="form-label">Cliente</label>
                  <Select
                    name="cliente_add"
                    value={clienteSelected.value}
                    onChange={handleClienteSelect}
                    options={optionsClientes}
                    isSearchable
                    className="react-select"
                    placeholder="Seleccione un cliente"
                  />
                </div>
              ) : (
                <div className="col">
                  <label className="form-label">Cliente</label>
                  <select className="form-select" name="cliente_add">
                    <option value="">No se encontraron clientes</option>
                  </select>
                </div>
              )}
              {obras ? (
                <div className="col">
                  <label className="form-label">Obra</label>
                  <select className="form-select" name="obra_add" value={obraSelected || formCotizacionData.obra_add} onChange={handleFormCotizacionData}>
                    <option value="">Seleccione una obra</option>
                    {obras.map((obra) => (
                      <option key={obra.id_obra} value={obra.id_obra}>{obra.nombre}</option>
                    ))}
                  </select>
                </div>
              ) : (
                <div className="col">
                  <label className="form-label">Obra</label>
                  <select className="form-select" name="obra_add">
                    <option value="">Cliente sin obras asociadas</option>
                  </select>
                </div>
              )}
            </div>
            <div className="row row-cols-md-2 mb-3">
              {requerimientos ? (
                <div className="col-md-6">
                  <label className="form-label">Requerimiento</label>
                  <select className="form-select" name="requerimiento_add" value={formCotizacionData.requerimiento_add} onChange={handleFormCotizacionData}>
                    <option value="">Seleccione un requerimiento</option>
                    {requerimientos.map((requerimiento) => (
                      <option key={requerimiento.id_requerimiento} value={requerimiento.id_requerimiento}>{requerimiento.nombre_requerimiento}</option>
                    ))}
                  </select>
                </div>
              ) : (
                <div className="col-md-6">
                  <label className="form-label">Requerimiento</label>
                  <select className="form-select" name="requerimiento_add">
                    <option value="">No se encontraron requerimientos</option>
                  </select>
                </div>
              )}
              {clientes ? (
                <div className="col">
                  <label className="form-label">Cliente Final</label>
                  <Select
                    name="cliente_final_add"
                    value={clienteSelected.value}
                    onChange={handleClienteFinalSelect}
                    options={optionsClientes}
                    isSearchable
                    className="react-select"
                    placeholder="Seleccione un cliente final"
                  />
                </div>
              ) : (
                <div className="col">
                  <label className="form-label">Cliente Final</label>
                  <select className="form-select" name="cliente_add">
                    <option value="">No se encontraron clientes</option>
                  </select>
                </div>
              )}
            </div>
            <div className="row row-cols-md-2 mb-4">
              <div className="col">
                <label className="form-label">Maquinaria</label>
                <select className="form-select" name="id_maquinaria" value={maquinariaFiltro} onChange={handleFiltroMaquinariaData}>
                  <option value="">Seleccione una maquinaria</option>
                  {maquinaria.map((maquinaria) => (
                    <option key={maquinaria.id_maquinaria} value={maquinaria.id_maquinaria}>{maquinaria.maquinaria}</option>
                  ))}
                </select>
              </div>
              <div className="col">
                <label className="form-label">Equipo</label>
                <select className="form-select" name="equipo_add" value={formCotizacionData.equipo_add} onChange={handleFormCotizacionData}>
                  <option value="">Seleccione un equipo</option>
                  {equipos.map((equipo, index) => (
                    <option key={index} value={equipo.id_equipo}>{equipo.marca + " " + equipo.modelo}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="mb-4">
              <div className="d-flex align-items-end justify-content-between mb-3">
                <h5 className="mb-0">Servicios</h5>
                <div className="d-flex flex-md-row gap-md-2">
                  <div className="input-group input-group-sm">
                    <span className="input-group-text" id="search-servicios">
                      <i className="bi bi-search"></i>
                    </span>
                    <input type="text" className="form-control" placeholder="Servicio..." aria-describedby="search-servicios" onChange={manejarCambioFiltro} />
                  </div>
                </div>
              </div>
              <div className="table-responsive border rounded">
                <table className="table table-sm table-hover mb-0">
                  <thead>
                    <tr className="table-active border-bottom">
                      <th className="ps-2"></th>
                      <th>Item</th>
                      <th>Nombre Servicio</th>
                      <th>Cantidad Mínima</th>
                      <th>Unidad Medida</th>
                      <th>Valor Unitario Neto + IVA</th>
                      {maquinariaFiltro === "1" && (
                        <th>Valor Unitario Neto PM</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {serviciosFiltrados.length > 0 ? (
                      serviciosFiltrados.map((servicio, index) => (
                        <tr key={index}>
                          <td className="ps-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={checkboxStates[index] || false}
                                onChange={() => toggleCheckbox(index, servicio)}
                              />
                            </div>
                          </td>
                          <td>
                            {servicio.item_orden.split('-')[1]}
                          </td>
                          <td>
                            {
                              servicio.glosa_servicio !== null && servicio.glosa_servicio !== '' ? (
                                servicio.glosa_servicio
                              ) : (
                                servicio.id_maquinaria !== 1 && servicio.id_maquinaria !== 2 && servicio.id_tipo_maquinaria === 0 ? (
                                  servicio.nombre_maquinaria + " - " + servicio.tipo_arriendo
                                ) : (
                                  servicio.nombre_maquinaria + (servicio.tipo_maquinaria === "" ? " - " + servicio.tipo_arriendo : " - " + servicio.tipo_maquinaria + " - " + servicio.tipo_arriendo)
                                )
                              )
                            }
                          </td>
                          <td>
                            <input
                              className="form-control form-control-sm w-auto"
                              id={"cantidad_minima_" + servicio.id_servicio}
                              name={"cantidad_minima_" + servicio.id_servicio}
                              type="text"
                              value={
                                dataServiciosCotizacion[servicio.id_servicio]?.["cantidad_minima_" + servicio.id_servicio] !== undefined
                                  ? dataServiciosCotizacion[servicio.id_servicio]?.["cantidad_minima_" + servicio.id_servicio]
                                  : Math.trunc(servicio.cantidad_minima)
                              }
                              onChange={(e) => handleServiciosCotizacionChange(e, servicio)}
                              disabled={!checkboxStates[index]}
                            />
                          </td>
                          <td>
                            {servicio.unidad_medida}
                          </td>
                          <td>
                            <input
                              className="form-control form-control-sm w-auto"
                              id={"valor_unitario_neto_" + servicio.id_servicio}
                              name={"valor_unitario_neto_" + servicio.id_servicio}
                              type="text"
                              value={
                                formCotizacionData.maquinaria_add === "1" ? (
                                  dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_" + servicio.id_servicio] !== undefined
                                    ? dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_" + servicio.id_servicio]
                                    : servicio.valor_unitario_neto
                                ) : formCotizacionData.maquinaria_add === "2" ? (
                                  dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_" + servicio.id_servicio] !== undefined
                                    ? dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_" + servicio.id_servicio]
                                    : parseInt(servicio.valor_unitario_neto)
                                ) : (
                                  dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_" + servicio.id_servicio] !== undefined
                                    ? dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_" + servicio.id_servicio]
                                    : parseFloat(servicio.valor_unitario_neto).toFixed(2)
                                )
                              }
                              onChange={(e) => handleServiciosCotizacionChange(e, servicio)}
                              disabled={!checkboxStates[index]}
                            />
                          </td>
                          {servicio.id_maquinaria === 1 && servicio.id_tipo_maquinaria != 0 && (servicio.id_unidad_medida === 1 || servicio.id_unidad_medida === 7) ? (
                            <td>
                              <input
                                className="form-control form-control-sm w-auto"
                                id={"valor_unitario_neto_pm_" + servicio.id_servicio}
                                name={"valor_unitario_neto_pm_" + servicio.id_servicio}
                                type="text"
                                value={
                                  dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_pm_" + servicio.id_servicio] !== undefined
                                    ? dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_pm_" + servicio.id_servicio]
                                    : servicio.valor_unitario_neto_pm
                                }
                                onChange={(e) => handleServiciosCotizacionChange(e, servicio)}
                                disabled={!checkboxStates[index]}
                              />
                            </td>
                          ) : servicio.id_maquinaria != 1 ? (
                            null
                          ) : (
                            <td>
                              <input
                                className="form-control form-control-sm w-auto"
                                id={"valor_unitario_neto_pm_" + servicio.id_servicio}
                                name={"valor_unitario_neto_pm_" + servicio.id_servicio}
                                type="text"
                                value={0}
                                hidden
                                readOnly
                              />
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">No se encontraron servicios</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <h5 className="mb-3">Información de Solicitante</h5>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
              <div className="col">
                <label className="form-label">Nombre</label>
                <input
                  className="form-control"
                  name="nombre_solicitante_add"
                  type="text"
                  value={formCotizacionData.nombre_solicitante_add}
                  onChange={handleFormCotizacionData}
                />
              </div>
              <div className="col">
                <label className="form-label">Rut</label>
                <input
                  className="form-control"
                  name="rut_solicitante_add"
                  type="text"
                  value={formCotizacionData.rut_solicitante_add}
                  onChange={handleFormCotizacionData}
                />
              </div>
            </div>
            <div className="row row-cols-2 g-4 mb-4">
              <div className="col">
                <label className="form-label">E-Mail</label>
                <input
                  className="form-control"
                  name="email_solicitante_add"
                  type="text"
                  value={formCotizacionData.email_solicitante_add}
                  onChange={handleFormCotizacionData}
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <label className="form-label">Observaciones</label>
                <textarea
                  className="form-control"
                  name="observaciones_add"
                  value={formCotizacionData.observaciones_add}
                  rows={5}
                  onChange={handleFormCotizacionData}
                ></textarea>
              </div>
            </div>
            <h5 className="mb-3">Detalle</h5>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
              <div className="col">
                <label className="form-label">Fecha Estimada Inicio</label>
                <input
                  className="form-control"
                  name="fecha_estimada_inicio_add"
                  type="date"
                  value={formCotizacionData.fecha_estimada_inicio_add}
                  onChange={handleFormCotizacionData}
                />
              </div>
              <div className="col">
                <label className="form-label">Fecha Estimada Fin</label>
                <input
                  className="form-control"
                  name="fecha_estimada_fin_add"
                  type="date"
                  value={formCotizacionData.fecha_estimada_fin_add}
                  onChange={handleFormCotizacionData}
                />
              </div>
            </div>
            <div className="row row-cols-1">
              <div className="col">
                <label className="form-label" htmlFor="formFile">Documento PDF</label>
                <input
                  className="form-control"
                  name="imagen"
                  type="file"
                  id="formFile"
                  accept=".pdf"
                  onChange={(e) =>
                    handleFileChange(e.target.files[0])
                  }
                />
              </div>
            </div>
          </div>
          <div className="modal-footer gap-2">
            <a className="btn btn-outline-dark mNegativo" href="${config.apiBaseUrl}/ANEXO.pdf" target="_blank"><i className="bi bi-file-earmark-text"></i> Ver Anexo</a>
            <button className="btn btn-yellow" onClick={(e) => handleConfirmaCotizacion(e, formCotizacionData.folio, formCotizacionData.email_solicitante_add)}><i className="bi bi-check-circle"></i> Confirmar</button>
          </div>
        </div>
      </div>
    );
  }

  function EditarCotizacionModalContent({ datos, cabecera, servicios }) {
    const fechaInicioBD = cabecera[0].fecha_inicio;
    const fechaInicio = format(parse(fechaInicioBD, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd');
    const fechaFinBD = cabecera[0].fecha_fin;
    const fechaFin = format(parse(fechaFinBD, 'dd-MM-yyyy', new Date()), 'yyyy-MM-dd');

    const [serviciosData, setServiciosData] = useState([]);
    const [filtroServiciosCotizacion, setFiltroServiciosCotizacion] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
      obtenerServicios(cabecera[0].id_maquinaria);
    }, []);

    const obtenerServicios = async (idMaquinaria) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/servicio.php?id_maquinaria=${idMaquinaria}`
        );
        const data = await response.json();

        if (data && data[0].id_servicio) {
          const idsEnPrimerArreglo = new Set(servicios.map(item => item.id_servicio));
          const nuevosServicios = data.filter(item => !idsEnPrimerArreglo.has(item.id_servicio));

          setServiciosData(nuevosServicios);
        }
      } catch (error) {
        setServiciosData([]);
      }
    };

    const [formCotizacionEditData, setFormCotizacionEditData] = useState({
      folio: datos.folio,
      nombre_solicitante_edit: cabecera[0].nombre_solicitante || "",
      observaciones_edit: cabecera[0].observaciones || "",
      rut_solicitante_edit: cabecera[0].rut_solicitante || "",
      email_solicitante_edit: cabecera[0].email_solicitante || "",
      fecha_estimada_inicio_edit: fechaInicio || "",
      fecha_estimada_fin_edit: fechaFin || "",
      id_usuario_actualizacion: dataLogin.id_usuario
    });

    const handleFormCotizacionEditData = (e) => {
      setFormCotizacionEditData({
        ...formCotizacionEditData,
        [e.target.name]: e.target.value,
      });
    };

    const [dataServiciosCotizacion, setServiciosCotizacionData] = useState({});
    const handleFormCotizacionServiciosData = (e, id_servicio, id_unidad_medida) => {
      const { name, value } = e.target;
      const inputFolioNombre = "folio_edit_" + id_servicio;
      const inputUnidadMedidaNombre = "id_unidad_medida_edit_" + id_servicio;

      setServiciosCotizacionData(prevData => ({
        ...prevData,
        [id_servicio]: {
          ...prevData[id_servicio],
          [inputFolioNombre]: datos.folio,
          [name]: value,
          [inputUnidadMedidaNombre]: id_unidad_medida
        }
      }));
    };

    const [dataServiciosNuevosCotizacion, setServiciosNuevosCotizacionData] = useState({});
    const handleFormCotizacionServiciosNuevosData = (e, id_servicio, id_unidad_medida) => {
      const { name, value } = e.target;
      const inputFolioNombre = "folio_edit_" + id_servicio;
      const inputUnidadMedidaNombre = "id_unidad_medida_edit_" + id_servicio;

      setServiciosNuevosCotizacionData(prevData => ({
        ...prevData,
        [id_servicio]: {
          ...prevData[id_servicio],
          [inputFolioNombre]: datos.folio,
          [name]: value,
          [inputUnidadMedidaNombre]: id_unidad_medida
        }
      }));
    };

    const [checkboxStates, setCheckboxStates] = useState({});
    const toggleCheckbox = (filaId, id_servicio, id_unidad_medida) => {
      setCheckboxStates((prevState) => ({
        ...prevState,
        [filaId]: !prevState[filaId],
      }));

      //Valores iniciales de cantidad minima y valor unitario neto
      const inputFolioNombre = "folio_edit_" + id_servicio;
      const inputUnidadMedidaNombre = "id_unidad_medida_edit_" + id_servicio;
      const inputCantidadMinimaNombre = "cantidad_minima_edit_" + id_servicio;
      const inputCantidadMinima = document.getElementById(inputCantidadMinimaNombre);
      const inputValorUnitarioNombre = "valor_unitario_neto_edit_" + id_servicio;
      const inputValorUnitario = document.getElementById(inputValorUnitarioNombre);
      const inputValorUnitarioPMNombre = "valor_unitario_neto_pm_edit_" + id_servicio;
      const inputValorUnitarioPM = document.getElementById(inputValorUnitarioPMNombre);
      const idUsuario = "id_usuario_" + id_servicio;

      // Comprobar si el atributo "disabled" está presente
      if (inputCantidadMinima && inputCantidadMinima.disabled) {
        //Agrega valores iniciales si el input se habilita
        setServiciosNuevosCotizacionData(prevData => ({
          ...prevData,
          [id_servicio]: {
            ...prevData[id_servicio],
            [inputFolioNombre]: datos.folio,
            [inputCantidadMinima.name]: inputCantidadMinima.value,
            [inputValorUnitario.name]: inputValorUnitario.value,
            [inputValorUnitarioPM.name]: inputValorUnitarioPM.value,
            [inputUnidadMedidaNombre]: id_unidad_medida,
            [idUsuario]: dataLogin.id_usuario
          }
        }));
      } else {
        //Elimina valores si el input se deshabilita
        const newData = { ...dataServiciosCotizacion };
        delete newData[id_servicio];
        setServiciosNuevosCotizacionData(newData);
      }
    };

    let serviciosAsignados;

    if (servicios && servicios.length > 0) {
      serviciosAsignados = servicios.map(servicio => ({
        folio: servicio.folio,
        id_servicio: servicio.id_servicio,
        descripcion: servicio.descripcion,
        id_maquinaria: servicio.id_maquinaria,
        nombre_maquinaria: servicio.nombre_maquinaria,
        id_tipo_maquinaria: servicio.id_tipo_maquinaria,
        tipo_maquinaria: servicio.tipo_maquinaria,
        tipo_arriendo: servicio.tipo_arriendo,
        cantidad_minima: servicio.cantidad_minima,
        id_unidad_medida: servicio.id_unidad_medida,
        unidad_medida: servicio.unidad_medida,
        valor_unitario_neto: servicio.valor_unitario_neto,
        valor_unitario_neto_pm: servicio.valor_unitario_neto_pm
      }));
    } else {
      serviciosAsignados = []; // Definir serviciosAsignados como un arreglo vacío
    }

    useEffect(() => {
      serviciosAsignados.forEach(servicio => {
        const {
          id_servicio,
          folio,
          cantidad_minima,
          valor_unitario_neto,
          valor_unitario_neto_pm,
          id_unidad_medida
        } = servicio;

        const inputFolioNombre = "folio_edit_" + id_servicio;
        const inputUnidadMedidaNombre = "id_unidad_medida_edit_" + id_servicio;
        const inputCantidadMinimaNombre = "cantidad_minima_edit_" + id_servicio;
        const inputValorUnitarioNombre = "valor_unitario_neto_edit_" + id_servicio;
        const inputValorUnitarioPMNombre = "valor_unitario_neto_pm_edit_" + id_servicio;

        setServiciosCotizacionData(prevData => ({
          ...prevData,
          [id_servicio]: {
            ...prevData[id_servicio],
            [inputFolioNombre]: folio,
            [inputCantidadMinimaNombre]: cantidad_minima,
            [inputValorUnitarioNombre]: valor_unitario_neto,
            [inputValorUnitarioPMNombre]: valor_unitario_neto_pm,
            [inputUnidadMedidaNombre]: id_unidad_medida
          }
        }));
      });
    }, []);

    const serviciosFiltrados = serviciosData.filter((item) =>
      item.glosa_servicio.toLowerCase().includes(filtroServiciosCotizacion.toLowerCase())
    );

    const modificaLlavesServiCot = (objetoOriginal) => {
      const nuevoObjeto = {};

      Object.keys(objetoOriginal).forEach((clave) => {
        const nuevoNombreFolio = `folio`;
        const nuevoNombreCantidad = `cantidad_minima`;
        const nuevoNombreUnidadMedida = `id_unidad_medida`;
        const nuevoNombreValor = `valor_unitario_neto`;
        const nuevoNombreValorPM = `valor_unitario_neto_pm`;
        const nuevoNombreIdUsuario = `id_usuario`;

        nuevoObjeto[clave] = {
          [nuevoNombreFolio]: objetoOriginal[clave][`folio_edit_${clave}`],
          [nuevoNombreCantidad]: objetoOriginal[clave][`cantidad_minima_edit_${clave}`],
          [nuevoNombreUnidadMedida]: objetoOriginal[clave][`id_unidad_medida_edit_${clave}`],
          [nuevoNombreValor]: objetoOriginal[clave][`valor_unitario_neto_edit_${clave}`],
          [nuevoNombreValorPM]: objetoOriginal[clave][`valor_unitario_neto_pm_edit_${clave}`],
          [nuevoNombreIdUsuario]: objetoOriginal[clave][`id_usuario_${clave}`],
          ["id_usuario_actualizacion"]: dataLogin.id_usuario
        };
      });

      return nuevoObjeto;
    };

    const handleSubmitEditCotizacion = async (event) => {
      event.preventDefault();

      try {
        const esFormularioValido = validaFormulario();

        if (esFormularioValido) {
          const esRutValido = validarRut(formCotizacionEditData.rut_solicitante_edit);
          const esEmailValido = validarEmail(formCotizacionEditData.email_solicitante_edit);

          if (!esRutValido) {
            alert("Rut No Válido");
          } else if (!esEmailValido) {
            alert("Email No Válido");
          } else {
            const responseEditCabeceraCotizacion = await fetch(
              `${config.apiBaseUrl}/cabecera_cotizacion.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formCotizacionEditData),
              }
            );

            const dataEditCabeceraCotizacion = await responseEditCabeceraCotizacion.json();
            //console.log(JSON.stringify(dataEditCabeceraCotizacion,null,2))
            if (dataEditCabeceraCotizacion.message === "Cabecera de cotización modificada con éxito.") {
              const objetoTransformado = modificaLlavesServiCot(dataServiciosCotizacion);
              const responseServiciosCotizacion = await fetch(
                `${config.apiBaseUrl}/detalle_cotizacion.php`,
                {
                  method: "PUT",
                  headers: {
                    'Accept': 'application/json', // Indica que esperas una respuesta JSON
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(objetoTransformado),
                }
              );

              const dataEditServiciosCotizacion = await responseServiciosCotizacion.json();
              if (dataEditServiciosCotizacion.message === "Servicios de cotización modificados con éxito.") {
                const objetoTransformadoNuevo = modificaLlavesServiCot(dataServiciosNuevosCotizacion);
                console.info(objetoTransformadoNuevo.length)
                console.info(serviciosAsignados.length)
                let numNuevos = objetoTransformadoNuevo.length || 0
                if (numNuevos + serviciosAsignados.length < 31) {

                  const responseServiciosNuevosCotizacion = await fetch(
                    `${config.apiBaseUrl}/detalle_cotizacion.php`,
                    {
                      method: "POST",
                      headers: {
                        'Accept': 'application/json', // Indica que esperas una respuesta JSON
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(objetoTransformadoNuevo),
                    }
                  );

                  const dataEditServiciosNuevosCotizacion = await responseServiciosNuevosCotizacion.json();
                  if (dataEditServiciosNuevosCotizacion.message === "Detalle de cotización agregado con éxito.") {
                    setFormCotizacionEditData({
                      folio: "",
                      nombre_solicitante_edit: "",
                      rut_solicitante_edit: "",
                      email_solicitante_edit: "",
                      fecha_estimada_inicio_edit: "",
                      fecha_estimada_fin_edit: "",
                      id_usuario_actualizacion: ""
                    });

                    obtenerCotizaciones();

                    alert("Cotización modificada con éxito.");

                    closeModal();

                    navigate("/dashboard", { state: dataLogin });
                  }
                } else {
                  alert('Se permiten hasta 30 items por cotización');
                  return false;
                }
              }
            } else {
              throw new Error();
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    const validaFormulario = () => {
      if (formCotizacionEditData.nombre_solicitante_edit === "") {
        alert('Debe ingresar un nombre de solicitante');
        return false;
      }

      if (formCotizacionEditData.rut_solicitante_edit === "") {
        alert('Debe ingresar un rut de solicitante');
        return false;
      }

      if (formCotizacionEditData.email_solicitante_edit === "") {
        alert('Debe ingresar un email de solicitante');
        return false;
      }

      if (formCotizacionEditData.fecha_estimada_inicio_edit === "") {
        alert('Debe ingresar una fecha estimada de inicio');
        return false;
      }

      return true;
    }

    //Filtro Servicios Cotización    
    const manejarCambioFiltro = (event) => {
      setFiltroServiciosCotizacion(event.target.value);
    };

    const validarRut = (rut) => {
      return validate(rut);
    }

    const validarEmail = (email) => {
      // Expresión regular para validar el formato del correo electrónico
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Editar Cotización{/* ({cabecera.nombre_maquinaria}) */}: {datos.folio || ""} ({datos.fecha_cotizacion || ""})</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body py-3 px-5">
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
              <div className="col">
                <span className="form-label d-block mb-1">Cliente</span>
                <select className="form-select" disabled>
                  <option value={cabecera[0].id_cliente}>{datos.nombre_cliente || ""}</option>
                </select>
              </div>
              <div className="col">
                <span className="form-label d-block mb-1">Obra</span>
                <select className="form-select" disabled>
                  <option value={cabecera[0].id_obra}>{datos.obra || ""}</option>
                </select>
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-4">
              <div className="col">
                <span className="form-label d-block mb-1">Requerimiento</span>
                <select className="form-select" disabled>
                  <option value={cabecera[0].id_requerimiento}>{cabecera[0].nombre_requerimiento || ""}</option>
                </select>
              </div>
              <div className="col">
                <span className="form-label d-block mb-1">Cliente Final</span>
                <select className="form-select" disabled>
                  <option value={cabecera[0].id_cliente_final}>{cabecera[0].nombre_cliente_final || ""}</option>
                </select>
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-4">
              <div className="col">
                <span className="form-label d-block mb-1">Maquinaria</span>
                <select className="form-select" disabled>
                  <option value={cabecera[0].id_maquinaria}>{cabecera[0].nombre_maquinaria || ""}</option>
                </select>
              </div>
              <div className="col">
                <span className="form-label d-block mb-1">Equipo</span>
                <select className="form-select" disabled>
                  <option value={cabecera[0].id_equipo}>{cabecera[0].equipo || ""}</option>
                </select>
              </div>
            </div>
            <div className="d-flex align-items-end justify-content-between mb-3">
              <h5 className="mb-0">Servicios</h5>
              <div className="input-group input-group-sm" style={{ maxWidth: '210px' }}>
                <span className="input-group-text" id="search-servicios">
                  <i className="bi bi-search"></i>
                </span>
                <input type="text" className="form-control" placeholder="Servicio..." aria-describedby="search-servicios" onChange={manejarCambioFiltro} />
              </div>
            </div>
            <div className="table-responsive border rounded mb-4">
              <table className="table table-hover table-sm mb-0">
                <thead>
                  <tr className="table-active border-bottom">
                    <th className="ps-2"></th>
                    <th>Nombre Servicio</th>
                    <th>Cantidad Mínima</th>
                    <th>Unidad Medida</th>
                    <th>Valor Unitario Neto + IVA</th>
                    {cabecera[0].id_maquinaria === 1 && (
                      <th scope="col" className="pe-3">Valor Unitario Neto PM</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {serviciosAsignados.length > 0 ? (
                    serviciosAsignados.map((servicio, index) => (
                      <tr key={servicio.id_servicio}>
                        <td className="ps-2"></td>
                        <td>
                          {
                            servicio.descripcion !== null && servicio.descripcion !== '' ? (
                              servicio.descripcion
                            ) : (
                              servicio.id_maquinaria !== 1 && servicio.id_maquinaria !== 2 && servicio.id_tipo_maquinaria === 0 ? (
                                servicio.nombre_maquinaria + " - " + servicio.tipo_arriendo
                              ) : (
                                servicio.nombre_maquinaria + (servicio.tipo_maquinaria === "" ? " - " + servicio.tipo_arriendo : " - " + servicio.tipo_maquinaria + " - " + servicio.tipo_arriendo)
                              )
                            )
                          }
                        </td>
                        <td>
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            name={"cantidad_minima_edit_" + servicio.id_servicio}
                            id={"cantidad_minima_edit_" + servicio.id_servicio}
                            value={
                              dataServiciosCotizacion[servicio.id_servicio]?.["cantidad_minima_edit_" + servicio.id_servicio] !== undefined
                                ? dataServiciosCotizacion[servicio.id_servicio]?.["cantidad_minima_edit_" + servicio.id_servicio]
                                : Math.trunc(servicio.cantidad_minima)
                            }
                            onChange={(e) => handleFormCotizacionServiciosData(e, servicio.id_servicio.toString(), servicio.id_unidad_medida.toString())}
                          />
                        </td>
                        <td>
                          {servicio.unidad_medida}
                        </td>
                        <td>
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            name={"valor_unitario_neto_edit_" + servicio.id_servicio}
                            id={"valor_unitario_neto_edit_" + servicio.id_servicio}
                            value={
                              dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_edit_" + servicio.id_servicio] !== undefined
                                ? dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_edit_" + servicio.id_servicio]
                                : servicio.valor_unitario_neto
                            }
                            onChange={(e) => handleFormCotizacionServiciosData(e, servicio.id_servicio.toString(), servicio.id_unidad_medida.toString())}
                          />
                        </td>
                        {servicio.id_maquinaria === 1 && servicio.id_tipo_maquinaria != null && (servicio.id_unidad_medida === 1 || servicio.id_unidad_medida === 7) ? (
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              name={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                              id={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                              value={
                                dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_pm_edit_" + servicio.id_servicio] !== undefined
                                  ? dataServiciosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_pm_edit_" + servicio.id_servicio]
                                  : servicio.valor_unitario_neto_pm
                              }
                              onChange={(e) => handleFormCotizacionServiciosData(e, servicio.id_servicio.toString(), servicio.id_unidad_medida.toString())}
                            />
                          </td>
                        ) : servicio.id_maquinaria != 1 ? (
                          null
                        ) : (
                          <td>
                            <input
                              className="form-control form-control-sm"
                              id={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                              name={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                              type="text"
                              value={0}
                              hidden
                              readOnly
                            />
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-0 border-bottom-0" colSpan={5}></td>
                    </tr>
                  )}
                  {serviciosFiltrados.map((servicio, index) => (
                    <tr key={servicio.id_servicio}>
                      <td className="ps-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checkboxStates[index] || false}
                            onChange={() => toggleCheckbox(index, servicio.id_servicio, servicio.id_unidad_medida.toString())}
                          />
                        </div>
                      </td>
                      <td>
                        {
                          servicio.glosa_servicio !== null && servicio.glosa_servicio !== '' ? (
                            servicio.glosa_servicio
                          ) : (
                            servicio.nombre_maquinaria + " - " + servicio.tipo_maquinaria + " - " + servicio.tipo_arriendo
                          )
                        }
                      </td>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          name={"cantidad_minima_edit_" + servicio.id_servicio}
                          id={"cantidad_minima_edit_" + servicio.id_servicio}
                          value={
                            dataServiciosNuevosCotizacion[servicio.id_servicio]?.["cantidad_minima_edit_" + servicio.id_servicio] !== undefined
                              ? dataServiciosNuevosCotizacion[servicio.id_servicio]?.["cantidad_minima_edit_" + servicio.id_servicio]
                              : Math.trunc(servicio.cantidad_minima)
                          }
                          onChange={(e) => handleFormCotizacionServiciosNuevosData(e, servicio.id_servicio.toString(), servicio.id_unidad_medida.toString())}
                          disabled={!checkboxStates[index]}
                        />
                      </td>
                      <td>
                        {servicio.unidad_medida}
                      </td>
                      <td>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          name={"valor_unitario_neto_edit_" + servicio.id_servicio}
                          id={"valor_unitario_neto_edit_" + servicio.id_servicio}
                          value={
                            dataServiciosNuevosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_edit_" + servicio.id_servicio] !== undefined
                              ? dataServiciosNuevosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_edit_" + servicio.id_servicio]
                              : servicio.valor_unitario_neto
                          }
                          onChange={(e) => handleFormCotizacionServiciosNuevosData(e, servicio.id_servicio.toString(), servicio.id_unidad_medida.toString())}
                          disabled={!checkboxStates[index]}
                        />
                      </td>
                      {servicio.id_maquinaria === 1 && servicio.id_tipo_maquinaria != null && servicio.id_unidad_medida === 1 ? (
                        <td>
                          <input
                            className="form-control form-control-sm"
                            id={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                            name={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                            type="text"
                            value={
                              dataServiciosNuevosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_pm_edit_" + servicio.id_servicio] !== undefined
                                ? dataServiciosNuevosCotizacion[servicio.id_servicio]?.["valor_unitario_neto_pm_edit_" + servicio.id_servicio]
                                : servicio.valor_unitario_neto_pm
                            }
                            onChange={(e) => handleFormCotizacionServiciosNuevosData(e, servicio.id_servicio.toString(), servicio.id_unidad_medida.toString())}
                            disabled={!checkboxStates[index]}
                          />
                        </td>
                      ) : (
                        <td>
                          <input
                            className="form-control form-control-sm"
                            id={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                            name={"valor_unitario_neto_pm_edit_" + servicio.id_servicio}
                            type="text"
                            value={0}
                            hidden
                            readOnly
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <h5 className="mb-3">Información de Solicitante</h5>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
              <div className="col">
                <label className="form-label">Nombre</label>
                <input
                  className="form-control"
                  type="text"
                  name="nombre_solicitante_edit"
                  value={formCotizacionEditData.nombre_solicitante_edit}
                  onChange={handleFormCotizacionEditData}
                />
              </div>
              <div className="col">
                <label className="form-label">Rut</label>
                <input
                  className="form-control"
                  type="text"
                  name="rut_solicitante_edit"
                  value={formCotizacionEditData.rut_solicitante_edit}
                  onChange={handleFormCotizacionEditData}
                />
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-4">
              <div className="col">
                <label className="form-label">E-Mail</label>
                <input
                  className="form-control"
                  type="text"
                  name="email_solicitante_edit"
                  value={formCotizacionEditData.email_solicitante_edit}
                  onChange={handleFormCotizacionEditData}
                />
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <label className="form-label">Observaciones</label>
                <textarea
                  className="form-control"
                  type="text"
                  name="observaciones_edit"
                  rows={5}
                  value={formCotizacionEditData.observaciones_edit}
                  onChange={handleFormCotizacionEditData}
                ></textarea>
              </div>
            </div>
            <h5 className="mb-3">Detalle</h5>
            <div className="row row-cols-1 row-cols-md-2 g-4 mb-3">
              <div className="col">
                <label className="form-label">Fecha Estimada Inicio</label>
                <input
                  className="form-control"
                  type="date"
                  name="fecha_estimada_inicio_edit"
                  value={formCotizacionEditData.fecha_estimada_inicio_edit}
                  onChange={handleFormCotizacionEditData}
                />
              </div>
              <div className="col">
                <label className="form-label">Fecha Estimada Fin</label>
                <input
                  className="form-control"
                  type="date"
                  name="fecha_estimada_fin_edit"
                  value={formCotizacionEditData.fecha_estimada_fin_edit}
                  onChange={handleFormCotizacionEditData}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer flex-row">
            <button className="btn btn-yellow" onClick={handleSubmitEditCotizacion}><i className="bi bi-floppy"></i> Guardar</button>
          </div>
        </div>
      </div>
    );
  }

  function CotizacionModalContent({ data }) {
    const [estadosCotizacion, setEstadosCotizacion] = useState([]);
    const [estadoCotizacion, setEstadoCotizacion] = useState(data.id_estado_cotizacion);
    const [cabeceraCotizacion, setCabeceraCotizacion] = useState([]);
    const [detalleCotizacion, setdetalleCotizacion] = useState([]);

    useEffect(() => {
      obtenerEstadosCotizacion();
      obtenerCabeceraCotizacion(data.folio);
      obtenerDetalleCotizacion(data.folio);
    }, []);

    const obtenerEstadosCotizacion = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_cotizacion.php`
        );
        const data = await response.json();

        if (data && data[0].id_estado_cotizacion) {
          setEstadosCotizacion(data);
        }
      } catch (error) {
        setEstadosCotizacion([]);
      }
    };

    const obtenerCabeceraCotizacion = async (folio) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cabecera_cotizacion.php?folio=${folio}`
        );
        const data = await response.json();

        if (data && data[0].folio) {
          setCabeceraCotizacion(data);
        }
      } catch (error) {
        setCabeceraCotizacion([]);
      }
    };

    const obtenerDetalleCotizacion = async (folio) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/detalle_cotizacion.php?folio=${folio}`
        );
        const data = await response.json();

        if (data && data[0].folio) {
          setdetalleCotizacion(data);
        }
      } catch (error) {
        setdetalleCotizacion([]);
      }
    };

    const [pdfBytes, setPdfBytes] = useState(null);
    const crearDescargarPDFCotizacion = async () => {
      const existingPdfBytes = await fetch(`${config.apiBaseUrl}/obtienePlantillaCotizacion.php`).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      // Obtener el formulario del PDF
      const form = pdfDoc.getForm();


      // Cabecera Cotización
      form.getTextField('Folio').setText(data.folio);
      form.getTextField('Cotizador').setText(cabeceraCotizacion[0].cotizador);
      form.getTextField('Nombre_Cliente').setText(data.nombre_cliente);
      form.getTextField('Rut_Cliente').setText(formatearRut(data.rut_cliente));
      form.getTextField('Razon_Social').setText(cabeceraCotizacion[0].razon_social);
      form.getTextField('Giro_Cliente').setText(cabeceraCotizacion[0].giro);
      form.getTextField('Direccion_Cliente').setText(cabeceraCotizacion[0].direccion);
      form.getTextField('Obra_Cliente').setText(data.obra);
      form.getTextField('Direccion_Obra').setText(cabeceraCotizacion[0].direccion_obra);

      form.getTextField('Fecha_Cotizacion').setText(data.fecha_cotizacion);
      form.getTextField('Contacto').setText(cabeceraCotizacion[0].nombre_contacto);
      form.getTextField('Cargo_Contacto').setText(cabeceraCotizacion[0].cargo_contacto);
      form.getTextField('Telefono_Contacto').setText(cabeceraCotizacion[0].telefono_contacto);
      form.getTextField('Email_Contacto').setText(cabeceraCotizacion[0].email_contacto);
      form.getTextField('Observaciones').setText(cabeceraCotizacion[0].observaciones ? cabeceraCotizacion[0].observaciones : "");

      if (cabeceraCotizacion[0].id_maquinaria === 1) {
        form.getTextField('Equipo').setText(
          `${cabeceraCotizacion[0].nombre_maquinaria} (${cabeceraCotizacion[0].nombre_requerimiento})`
        );
      } else {
        form.getTextField('Equipo').setText(
          `${cabeceraCotizacion[0].nombre_maquinaria} - ${cabeceraCotizacion[0].equipo} (${cabeceraCotizacion[0].nombre_requerimiento})`
        );
      }

      let pmInserted = false;

      //const primerServicio = detalleCotizacion[0];
      // Servicios Cotización
      detalleCotizacion.forEach((detalle, index) => {
        form.getTextField(`Item_Orden_${index + 1}`).setText(detalle.item_orden.split('-')[1]);
        if (detalle.descripcion !== "") {
          form.getTextField(`Descripcion_${index + 1}`).setText(detalle.descripcion);
        } else {
          form.getTextField(`Descripcion_${index + 1}`).setText(detalle.nombre_maquinaria + " " + detalle.tipo_maquinaria + " " + detalle.tipo_arriendo);
        }
        form.getTextField(`Cantidad_Minima_${index + 1}`).setText(detalle.cantidad_minima);
        form.getTextField(`Unidad_Medida_${index + 1}`).setText(detalle.unidad_medida);

        if (detalle.id_maquinaria === 1) {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(detalle.valor_unitario_neto + " UF");
        } else if (detalle.id_maquinaria === 2) {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(String("$ " + parseInt(detalle.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')));
        } else {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(String(parseFloat(detalle.valor_unitario_neto).toFixed(2) + " UF"));
        }

        if (detalle.id_maquinaria === 1 && !pmInserted) {
          form.getTextField(`Valor_Unitario_Neto_PM_${index + 1}`).setText(detalle.valor_unitario_neto_pm + " UF (PM)");
          pmInserted = true;
        }
      });

      // Guardar el PDF modificado
      const modifiedPdfBytes = await pdfDoc.save();

      // Actualizar el estado para que React renderice el PDF modificado
      setPdfBytes(modifiedPdfBytes);

      guardarPDF(modifiedPdfBytes, data.folio);

      // Crear un objeto Blob con los bytes del PDF modificado
      const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });

      // Crear una URL para el Blob
      const urlBlob = URL.createObjectURL(blob);

      // Crear un enlace <a> para descargar el PDF
      const link = document.createElement('a');
      link.href = urlBlob;

      link.download = data.folio + '.pdf';

      // Agregar el enlace al documento
      document.body.appendChild(link);

      // Simular un clic en el enlace para iniciar la descarga
      link.click();

      // Eliminar el enlace después de la descarga
      document.body.removeChild(link);
    };

    const crearDescargarPDFAdjunto = async () => {
      function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64); // Decodificar la cadena base64
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
      }

      // Convertir el base64 a un ArrayBuffer
      const arrayBuffer = base64ToArrayBuffer(data.imagen);

      // Crear un objeto Blob con los bytes del PDF modificado
      const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

      // Crear una URL para el Blob
      const urlBlob = URL.createObjectURL(blob);

      // Crear un enlace <a> para descargar el PDF
      const link = document.createElement('a');
      link.href = urlBlob;

      link.download = data.folio + '_Adjunto.pdf';

      // Agregar el enlace al documento
      document.body.appendChild(link);

      // Simular un clic en el enlace para iniciar la descarga
      link.click();

      // Eliminar el enlace después de la descarga
      document.body.removeChild(link);
    };

    const guardarPDF = async (modifiedPdfBytes, folio) => {
      const formData = new FormData();
      formData.append('pdf', new Blob([modifiedPdfBytes], { type: 'application/pdf' }), folio);

      try {
        const response = await fetch(`${config.apiBaseUrl}/guardar_pdf.php`, {
          method: 'POST',
          body: formData,
        });

        if (response.ok) {
          const responseData = await response.text();
          //console.log('Respuesta del servidor:', responseData);
        } else {
          console.error('Error al enviar el PDF al servidor:', response.status);
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };

    const obtenerEstadosPago = async (folio, idMaquinaria) => {
      try {
        let response;
        switch (idMaquinaria) {
          case 1:
            response = await fetch(
              `${config.apiBaseUrl}/estado_pago_bh.php?folio_ep=${folio}&id_maquinaria${idMaquinaria}`
            );
            break;
          case 2:
            response = await fetch(
              `${config.apiBaseUrl}/estado_pago_gh.php?folio_ep=${folio}&id_maquinaria${idMaquinaria}`
            );
            break;
          case 3:
            response = await fetch(
              `${config.apiBaseUrl}/estado_pago_gt.php?folio_ep=${folio}&id_maquinaria${idMaquinaria}`
            );
            break;
          default:
            alert("Tipo de maquinaria no reconocido.");
            return;
        }

        const data = await response.json();

        if (data && data[0].folio) {
          return data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    }

    const handleModificaEstado = async (data_cotizacion, id_estado_cotizacion) => {
      setEstadoCotizacion(id_estado_cotizacion);

      if (id_estado_cotizacion === '7') {
        const estadosPago = await obtenerEstadosPago(data_cotizacion.folio, cabeceraCotizacion[0].id_maquinaria);
        const estadosPagofinalizados = estadosPago.every(estado_pago => estado_pago.id_estado_pago_estado === 3);

        if (estadosPago.length > 0 && estadosPagofinalizados) {
          setSecondModalOpen(true);
          setSecondModalContent(<ConfirmaModificaEstadoModalContent dataCotizacion={data_cotizacion} detalleCotizacion={detalleCotizacion} idEstadoCotizacion={id_estado_cotizacion} dataEstadosPago={estadosPago} idRequerimiento={cabeceraCotizacion[0].id_requerimiento} />);
        } else {
          alert('Para finalizar una cotización se deben finalizar sus estados de pago asociados.');
        }
      } else {
        setSecondModalOpen(true);
        setSecondModalContent(<ConfirmaModificaEstadoModalContent dataCotizacion={data_cotizacion} detalleCotizacion={detalleCotizacion} idEstadoCotizacion={id_estado_cotizacion} />);
      }
    };

    function ConfirmaModificaEstadoModalContent({ dataCotizacion, detalleCotizacion, idEstadoCotizacion, dataEstadosPago, idRequerimiento }) {
      const obtenerEstadoPorId = (idEstadoCotizacion) => {
        const estadoEncontrado = estadosCotizacion.find(estado => estado.id_estado_cotizacion === idEstadoCotizacion);
        return estadoEncontrado ? estadoEncontrado.estado : 'Estado no encontrado';
      };

      const estado = obtenerEstadoPorId(Number(idEstadoCotizacion));

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Modificar Estado: {dataCotizacion.folio}</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5">¿Está seguro que desea modificar el estado de la cotización a: <span className="text-green">{estado}</span>?</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-success" onClick={(e) => handleSubmitModificarEstado(e, dataCotizacion.folio, idEstadoCotizacion, idRequerimiento)}><i className="bi bi-dash-circle"></i> Modificar Estado</button>
            </div>
          </div>
        </div>
      );
    }

    const handleSubmitModificarEstado = async (event, folio, idEstadoCotizacion, idRequerimiento) => {
      event.preventDefault();

      try {
        const formModificarEstado = { folio: folio, id_estado_cotizacion: idEstadoCotizacion, id_usuario_actualizacion: dataLogin.id_usuario };

        const responseModificarEstado = await fetch(
          `${config.apiBaseUrl}/cabecera_cotizacion.php`,
          {
            method: "PUT",
            headers: {
              'Accept': 'application/json', // Indica que esperas una respuesta JSON
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formModificarEstado),
          }
        );

        const dataModificarEstado = await responseModificarEstado.json();
        //console.log(JSON.stringify(dataModificarEstado,null,2))
        if (dataModificarEstado.message === "Estado de cotización modificado con éxito.") {

          if (idEstadoCotizacion === '7') {
            const formFinalizarRequerimiento = {
              id_requerimiento: idRequerimiento,
              id_usuario_actualizacion: dataLogin.id_usuario
            };

            const responseFinalizarRequerimiento = await fetch(
              `${config.apiBaseUrl}/requerimiento.php?finaliza=1`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(formFinalizarRequerimiento),
              }
            );

            const dataFinalizarRequerimiento = await responseFinalizarRequerimiento.json();
            if (dataFinalizarRequerimiento.message === "Requerimiento finalizado con éxito.") {
              obtenerRequerimientos();
            }
          }

          alert("Estado de cotización modificado con éxito.");

          obtenerCotizaciones();

          closeSecondModal();
          closeModal();

          navigate("/dashboard", { state: dataLogin });
        } else {
          throw new Error();
        }
      } catch (error) {
        obtenerCotizaciones();
      }
    }

    /* Confirmación de reenvío de cotización */
    const handleConfirmaReenviaCotizacion = (e, folio, email) => {
      setSecondModalOpen(true);
      setSecondModalContent(<ConfirmaReenviaCotizacionModalContent folio={folio} email={email} />);
    };

    function ConfirmaReenviaCotizacionModalContent({ folio, email }) {
      const [filas, setFilas] = useState([]);

      useEffect(() => {
        obtenerEmailCC();
      }, []);

      const obtenerEmailCC = async () => {
        try {
          const response = await fetch(
            `${config.apiBaseUrl}/email_cc.php`
          );
          const data = await response.json();
          if (data && data[0].id_email_cc) {
            setFilas(data);
          }
        } catch (error) {
          setFilas([]);
        }
      };

      /* Agregar CC */
      const [mostrarTablaCC, setMostrarTablaCC] = useState(true);
      const [mostrarBotonCC, setMostrarBotonCC] = useState(true);

      const handleRadioChange = (event) => {
        setMostrarTablaCC(event.target.value === "1");

        setMostrarBotonCC(!mostrarBotonCC);

        setFilas([{
          "id_email_cc": 1,
          "email_cc": ""
        }]);
      }

      const handleAgregarFila = () => {
        let siguienteId = 1;

        while (filas.some(fila => fila.id_email_cc === siguienteId)) {
          siguienteId++;
        }

        const nuevaFila = {
          id_email_cc: siguienteId,
          email_cc: ''
        };

        setFilas([...filas, nuevaFila]);
      };

      const handleInputChange = (id, campo, valor) => {
        const nuevasFilas = filas.map((fila) =>
          fila.id_email_cc === id ? { ...fila, [campo]: valor } : fila
        );

        setFilas(nuevasFilas);
      };

      const handleEliminarFila = (id) => {
        // Verificar que haya más de una fila antes de eliminar
        if (filas.length > 1) {
          const nuevasFilas = filas.filter((fila) => fila.id_email_cc !== id);
          setFilas(nuevasFilas);
        } else {
          alert("Debe agregar al menos un email, de lo contrario seleccione 'NO'.");
        }
      };

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Reenviar Cotización</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5 mb-2">¿Está seguro que desea reenviar la cotización: <span className="text-orange">{folio}</span>?</p>
              <p>Se modificará su estado a "Enviada" y se enviará mediante correo electrónico a la dirección indicada: <br /><span className="text-orange">{email}.</span></p>
              <p>¿Requiere copiar cotización a otras direcciones de correo electrónico (CC)?</p>
              <div className="d-flex justify-content-md-between">
                <div>
                  <input
                    type="radio"
                    className="btn-check"
                    name="email_cc"
                    id="email-cc-si"
                    autoComplete="off"
                    value="1"
                    checked={mostrarTablaCC}
                    onChange={handleRadioChange}
                  />
                  <label className="btn" htmlFor="email-cc-si">Si</label>
                  <input
                    type="radio"
                    className="btn-check"
                    name="email_cc"
                    id="email-cc-no"
                    autoComplete="off"
                    value="0"
                    checked={!mostrarTablaCC}
                    onChange={handleRadioChange}
                  />
                  <label className="btn" htmlFor="email-cc-no">No</label>
                </div>
                {mostrarBotonCC && (
                  <button type="button" className="btn btn-dark btn-sm" onClick={handleAgregarFila}>
                    <i className="bi-plus-circle"></i> Agregar
                  </button>
                )}
              </div>
              {mostrarTablaCC && (
                <div className="mt-3">
                  <table className="table mb-0">
                    <thead>
                      <tr className="table-active">
                        <th>Email</th>
                        <th>Eliminar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filas.map((fila, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              id={"email_cc_" + index}
                              value={fila.email_cc}
                              onChange={(e) =>
                                handleInputChange(fila.id_email_cc, 'email_cc', e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id_email_cc)}>
                              <i className="bi bi-trash3"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-yellow" onClick={(e) => handleSubmitReenviaCotizacion(e, mostrarBotonCC, filas)} disabled={reenviarDisabled}>
                <i className="bi bi-send"></i> Reenviar
              </button>
            </div>
          </div>
        </div>
      );
    }

    const [pdfBytesReenviar, setPdfBytesReenviar] = useState(null);
    const crearReenviarPDFCotizacion = async () => {
      const existingPdfBytes = await fetch(`${config.apiBaseUrl}/obtienePlantillaCotizacion.php`).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      console.info(cabeceraCotizacion[0])
      // Obtener el formulario del PDF
      const form = pdfDoc.getForm();

      // Cabecera Cotización
      form.getTextField('Folio').setText(data.folio);
      form.getTextField('Cotizador').setText(cabeceraCotizacion[0].cotizador);
      form.getTextField('Nombre_Cliente').setText(data.nombre_cliente);
      form.getTextField('Rut_Cliente').setText(formatearRut(data.rut_cliente));
      form.getTextField('Razon_Social').setText(cabeceraCotizacion[0].razon_social);
      form.getTextField('Giro_Cliente').setText(cabeceraCotizacion[0].giro);
      form.getTextField('Direccion_Cliente').setText(cabeceraCotizacion[0].direccion);
      form.getTextField('Obra_Cliente').setText(data.obra);
      form.getTextField('Direccion_Obra').setText(cabeceraCotizacion[0].direccion_obra + " (" + cabeceraCotizacion[0].comuna_obra + ")");

      form.getTextField('Fecha_Cotizacion').setText(data.fecha_cotizacion);
      form.getTextField('Contacto').setText(cabeceraCotizacion[0].nombre_contacto);
      form.getTextField('Cargo_Contacto').setText(cabeceraCotizacion[0].cargo_contacto);
      form.getTextField('Telefono_Contacto').setText(cabeceraCotizacion[0].telefono_contacto);
      form.getTextField('Email_Contacto').setText(cabeceraCotizacion[0].email_contacto);
      form.getTextField('Observaciones').setText(cabeceraCotizacion[0].observaciones ? cabeceraCotizacion[0].observaciones : "");

      if (cabeceraCotizacion[0].id_maquinaria === 1) {
        form.getTextField('Equipo').setText(
          `${cabeceraCotizacion[0].nombre_maquinaria} (${cabeceraCotizacion[0].nombre_requerimiento})`
        );
      } else {
        form.getTextField('Equipo').setText(
          `${cabeceraCotizacion[0].nombre_maquinaria} - ${cabeceraCotizacion[0].equipo} (${cabeceraCotizacion[0].nombre_requerimiento})`
        );
      }

      let pmInserted = false;
      // Servicios Cotización
      detalleCotizacion.forEach((detalle, index) => {
        form.getTextField(`Item_Orden_${index + 1}`).setText(detalle.item_orden.split('-')[1]);
        if (detalle.descripcion !== "") {
          form.getTextField(`Descripcion_${index + 1}`).setText(detalle.descripcion);
        } else {
          form.getTextField(`Descripcion_${index + 1}`).setText(detalle.nombre_maquinaria + " " + detalle.tipo_maquinaria + " " + detalle.tipo_arriendo);
        }
        form.getTextField(`Cantidad_Minima_${index + 1}`).setText(detalle.cantidad_minima);
        form.getTextField(`Unidad_Medida_${index + 1}`).setText(detalle.unidad_medida);

        if (detalle.id_maquinaria === 1) {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(detalle.valor_unitario_neto + " UF");
        } else if (detalle.id_maquinaria === 2) {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(String("$ " + parseInt(detalle.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')));
        } else {
          form.getTextField(`Valor_Unitario_Neto_${index + 1}`).setText(String(parseFloat(detalle.valor_unitario_neto).toFixed(2) + " UF"));
        }

        if (detalle.id_maquinaria === 1 && !pmInserted) {
          form.getTextField(`Valor_Unitario_Neto_PM_${index + 1}`).setText(detalle.valor_unitario_neto_pm + " UF (PM)");
          pmInserted = true;
        }
      });

      // Guardar el PDF modificado
      const modifiedPdfBytes = await pdfDoc.save();

      // Convierte los bytes en base64
      const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      };

      // Convertir a base64 el PDF modificado y añadirlo al Email como adjunto
      const pdfBase64 = arrayBufferToBase64(modifiedPdfBytes);
      //formCorreo.adjunto[0].Base64 = pdfBase64;

      const adjuntoCotizacion = {
        NombreAdjunto: "Cotización Vittamaq " + data.folio,
        TipoDocumento: "pdf",
        Base64: pdfBase64
      };

      //Condiciones Generales
      let adjuntoCondGen = null;

      try {
        const resCG = await fetch(`${config.apiBaseUrl}/obtienePlantillaCondicionesGenerales.php?id_maquinaria=${cabeceraCotizacion[0].id_maquinaria}`);
        const bufferCG = await resCG.arrayBuffer();

        const previewCG = new TextDecoder().decode(bufferCG.slice(0, 8));
        if (!previewCG.startsWith('%PDF-')) throw new Error('No es un PDF válido');

        const pdfDocCG = await PDFDocument.load(bufferCG);
        const formCG = pdfDocCG.getForm();
        formCG.getTextField('FOLIO').setText(data.folio);

        const modifiedPdfBytesCG = await pdfDocCG.save();
        const pdfBase64CG = arrayBufferToBase64(modifiedPdfBytesCG);

        adjuntoCondGen = {
          NombreAdjunto: "Condiciones Generales " + data.folio,
          TipoDocumento: "pdf",
          Base64: pdfBase64CG
        };
      } catch (error) {
        console.warn('No se pudo cargar la plantilla de condiciones generales:', error.message);
      }

      const adjuntos = [adjuntoCotizacion];

      if (adjuntoCondGen) adjuntos.push(adjuntoCondGen);
      if (data.imagen) {
        adjuntos.push({
          NombreAdjunto: "Documento Vittamaq " + data.folio,
          TipoDocumento: "pdf",
          Base64: data.imagen
        });
      }

      formCorreo.adjuntos = adjuntos;
      // Actualizar el estado para que React renderice el PDF modificado
      setPdfBytesReenviar(modifiedPdfBytes);

      // Crear un objeto Blob con los bytes del PDF modificado
      const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
      guardarPDF(blob, data.folio);

      handleEnviarCorreo();
    };

    /* Envío de Correo: Cotización */
    const [formCorreo, setFormCorreo] = useState({
      para: "",
      asunto: "",
      cliente: "",
      razon_social: "",
      texto_cuerpo: "A continuación, adjuntamos la cotización detallada que hemos preparado para proporcionarles una oferta que se ajuste a sus necesidades y expectativas. Por favor, revisar y no dude en ponerse en contacto con nosotros si tiene alguna pregunta o necesita más información.",
      cc: {},
    });

    useEffect(() => {
      setFormCorreo({
        ...formCorreo,
        ["para"]: cabeceraCotizacion[0]?.email_solicitante,
        ["asunto"]: "Cotización N°: " + data.folio + " - Vittamaq / " + data.obra + " / " + cabeceraCotizacion[0]?.comuna_obra + " / " + data.nombre_cliente,
        ["cliente"]: cabeceraCotizacion[0]?.nombre_solicitante,
        ["razon_social"]: cabeceraCotizacion[0]?.razon_social
      });
    }, [cabeceraCotizacion]);

    const handleEnviarCorreo = async () => {
      try {
        closeSecondModal();
        closeModal();

        const response = await fetch(
          `${config.apiBaseUrl}/envio_correos.php`,
          {
            method: "POST",
            headers: {
              'Accept': 'application/json', // Indica que esperas una respuesta JSON
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formCorreo),
          }
        );

        const dataResponse = await response.json();
        if (dataResponse.message === "El correo electrónico ha sido enviado correctamente.") {
          const estadoData = [{ folio: data.folio, id_estado_cotizacion: 2, id_usuario_actualizacion: dataLogin.id_usuario }];
          const responseCambioEstado = await fetch(
            `${config.apiBaseUrl}/cabecera_cotizacion.php`,
            {
              method: "PUT",
              headers: {
                'Accept': 'application/json', // Indica que esperas una respuesta JSON
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(estadoData),
            }
          );

          const dataResponseCambioEstado = await responseCambioEstado.json();
          if (dataResponseCambioEstado.message === "Estado de cotización modificado con éxito.") {
            alert("Se ha reenviado exitosamente la cotización por correo electrónico.");

            navigate("/dashboard", { state: dataLogin });
          }

        }
      } catch (error) {
        alert("Hubo un error al enviar el correo electrónico");
      }
    };

    //Valida Email
    const validarEmail = (email) => {
      // Expresión regular para validar el formato del correo electrónico
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const [reenviarDisabled, setReenviarDisabled] = useState(false);
    const handleSubmitReenviaCotizacion = async (event, mostrarTablaCC, filas) => {
      event.preventDefault();

      setReenviarDisabled(true);

      try {
        const validaEmail = filas.every(item => validarEmail(item.email_cc));

        if (mostrarTablaCC && !validaEmail) {
          alert('Debe ingresar el o los email y comprobar si están correctos');
        } else if (!mostrarTablaCC) {
          formCorreo.cc = [];
          crearReenviarPDFCotizacion();
        } else {
          const filasEmail = filas.map(({ email_cc, ...rest }) => ({
            ...rest,
            email: email_cc
          }));
          formCorreo.cc = filasEmail;
          crearReenviarPDFCotizacion();
        }
      } catch (error) {
        //alert(error);
        console.log("Error");
      }
    }

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Detalle Cotización{/*  ({data.nombre_maquinaria}) */}</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body">
            <div className="row row-cols-md-2 mb-4">
              <div className="col">
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Folio</span>
                    <span className="label">{data.folio || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Fecha Cotización</span>
                    <span className="label">{data.fecha_cotizacion || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Obra</span>
                    <span className="label">{data.obra || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Dirección Obra</span>
                    <span className="label">{cabeceraCotizacion[0]?.direccion_obra || ""} ({cabeceraCotizacion[0]?.comuna_obra || ""})</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Maquinaria | Equipo</span>
                    <span className="label">{cabeceraCotizacion[0]?.nombre_maquinaria || ""} | {cabeceraCotizacion[0]?.equipo === "null null" ? "" : cabeceraCotizacion[0]?.equipo}</span>
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Cliente</span>
                    <span className="label">{data.nombre_cliente || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Rut</span>
                    <span className="label">{formatearRut(data.rut_cliente) || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Cliente Final</span>
                    <span className="label">{cabeceraCotizacion[0]?.nombre_cliente_final || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Contacto</span>
                    <span className="label">{cabeceraCotizacion[0]?.email_contacto || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Fecha Inicio | Fin</span>
                    <span className="label">{cabeceraCotizacion[0]?.fecha_inicio || ""} | {cabeceraCotizacion[0]?.fecha_fin || ""}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row row-cols-lg-2">
              <div className="col">
                <h5 className="mb-3">Solicitante</h5>
                <ul className="list-group mb-4">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Nombre</span>
                    <span className="label">{cabeceraCotizacion[0]?.nombre_solicitante || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Rut</span>
                    <span className="label">{cabeceraCotizacion[0]?.rut_solicitante ? formatearRut(cabeceraCotizacion[0]?.rut_solicitante) : ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Email</span>
                    <span className="label">{cabeceraCotizacion[0]?.email_solicitante || ""}</span>
                  </li>
                </ul>
              </div>
              <div className="col">
                <h5 className="mb-3">Requerimiento</h5>
                <ul className="list-group mb-3">
                  <li className="list-group-item">
                    <span className="label">{cabeceraCotizacion[0]?.nombre_requerimiento || ""}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col">
                <h5 className="mb-3">Observaciones</h5>
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="label">{cabeceraCotizacion[0]?.observaciones ? cabeceraCotizacion[0]?.observaciones : "Sin observaciones"}</span>
                  </li>
                </ul>
              </div>
            </div>
            <h5 className="mb-3">Servicios</h5>
            <div className="table-responsive border rounded">
              <table className="table table-hover mb-0">
                <thead>
                  <tr className="table-active border-bottom">
                    <th scope="col" className="ps-3">Item</th>
                    <th scope="col">Descripción</th>
                    <th scope="col">Cantidad Mínima</th>
                    <th scope="col">Unidad Medida</th>
                    <th scope="col">
                      Valor Unitario Neto más IVA
                      {cabeceraCotizacion[0]?.id_maquinaria === 2 ? " ($)" : " (UF)"}
                    </th>
                    {cabeceraCotizacion[0]?.id_maquinaria === 1 && (
                      <th scope="col" className="pe-3">Valor Unitario Neto PM (UF)</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {detalleCotizacion ? (
                    detalleCotizacion.map((detalle, index) => (
                      <tr key={index}>
                        <td className="ps-3">
                          {detalle.item_orden.split('-')[1]}
                        </td>
                        <td>
                          {
                            detalle.descripcion !== null && detalle.descripcion !== '' ? (
                              detalle.descripcion
                            ) : (
                              detalle.id_maquinaria !== 1 && detalle.id_maquinaria !== 2 && detalle.id_tipo_maquinaria === 0 ? (
                                detalle.nombre_maquinaria + " - " + detalle.tipo_arriendo
                              ) : (
                                detalle.nombre_maquinaria + (detalle.tipo_maquinaria === "" ? " - " + detalle.tipo_arriendo : " - " + detalle.tipo_maquinaria + " - " + detalle.tipo_arriendo)
                              )
                            )
                          }
                        </td>
                        <td>{Math.trunc(detalle.cantidad_minima)}</td>
                        <td>{detalle.unidad_medida}</td>
                        <td>
                          {
                            detalle.id_maquinaria === 1 ? (
                              detalle.valor_unitario_neto
                            ) : detalle.id_maquinaria === 2 ? (
                              parseInt(detalle.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')
                            ) : (
                              parseFloat(detalle.valor_unitario_neto).toFixed(2)
                            )
                          }
                        </td>
                        {detalle.id_maquinaria === 1 && detalle.id_tipo_maquinaria != null && (detalle.id_unidad_medida === 1 || detalle.id_unidad_medida === 7) ? (
                          <td className="pe-3">{detalle.valor_unitario_neto_pm}</td>
                        ) : detalle.id_maquinaria != 1 ? (
                          null
                        ) : <td></td>}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center" colSpan={4}>No se encontraron servicios asociados</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer justify-content-between">
            <div className="d-flex gap-2">
              <button className="btn btn-outline-primary" onClick={crearDescargarPDFCotizacion}><i className="bi bi-download"></i> Descargar Cotización</button>
              {cabeceraCotizacion.imagen && (
                <button className="btn btn-outline-primary" onClick={crearDescargarPDFAdjunto}><i className="bi bi-download"></i> Descargar Adjunto</button>
              )}
            </div>
            <div className="d-flex gap-2">
              {dataLogin.id_perfil === 1 && (
                <select className="form-select form-select-width" name="id_estado_cotizacion" value={estadoCotizacion} onChange={(event) => handleModificaEstado(data, event.target.value)}>
                  {estadosCotizacion.map((estado) => (
                    <option key={estado.id_estado_cotizacion} value={estado.id_estado_cotizacion}>{estado.estado}</option>
                  ))}
                </select>
              )}
              <button className="btn btn-outline-dark" onClick={(e) => handleConfirmaReenviaCotizacion(e, data.folio, cabeceraCotizacion[0].email_solicitante)}><i className="bi bi-send"></i> Reenviar</button>
              <button className="btn btn-dark" onClick={() => handleEditButtonClick("Cotización", data, detalleCotizacion, cabeceraCotizacion)}><i className="bi bi-pencil-square"></i> Editar</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* Estados de Pago */
  function AgregarEstadoPagoModalContent() {
    const [clientes, setClientes] = useState([]);
    useEffect(() => {
      obtenerClientes();
    }, []);

    const obtenerClientes = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente.php`
        );
        const data = await response.json();

        if (data && data[0].id_cliente) {
          setClientes(data);
        }
      } catch (error) {
        setClientes([]);
      }
    };

    const [dataEstadoPago, setEstadoPagoData] = useState({
      id_folio_ep: "",
      id_obra_ep: "",
      id_cliente_ep: "",
      id_cliente_final_ep: "",
      m3_bombeado_uf: "",
      m3_bombeado_valor: "",
      valor_m3: "",
      aditivo_uf: "",
      aditivo_valor: "",
      valor_traslado_bomba_uf: "",
      valor_traslado_bomba: "",
      sobre_estadia_uf: "",
      sobre_estadia_valor: "",
      otros_descuentos_ep: 0,
      detalle_otros_descuentos_ep: "",
      total_neto: "",
      iva: "",
      total: "",
      id_usuario: ""
    });

    const handleFormEstadoPagoData = (e) => {
      const { name, value } = e.target;

      if (name === "orden_compra_ep") {
        if (/^\d*$/.test(value)) {
          setEstadoPagoData({
            ...dataEstadoPago,
            [name]: value,
          });
        }
      } else {
        setEstadoPagoData({
          ...dataEstadoPago,
          [name]: value,
        });
      }

      if (name === "id_folio_ep") {
        setDataConsultaReports({
          ...dataConsultaReports,
          ["folio"]: value,
        });

        obtenerServicios(value);
      }

      //console.log(JSON.stringify(dataDetalleReportGH));
    };

    const [esServicioMensual, setEsServicioMensual] = useState(false);
    const obtenerServicios = async (folio) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/detalle_cotizacion.php?folio=${folio}`
        );
        const data = await response.json();

        if (data && data[0].id_servicio) {
          const serviciosMensuales = [5, 10, 11, 12, 13];
          const esMensual = serviciosMensuales.includes(data[0].id_servicio);
          setEsServicioMensual(esMensual);
        }
      } catch (error) {
        setEsServicioMensual('');
      }
    };

    const [clienteSelected, setClienteSelected] = useState('');
    const handleClienteSelect = async (clienteSelected) => {
      setClienteSelected(clienteSelected.value);
      await obtenerClienteObra(clienteSelected.value);

      setEstadoPagoData({
        ...dataEstadoPago,
        ["id_cliente_ep"]: clienteSelected.value,
        ["id_cliente_final_ep"]: clienteSelected.value,
        ["id_usuario"]: dataLogin.id_usuario
      });
    };

    const optionsClientes = clientes.map((cliente) => ({
      value: cliente.id_cliente,
      label: cliente.nombre_cliente,
    }));

    const handleObraSelect = async (obraSelected) => {
      await obtenerFolios(obraSelected);

      setDataConsultaReports({
        ...dataConsultaReports,
        ["id_obra_ep"]: obraSelected,
      });

      setEstadoPagoData({
        ...dataEstadoPago,
        ["id_obra_ep"]: obraSelected,
      });
    };

    const [clienteObra, setclienteObra] = useState([]);
    const obtenerClienteObra = async (cliente) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente_obra.php?id_cliente=${cliente}`
        );
        const data = await response.json();

        if (data && data[0].id_obra) {
          setclienteObra(data);
        }
      } catch (error) {
        setclienteObra([]);
      }
    };

    const [folios, setFolios] = useState([]);
    const obtenerFolios = async (obra) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cabecera_cotizacion.php?id_obra=${obra}&id_maquinaria=1`
        );
        const data = await response.json();

        if (data && data[0].folio) {
          setFolios(data);
        }
      } catch (error) {
        setFolios([]);
      }
    };

    const [dataConsultaReports, setDataConsultaReports] = useState({
      id_obra_ep: "",
      folio: "",
      fecha_desde_ep: "",
      fecha_hasta_ep: ""
    });

    const [dataReports, setDataReports] = useState([]);
    const handleSubmitBuscarReports = async (event) => {
      event.preventDefault();

      try {
        const esFormularioValido = validaFormulario();

        if (esFormularioValido) {
          setDataReports({});
          setCheckboxStates({});
          setSelectAll(false);
          setDataTotales({});

          const idObra = dataConsultaReports.id_obra_ep;
          const folio = dataConsultaReports.folio;
          const fechaDesde = dataConsultaReports.fecha_desde_ep;
          const fechaHasta = dataConsultaReports.fecha_hasta_ep;

          const response = await fetch(
            `${config.apiBaseUrl}/estado_pago_bh.php?id_obra=${idObra}&folio=${folio}&fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`
          );
          const data = await response.json();

          if (data && data[0].id_report_bh) {
            //console.log(JSON.stringify(data,null,2))
            //Suma M3
            const sumaPorId = {};

            data.forEach((item) => {
              const { id_report_bh, m3 } = item;
              sumaPorId[id_report_bh] = (sumaPorId[id_report_bh] || 0) + parseFloat(m3);
            });

            const m3_minimo = data[0].m3_minimo ? data[0].m3_minimo : Number(30).toFixed(2);

            const resultadoFormateado = Object.keys(sumaPorId).map((id_report_bh) => {
              const registros = data.filter((item) => item.id_report_bh === parseInt(id_report_bh, 10));
              const m3 = registros.reduce((total, registro) => total + (parseFloat(registro.m3) || 0), 0);

              // Diferencia en horas, minutos y segundos
              const tiempoSolicitado = new Date(`1970-01-01 ${registros[0].hora_solicitada_bombeo}`);
              const tiempoInicio = new Date(`1970-01-01 ${registros[0].hora_inicio_bombeo}`);
              const diferenciaEnMilisegundos = tiempoInicio - tiempoSolicitado;

              const diferenciaEnHoras = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60)) < 0 ? 0 : Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60));
              const diferenciaEnMinutos = Math.floor((diferenciaEnMilisegundos % (1000 * 60 * 60)) / (1000 * 60)) < 0 ? 0 : Math.floor((diferenciaEnMilisegundos % (1000 * 60 * 60)) / (1000 * 60));
              const diferenciaEnSegundos = Math.floor((diferenciaEnMilisegundos % (1000 * 60)) / 1000) < 0 ? 0 : Math.floor((diferenciaEnMilisegundos % (1000 * 60)) / 1000);

              // Formatear la diferencia en horas, minutos y segundos
              const diferenciaFormateada = `${String(diferenciaEnHoras).padStart(2, '0')}:${String(diferenciaEnMinutos).padStart(2, '0')}:${String(diferenciaEnSegundos).padStart(2, '0')}`;

              const horarioArray = diferenciaFormateada.split(':');
              const horas = parseInt(horarioArray[0], 10);
              const minutos = parseInt(horarioArray[1], 10);
              const segundos = parseInt(horarioArray[2], 10);

              const minutosTotales = horas * 60 + minutos + segundos / 60;

              const sobreEstadiaUF = Math.floor(minutosTotales / 120) < 0 ? 0 : Math.floor(minutosTotales / 120);

              //Obtener día y mes report
              const partesFecha = registros[0].fecha_report.split('-');
              const date = new Date(`${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}`);

              const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
              const nombreMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

              const diaSemana = diasSemana[date.getDay()];
              const nombreMes = nombreMeses[date.getMonth()];

              return {
                id_report_bh: parseInt(id_report_bh, 10),
                bomba: registros[0].bomba,
                fecha_report: registros[0].fecha_report,
                dia: diaSemana,
                mes: nombreMes,
                m3: isNaN(m3) || m3 === 0 ? Number(m3_minimo).toFixed(2) : m3,
                valor_uf: registros[0].valor_uf,
                valor_m3_uf: registros[0].valor_m3_uf,
                aditivo: registros[0].aditivo,
                valor_traslado_bomba_uf: registros[0].valor_traslado_bomba,
                sobre_estadia_hora: diferenciaFormateada,
                sobre_estadia_uf: sobreEstadiaUF
              };
            });

            const ufHoy = Number((indicadorUF / 1000).toFixed(5));

            const resultadoFinal = resultadoFormateado.map(item => ({
              id_report_bh: item.id_report_bh,
              bomba: item.bomba,
              fecha_report: item.fecha_report,
              dia: item.dia,
              mes: item.mes,
              //m3_bombeados: item.m3.toFixed(2),
              m3_bombeados: Number(item.m3.toFixed(2)) < Number(m3_minimo).toFixed(2) ? Number(m3_minimo).toFixed(2) : item.m3.toFixed(2),
              valor_m3_uf: item.valor_m3_uf,
              //valor_total_uf: (item.m3.toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') * item.valor_m3_uf).toFixed(2),
              valor_total_uf: esServicioMensual ? 0 : (Number(Number(item.m3.toFixed(2)) < Number(m3_minimo).toFixed(2) ? Number(m3_minimo).toFixed(2) : item.m3.toFixed(2)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') * item.valor_m3_uf).toFixed(2),
              valor_uf: item.valor_uf,
              //valor_total_bombeo_neto: ((item.m3 * item.valor_m3_uf) * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 3 }).replace(/,/g, '.'),
              valor_total_bombeo_neto: esServicioMensual ? 0 : ((Number(Number(item.m3.toFixed(2)) < Number(m3_minimo).toFixed(2) ? Number(m3_minimo).toFixed(2) : item.m3.toFixed(2)) * item.valor_m3_uf) * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 3 }).replace(/,/g, '.'),
              aditivo: item.aditivo,
              valor_traslado_bomba_uf: item.valor_traslado_bomba_uf,
              sobre_estadia_hora: item.sobre_estadia_hora,
              sobre_estadia_uf: item.sobre_estadia_uf
            }));

            setDataReports(resultadoFinal);
          } else {
            setDataReports([]);
          }
        }
      } catch (error) {
        setDataReports([]);
        alert("No se encontró información para los filtros indicados.");
      }
    }

    const [checkboxStates, setCheckboxStates] = useState({});
    const [formReportsData, setFormReportsData] = useState({});

    const [dataTotales, setDataTotales] = useState({
      m3_bombeados_suma: 0,
      valor_total_bombeo_neto_suma: 0,
      aditivo: 0,
      aditivo_valor: 0,
      horometro_uf: 0,
      horometro_valor: 0,
      sobre_estadia_uf: 0,
      sobre_estadia_valor: 0,
      total_neto: 0,
      iva: 0,
      total: 0
    });

    const [selectAll, setSelectAll] = useState(false);
    const toggleCheckbox = (index, id_report_bh, m3_bombeados, valor_m3_uf, valor_uf, aditivo, valor_traslado_bomba_uf, sobre_estadia_hora, sobre_estadia_uf, valor_total_bombeo_neto) => {
      setTotalNetoInicial(0);

      setCheckboxStates((prevState) => {
        const newState = {
          ...prevState,
          [index]: !prevState[index],
        };

        setFormReportsData((prevData) => {
          // Si el checkbox está desmarcado, elimina el elemento del estado
          if (!newState[index]) {
            setDataReports(prevReports =>
              prevReports.map(report =>
                report.id_report_bh === id_report_bh
                  ? { ...report, aditivo: aditivo, valor_traslado_bomba_uf: valor_traslado_bomba_uf, sobre_estadia_hora: sobre_estadia_hora, sobre_estadia_uf: sobre_estadia_uf, id_usuario: dataLogin.id_usuario }
                  : report
              )
            );

            const { [id_report_bh]: _, ...restData } = prevData;
            return restData;
          }

          // Si el checkbox está marcado o se está volviendo a marcar, actualiza el estado
          return {
            ...prevData,
            [id_report_bh]: {
              ...prevData[id_report_bh],
              ["id_report_bh"]: id_report_bh,
              ["m3_bombeados"]: m3_bombeados,
              ["valor_m3"]: Number(valor_m3_uf).toFixed(3),
              ["valor_uf_total"]: esServicioMensual ? 0 : (m3_bombeados * Number(valor_m3_uf)).toFixed(2),
              ["valor_uf"]: valor_uf,
              ["valor_total_bombeo_neto"]: esServicioMensual ? 0 : valor_total_bombeo_neto,
              ["aditivo"]: aditivo,
              ["valor_traslado_bomba_uf"]: valor_traslado_bomba_uf,
              ["sobre_estadia_hora"]: sobre_estadia_hora,
              ["sobre_estadia_uf"]: sobre_estadia_uf,
              ["id_estado_pago_bh"]: 0,
              ["id_usuario"]: dataLogin.id_usuario
            },
          };
        });

        return newState;
      });
    };

    //Checkbox seleccionar todos los reports BH
    const handleSelectAll = () => {
      const newSelectAll = !selectAll;
      setSelectAll(newSelectAll);

      dataReports.forEach((report, index) => {
        if (checkboxStates[index] !== newSelectAll) {
          toggleCheckbox(
            index,
            report.id_report_bh,
            report.m3_bombeados,
            report.valor_m3_uf,
            report.valor_uf,
            report.aditivo,
            report.valor_traslado_bomba_uf,
            report.sobre_estadia_hora,
            report.sobre_estadia_uf,
            report.valor_total_bombeo_neto
          );
        }
      });
    };

    useEffect(() => {
      //Cálculo de valores con fecha del último día de arriendo (Servicio Mensual)
      let UFultimoDiaMes = 0;
      if (dataConsultaReports.fecha_hasta_ep != '') {
        const [year, month, day] = dataConsultaReports.fecha_hasta_ep.split('-');
        const fechaUltimoDiaEP = `${day}-${month}-${year}`;

        const { serie } = UFmensual;

        const fechaActualIndicadorUF = serie.find(item => {
          const itemDate = new Date(item.fecha).toLocaleDateString('es-CL');
          return itemDate === fechaUltimoDiaEP;
        });

        UFultimoDiaMes = Number(fechaActualIndicadorUF.valor / 1000);
      }

      const suma = Object.values(formReportsData).reduce(
        (accumulator, item) => {
          let valorTotalBombeoNeto = esServicioMensual ? 0 : item.valor_total_bombeo_neto.replace(/\./g, '');

          accumulator.m3_bombeados += esServicioMensual ? parseFloat(item.valor_m3) : parseFloat(item.m3_bombeados);
          accumulator.valor_m3 = esServicioMensual ? 0 : parseFloat(item.valor_m3);
          accumulator.valor_total_bombeo_neto += esServicioMensual ? parseFloat(UFultimoDiaMes * item.valor_m3).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '') : parseFloat(valorTotalBombeoNeto);
          accumulator.valor_uf = parseFloat(item.valor_uf);
          accumulator.aditivo += parseFloat(item.aditivo);
          accumulator.valor_traslado_bomba_uf += parseFloat(item.valor_traslado_bomba_uf);
          accumulator.sobre_estadia_uf += parseFloat(item.sobre_estadia_uf);
          return accumulator;
        },
        { m3_bombeados: 0, valor_m3: 0, valor_total_bombeo_neto: 0, valor_uf: 0, aditivo: 0, valor_traslado_bomba_uf: 0, sobre_estadia_uf: 0 }
      );

      const ufHoy = Number((indicadorUF / 1000).toFixed(5));

      const nuevoArreglo = Object.entries(formReportsData).map(([id, item]) => ({
        valor_uf: Number((item.valor_uf / 1000).toFixed(5)),
        m3_bombeados_suma: esServicioMensual ? Number(item.valor_m3).toFixed(2) : suma.m3_bombeados.toFixed(2),
        valor_total_bombeo_neto_suma: esServicioMensual ? Number(Number(item.valor_m3) * UFultimoDiaMes).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : suma.valor_total_bombeo_neto.toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        aditivo: suma.aditivo.toFixed(2),
        aditivo_valor: Number(suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        valor_traslado_bomba_uf: suma.valor_traslado_bomba_uf === "" ? (0).toFixed(4) : parseFloat(suma.valor_traslado_bomba_uf).toFixed(4),
        valor_traslado_bomba: Number(suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        sobre_estadia_uf: isNaN(suma.sobre_estadia_uf) || suma.sobre_estadia_uf === "" ? (0).toFixed(4) : parseFloat(suma.sobre_estadia_uf).toFixed(4),
        sobre_estadia_valor: parseFloat(Number(30) * suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5)))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        total_neto: esServicioMensual ?
          Number(Number(Number(UFultimoDiaMes * item.valor_m3).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')
          : Number(Number(suma.valor_total_bombeo_neto) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        iva: esServicioMensual ?
          Number(Number(Number(Number(UFultimoDiaMes * item.valor_m3).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 0.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, })
          : Number(Number(Number(suma.valor_total_bombeo_neto) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 0.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, }),
        total: esServicioMensual ?
          Number(Number(Number(Number(UFultimoDiaMes * item.valor_m3).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 1.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, })
          : Number(Number(Number(suma.valor_total_bombeo_neto) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number((item.valor_uf / 1000).toFixed(5))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 1.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, })
      }));

      const resultadosUnicos = Array.from(
        new Set(nuevoArreglo.map(JSON.stringify)),
        JSON.parse
      );

      setDataTotales(resultadosUnicos);

      let valorTrasladoBomba;
      let sobreEstadiaValor;
      let totalNeto;
      let iva;
      let total;

      if (resultadosUnicos.length > 0) {
        valorTrasladoBomba = Number(suma.valor_traslado_bomba_uf * resultadosUnicos[0].valor_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        sobreEstadiaValor = Number(suma.sobre_estadia_uf * (suma.valor_m3 * resultadosUnicos[0].valor_uf)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '');
        totalNeto = esServicioMensual ?
          Number(Number(resultadosUnicos[0].valor_total_bombeo_neto_suma.replace(/[\.,]/g, '')) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number(resultadosUnicos[0].valor_uf)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number(Number(resultadosUnicos[0].valor_uf))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')
          : Number(Number(suma.valor_total_bombeo_neto) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number(resultadosUnicos[0].valor_uf)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number(Number(resultadosUnicos[0].valor_uf))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
        iva = esServicioMensual ?
          Number(Number(Number(resultadosUnicos[0].valor_total_bombeo_neto_suma.replace(/[\.,]/g, '')) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number(Number(resultadosUnicos[0].valor_uf))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number(Number(resultadosUnicos[0].valor_uf))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 0.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, })
          : Number(Number(Number(suma.valor_total_bombeo_neto) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number(Number(resultadosUnicos[0].valor_uf))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number(Number(resultadosUnicos[0].valor_uf))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 0.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, });
        total = esServicioMensual ?
          Number(Number(Number(resultadosUnicos[0].valor_total_bombeo_neto_suma.replace(/[\.,]/g, '')) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number(Number(resultadosUnicos[0].valor_uf))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number(Number(resultadosUnicos[0].valor_uf))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 1.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, })
          : Number(Number(Number(suma.valor_total_bombeo_neto) + Number((suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.valor_traslado_bomba_uf * Number(Number(resultadosUnicos[0].valor_uf))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')) + Number((suma.sobre_estadia_uf * parseFloat(suma.sobre_estadia_uf * (suma.valor_m3 * Number(Number(resultadosUnicos[0].valor_uf))))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, ''))) * 1.19).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0, });
      }

      setEstadoPagoData({
        ...dataEstadoPago,
        ["m3_bombeado_uf"]: suma.m3_bombeados.toFixed(2),
        ["m3_bombeado_valor"]: suma.valor_total_bombeo_neto,
        ["valor_m3"]: suma.valor_m3,
        ["aditivo_uf"]: suma.aditivo.toFixed(2),
        ["aditivo_valor"]: (suma.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
        ["valor_traslado_bomba_uf"]: suma.valor_traslado_bomba_uf === "" ? (0).toFixed(2) : parseFloat(suma.valor_traslado_bomba_uf).toFixed(2),
        ["valor_traslado_bomba"]: valorTrasladoBomba ? valorTrasladoBomba.replace(/\./g, '') : 0,
        ["sobre_estadia_uf"]: isNaN(suma.sobre_estadia_uf) || suma.sobre_estadia_uf === "" ? (0).toFixed(2) : parseFloat(suma.sobre_estadia_uf).toFixed(2),
        ["sobre_estadia_valor"]: sobreEstadiaValor ? sobreEstadiaValor.replace(/\./g, '') : 0,
        ["total_neto"]: totalNeto ? totalNeto.replace(/\./g, '') : 0,
        ["iva"]: iva ? iva.replace(/\./g, '') : 0,
        ["total"]: total ? total.replace(/\./g, '') : 0
      });
    }, [formReportsData]);

    const [isCheckedValorTrasladoBomba, setCheckedValorTrasladoBomba] = useState(true);
    const [isCheckedSobreEstadia, setCheckedSobreEstadia] = useState(true);

    const [dataOtrosDescuentos, setOtrosDescuentos] = useState(0);
    const [dataTotalNetoInicial, setTotalNetoInicial] = useState(0);

    const handleCheckboxValorTrasladoBombaChange = (valor_traslado_bomba, total_neto) => {
      setCheckedValorTrasladoBomba(!isCheckedValorTrasladoBomba);

      if (isCheckedValorTrasladoBomba) {
        const totalNeto = Number(total_neto.replace(/\./g, '')) - Number(valor_traslado_bomba.replace(/\./g, ''));
        setTotalNetoInicial(totalNeto);

        dataTotales[0].total_neto = Number(Number(total_neto.replace(/\./g, '')) - Number(valor_traslado_bomba.replace(/\./g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
        dataTotales[0].iva = Number(Number(Number(total_neto.replace(/\./g, '')) - Number(valor_traslado_bomba.replace(/\./g, ''))) * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
        dataTotales[0].total = Number(Number(Number(total_neto.replace(/\./g, '')) - Number(valor_traslado_bomba.replace(/\./g, ''))) * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
      } else {
        const totalNeto = Number(total_neto.replace(/\./g, '')) + Number(valor_traslado_bomba.replace(/\./g, ''));
        setTotalNetoInicial(totalNeto);

        dataTotales[0].total_neto = Number(Number(total_neto.replace(/\./g, '')) + Number(valor_traslado_bomba.replace(/\./g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
        dataTotales[0].iva = Number(Number(Number(total_neto.replace(/\./g, '')) + Number(valor_traslado_bomba.replace(/\./g, ''))) * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
        dataTotales[0].total = Number(Number(Number(total_neto.replace(/\./g, '')) + Number(valor_traslado_bomba.replace(/\./g, ''))) * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
      }
    };

    const handleCheckboxSobreEstadia = (sobre_estadia_valor, total_neto) => {
      setCheckedSobreEstadia(!isCheckedSobreEstadia);

      const totalNeto = Number(total_neto.replace(/\./g, '')) - Number(sobre_estadia_valor.replace(/\./g, ''));
      setTotalNetoInicial(totalNeto);

      if (isCheckedSobreEstadia) {
        dataTotales[0].total_neto = Number(Number(total_neto.replace(/\./g, '')) - Number(sobre_estadia_valor.replace(/\./g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
        dataTotales[0].iva = Number(Number(Number(total_neto.replace(/\./g, '')) - Number(sobre_estadia_valor.replace(/\./g, ''))) * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
        dataTotales[0].total = Number(Number(Number(total_neto.replace(/\./g, '')) - Number(sobre_estadia_valor.replace(/\./g, ''))) * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
      } else {
        dataTotales[0].total_neto = Number(Number(total_neto.replace(/\./g, '')) + Number(sobre_estadia_valor.replace(/\./g, ''))).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
        dataTotales[0].iva = Number(Number(Number(total_neto.replace(/\./g, '')) + Number(sobre_estadia_valor.replace(/\./g, ''))) * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
        dataTotales[0].total = Number(Number(Number(total_neto.replace(/\./g, '')) + Number(sobre_estadia_valor.replace(/\./g, ''))) * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
      }
    };

    const handleOtrosDescuentos = (otro_descuento, total_neto_valor) => {
      if (/^\d*$/.test(otro_descuento)) {
        const nuevoDescuento = Number(otro_descuento) || 0;
        setOtrosDescuentos(nuevoDescuento);

        if (dataTotalNetoInicial === 0) {
          const totalNeto = Number(total_neto_valor.replace(/\./g, ''));
          setTotalNetoInicial(totalNeto);

          let totalNetoMostrado = nuevoDescuento === 0 ? totalNeto : totalNeto - nuevoDescuento;
          dataTotales[0].total_neto = totalNetoMostrado.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
          dataTotales[0].iva = Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
          dataTotales[0].total = Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');

          setEstadoPagoData({
            ...dataEstadoPago,
            ["otros_descuentos_ep"]: nuevoDescuento,
            ["total_neto"]: totalNetoMostrado.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/[\.,]/g, ''),
            ["iva"]: Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            ["total"]: Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')
          });
        } else {
          let totalNetoConDescuento = dataTotalNetoInicial - nuevoDescuento;
          let totalNetoMostrado = nuevoDescuento === 0 ? dataTotalNetoInicial : totalNetoConDescuento;
          dataTotales[0].total_neto = totalNetoMostrado.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
          dataTotales[0].iva = Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
          dataTotales[0].total = Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');

          setEstadoPagoData({
            ...dataEstadoPago,
            ["otros_descuentos_ep"]: nuevoDescuento,
            ["total_neto"]: totalNetoMostrado.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/[\.,]/g, ''),
            ["iva"]: Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            ["total"]: Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '')
          });
        }
      }
    };

    const navigate = useNavigate();
    const handleSubmitEstadoPagoBH = async (event) => {
      event.preventDefault();

      try {
        const esFormularioValido = validaFormularioSubmit();

        if (Object.keys(formReportsData).length === 0) {
          alert('Debe agregar al menos un report');
        } else if (esFormularioValido) {
          const response = await fetch(
            `${config.apiBaseUrl}/estado_pago_bh.php`,
            {
              method: "POST",
              headers: {
                'Accept': 'application/json', // Indica que esperas una respuesta JSON
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(dataEstadoPago),
            }
          );

          const dataResponse = await response.json();
          if (dataResponse.message === "Estado de pago agregado con éxito.") {
            const estadoPagoReports = Object.keys(formReportsData).reduce((acc, key) => {
              if (typeof formReportsData[key] === 'object') {
                acc[key] = { ...formReportsData[key], id_estado_pago_bh: dataResponse.id_estado_pago_bh };
              } else {
                acc[key] = formReportsData[key];
              }
              return acc;
            }, {});

            const responseReports = await fetch(
              `${config.apiBaseUrl}/estado_pago_reports_bh.php`,
              {
                method: "POST",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(estadoPagoReports),
              }
            );

            const dataResponseReports = await responseReports.json();
            if (dataResponseReports.message === "Reports de estado de pago agregados con éxito.") {
              const responseReportsActualizados = await fetch(
                `${config.apiBaseUrl}/report_bh.php`,
                {
                  method: "PUT",
                  headers: {
                    'Accept': 'application/json', // Indica que esperas una respuesta JSON
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formReportsData),
                }
              );

              const dataResponseReportsActualizados = await responseReportsActualizados.json();
              if (dataResponseReportsActualizados.message === "Reports de estado de pago actualizados con éxito.") {
                setEstadoPagoData({
                  id_folio_ep: "",
                  id_obra_ep: "",
                  id_cliente_ep: "",
                  id_cliente_final_ep: "",
                  m3_bombeado_uf: "",
                  m3_bombeado_valor: "",
                  valor_m3: "",
                  aditivo_uf: "",
                  aditivo_valor: "",
                  kms_recorridos_uf: "",
                  kms_recorridos_valor: "",
                  sobre_estadia_uf: "",
                  sobre_estadia_valor: "",
                  otros_descuentos_ep: "",
                  detalle_otros_descuentos_ep: "",
                  total_neto: "",
                  iva: "",
                  total: "",
                  id_usuario: ""
                });

                setFormReportsData([]);

                alert("Estado de pago agregado con éxito.");

                navigate("/dashboard", { state: dataLogin });

                closeModal();
              }
            }
          } else {
            throw new Error();
          }
        }
      } catch (error) {
        alert(error);
      }
    }

    const validaFormulario = () => {
      if (clienteSelected === "") {
        alert('Debe seleccionar un cliente');
        return false;
      }

      if (dataEstadoPago.id_folio_ep.trim() === '') {
        alert('Debe seleccionar un folio');
        return false;
      }

      if (dataConsultaReports.fecha_desde_ep.trim() === '') {
        alert('Debe indicar una fecha desde');
        return false;
      }

      if (dataConsultaReports.fecha_hasta_ep.trim() === '') {
        alert('Debe indicar una fecha hasta');
        return false;
      }

      return true;
    }

    const validaFormularioSubmit = () => {
      if (clienteSelected === "") {
        alert('Debe seleccionar un cliente');
        return false;
      }

      if (dataEstadoPago.id_folio_ep.trim() === '') {
        alert('Debe seleccionar un folio');
        return false;
      }

      if (dataConsultaReports.fecha_desde_ep.trim() === '') {
        alert('Debe indicar una fecha desde');
        return false;
      }

      if (dataConsultaReports.fecha_hasta_ep.trim() === '') {
        alert('Debe indicar una fecha hasta');
        return false;
      }

      if (dataEstadoPago.otros_descuentos_ep !== 0) {
        if (dataEstadoPago.detalle_otros_descuentos_ep.trim() === '') {
          alert('Debe indicar el detalle de otros descuentos, de lo contrario su valor debe ser 0');
          return false;
        }
      }

      return true;
    }

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xxl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Agregar Estado de Pago: Bomba Hormigón</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body py-3 px-5">
            <div className="row row-cols-lg-4 mb-3">
              <div className="col">
                <label className="form-label">Cliente</label>
                <Select
                  name="id_cliente_ep"
                  value={clienteSelected.value}
                  onChange={handleClienteSelect}
                  options={optionsClientes}
                  isSearchable
                  className="react-select"
                  placeholder="Seleccione un cliente"
                />
              </div>
              <div className="col">
                <label className="form-label">Obra</label>
                <select className="form-select" name="id_obra_ep" value={dataConsultaReports.id_obra_ep} onChange={(e) => handleObraSelect(e.target.value)}>
                  <option value="">Seleccione una obra</option>
                  {clienteObra.map((obra, index) => (
                    <option key={index} value={obra.id_obra}>{obra.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="col">
                <label className="form-label">Cliente Final</label>
                <select className="form-select" name="id_cliente_final_ep" value={dataEstadoPago.id_cliente_final_ep} disabled>
                  <option value="">Seleccione un cliente final</option>
                  {optionsClientes.map((cliente_final, index) => (
                    <option key={index} value={cliente_final.value}>{cliente_final.label}</option>
                  ))}
                </select>
              </div>
              {folios ? (
                <div className="col">
                  <label className="form-label">Folio</label>
                  <select className="form-select" name="id_folio_ep" value={dataEstadoPago.id_folio_ep} onChange={handleFormEstadoPagoData}>
                    <option value="">Seleccione un folio</option>
                    {folios.map((folio, index) => (
                      <option key={index} value={folio.folio}>{folio.folio} {folio.equipo !== "null null" ? "(" + folio.equipo + ")" : ""}</option>
                    ))}
                  </select>
                </div>
              ) : (
                <div className="col">
                  <label className="form-label">Folio</label>
                  <select className="form-select" name="folio_ep">
                    <option value="">No se encontraron folios</option>
                  </select>
                </div>
              )}
            </div>
            <div className="row row-cols-lg-4 align-items-end mb-4">
              <div className="col">
                <label className="form-label">Fecha Desde</label>
                <input
                  className="form-control"
                  type="date"
                  name="fecha_desde_ep"
                  value={dataConsultaReports.fecha_desde_ep}
                  max={today.toISOString().split('T')[0]}
                  onChange={(e) => setDataConsultaReports({
                    ...dataConsultaReports,
                    fecha_desde_ep: e.target.value
                  })}
                />
              </div>
              <div className="col">
                <label className="form-label">Fecha Hasta</label>
                <input
                  className="form-control"
                  type="date"
                  name="fecha_hasta_ep"
                  value={dataConsultaReports.fecha_hasta_ep}
                  max={today.toISOString().split('T')[0]}
                  onChange={(e) => setDataConsultaReports({
                    ...dataConsultaReports,
                    fecha_hasta_ep: e.target.value
                  })}
                />
              </div>
              <div className="col">
                <label className="form-label d-block">&nbsp;</label>
                <button className="btn btn-dark" onClick={handleSubmitBuscarReports}>
                  <i className="bi bi-search"></i> Buscar
                </button>
              </div>
            </div>
            <div className="d-flex justify-content-md-between mb-3">
              <h5 className="mb-0">Detalle Reports</h5>
              <span className="d-inline-flex align-items-center">
                <label className="form-label mb-0 me-2">Valor UF Hoy:</label>
                <span className="fw-bold text-orange">{Number(indicadorUF ? indicadorUF : '0').toLocaleString('es-ES', { useGrouping: true })}</span>
              </span>
            </div>
            <div className="table-responsive border rounded mb-4">
              <table className="table table-hover text-center table-sm mb-0">
                <thead>
                  <tr className="table-active border-bottom">
                    {dataReports.length > 0 ? (
                      <th>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectAll}
                          onChange={handleSelectAll}
                        />
                      </th>
                    ) : (
                      <th></th>
                    )}
                    <th scope="col" className="text-center">N° Report</th>
                    <th scope="col">N° Equipo</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Día</th>
                    <th scope="col">Mes</th>
                    <th scope="col">M3 Bombeados</th>
                    <th scope="col">Valor M3 (UF)</th>
                    <th scope="col">Valor UF Total</th>
                    <th scope="col">Valor UF</th>
                    <th scope="col">V.T. Bombeo Neto</th>
                    <th scope="col">Vittech</th>
                    <th scope="col">Valor Traslado BH</th>
                    <th scope="col">Sobre Estadía</th>
                  </tr>
                </thead>
                <tbody>
                  {dataReports.length > 0 ? (
                    dataReports.map((report, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={checkboxStates[index] || false}
                            onChange={() => toggleCheckbox(index, report.id_report_bh, report.m3_bombeados, report.valor_m3_uf, report.valor_uf, report.aditivo, report.valor_traslado_bomba_uf, report.sobre_estadia_hora, report.sobre_estadia_uf, report.valor_total_bombeo_neto)}
                          />
                        </td>
                        <td>{report.id_report_bh}</td>
                        <td>{report.bomba}</td>
                        <td>{report.fecha_report}</td>
                        <td>{report.dia}</td>
                        <td>{report.mes}</td>
                        <td>{report.m3_bombeados}</td>
                        <td>{report.valor_m3_uf}</td>
                        <td>{report.valor_total_uf}</td>
                        <td><small className="text-secondary">$ </small> {Number(report.valor_uf).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        <td><small className="text-secondary">$ </small> {report.valor_total_bombeo_neto}</td>
                        <td>{report.aditivo}</td>
                        <td>{report.valor_traslado_bomba_uf}</td>
                        <td>{report.sobre_estadia_hora.substring(0, 5)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center ps-1" colSpan={14}>No se encontraron reports</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="row row-cols-md-2">
              <div className="col">
                <h5 className="mb-3">Total Item</h5>
                <div className="table-responsive border rounded">
                  <table className="table table-hover table-sm mb-0">
                    <thead>
                      <tr className="table-active border-bottom">
                        <th></th>
                        <th className="col-6">Item</th>
                        <th className="col-3">Cantidad (UF)</th>
                        <th className="col-3">Valor</th>
                      </tr>
                    </thead>
                    {dataTotales.length > 0 ? (
                      <tbody>
                        <tr>
                          <td> </td>
                          <td>M3 Bombeados {esServicioMensual ? "(Servicio Mensual)" : ""}</td>
                          <td>{dataTotales[0].m3_bombeados_suma}</td>
                          <td><small className="text-secondary">$ </small> {dataTotales[0].valor_total_bombeo_neto_suma}</td>
                        </tr>
                        <tr>
                          <td> </td>
                          <td>Vittech</td>
                          <td>{dataTotales[0].aditivo}</td>
                          <td><small className="text-secondary">$ </small> {dataTotales[0].aditivo_valor}</td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isCheckedValorTrasladoBomba}
                              onChange={() => handleCheckboxValorTrasladoBombaChange(dataTotales[0].valor_traslado_bomba, dataTotales[0].total_neto)}
                            />
                          </td>
                          <td>Valor Traslado Bomba</td>
                          <td>{dataTotales[0].valor_traslado_bomba_uf}</td>
                          <td><small className="text-secondary">$ </small> {dataTotales[0].valor_traslado_bomba}</td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={isCheckedSobreEstadia}
                              onChange={() => handleCheckboxSobreEstadia(dataTotales[0].sobre_estadia_valor, dataTotales[0].total_neto)}
                            />
                          </td>
                          <td>Sobre Estadia</td>
                          <td>{dataTotales[0].sobre_estadia_uf}</td>
                          <td><small className="text-secondary">$ </small> {dataTotales[0].sobre_estadia_valor}</td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td></td>
                          <td>M3 Bombeados</td>
                          <td>0.00</td>
                          <td><small className="text-secondary">$ </small> 0</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>Vittech</td>
                          <td>0.00</td>
                          <td><small className="text-secondary">$ </small> 0</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>Valor Traslado Bomba</td>
                          <td>0.00</td>
                          <td><small className="text-secondary">$ </small> 0</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td>Sobre Estadia</td>
                          <td>0.00</td>
                          <td><small className="text-secondary">$ </small> 0</td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
              <div className="col">
                <h5 className="mb-3">Valores Totales</h5>
                <div className="table-responsive border rounded mb-4">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr className="table-active border-bottom">
                        <th scope="col" className="ps-2">Total Neto</th>
                        <th scope="col">IVA</th>
                        <th scope="col" className="text-dark fw-semibold pe-2">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataTotales.length > 0 ? (
                        <tr>
                          <td className="ps-2"><small className="text-secondary">$ </small>{dataTotales[0].total_neto}</td>
                          <td><small className="text-secondary">$ </small>{dataTotales[0].iva}</td>
                          <td className="pe-2"><small className="text-secondary">$ </small><span className="text-orange">{dataTotales[0].total}</span></td>
                        </tr>
                      ) : (
                        <tr>
                          <td className="ps-2"><small className="text-secondary">$ </small>0</td>
                          <td><small className="text-secondary">$ </small>0</td>
                          <td className="pe-2"><small className="text-secondary">$ </small><span className="text-orange">0</span></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="row row-cols-md-2">
                  <div className="col">
                    <label className="form-label">Otros Descuentos</label>
                    {dataTotales.length > 0 ? (
                      <input
                        className="form-control"
                        type="text"
                        name="otros_descuentos_ep"
                        value={dataOtrosDescuentos}
                        onChange={(e) => handleOtrosDescuentos(e.target.value, dataTotales[0].total_neto)}
                      />
                    ) : (
                      <input
                        className="form-control"
                        type="text"
                        name="otros_descuentos_ep"
                        disabled
                      />
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Detalle Descuentos</label>
                    <input
                      className="form-control"
                      type="text"
                      name="detalle_otros_descuentos_ep"
                      onChange={(e) => setEstadoPagoData({
                        ...dataEstadoPago,
                        ["detalle_otros_descuentos_ep"]: e.target.value
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-yellow" onClick={handleSubmitEstadoPagoBH}><i className="bi bi-floppy"></i> Guardar</button>
          </div>
        </div>
      </div>
    );
  }

  function EstadoPagoBHModalContent({ data }) {
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [estadoPagoEstado, setEstadoPagoEstado] = useState(data.id_estado_pago_estado);
    const [estadoPagoReportsBH, setEstadoPagoReportsBH] = useState([]);
    const [estadoPagoDocumentosBH, setEstadoPagoDocumentosBH] = useState([]);
    const [detalleCotizacion, setDetalleCotizacion] = useState([]);
    const [submitFacturarDisabled, setSubmitFacturarDisabled] = useState(true);

    useEffect(() => {
      obtenerTiposDocumentos();
      obtenerReportsBH(data.id_estado_pago_bh);
      obtenerDocumentosBH(data.id_estado_pago_bh);
      obtenerDetalleCotizacion(data.folio);

      if (data.id_estado_pago_estado === 4) {
        setSubmitFacturarDisabled(false);
      }
    }, []);

    const obtenerTiposDocumentos = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/tipo_documento.php`
        );
        const data = await response.json();

        if (data && data[0].id_tipo_documento) {
          setTiposDocumentos(data);
        }
      } catch (error) {
        setTiposDocumentos([]);
      }
    };

    const obtenerDocumentosBH = async (id_estado_pago_bh) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_documentos_bh.php?id_estado_pago_bh=${id_estado_pago_bh}`
        );
        const data = await response.json();

        if (data && data[0].id_estado_pago_documentos_bh) {
          setEstadoPagoDocumentosBH(data);
        }
      } catch (error) {
        setEstadoPagoDocumentosBH([]);
      }
    };

    const [esServicioMensual, setEsServicioMensual] = useState(false);
    const obtenerDetalleCotizacion = async (folio) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/detalle_cotizacion.php?folio=${folio}`
        );
        const data = await response.json();

        if (data && data[0].id_servicio) {
          setDetalleCotizacion(data);

          const serviciosMensuales = [10, 11, 12, 13];
          const esMensual = serviciosMensuales.includes(data[0].id_servicio);
          setEsServicioMensual(esMensual);
        }
      } catch (error) {
        setDetalleCotizacion([]);
        setEsServicioMensual('');
      }
    };

    const obtenerReportsBH = async (id_estado_pago_bh) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_reports_bh.php?id_estado_pago_bh=${id_estado_pago_bh}`
        );
        const data = await response.json();

        if (data && data[0].id_estado_pago_bh) {
          setEstadoPagoReportsBH(data);
        }
      } catch (error) {
        setEstadoPagoReportsBH([]);
      }
    };

    //Obtiene resumen a facturar
    const [jsonPIGT, setJsonPIGT] = useState([]);
    const [detalleEquipos, setDetalleEquipos] = useState([]);

    useEffect(() => {
      if (estadoPagoReportsBH.length > 0 && detalleCotizacion.length > 0) {
        obtenerResumenFacturar();
      }
    }, [estadoPagoReportsBH, detalleCotizacion]);

    const obtenerResumenFacturar = () => {
      //JSON para PIG-T
      const objetoPIGT = (dataCotizacion, detalleCotizacion) => {
        //let fechaCotizacionFormateada = `${dataCotizacion.fecha_cotizacion.split('-')[2]}-${dataCotizacion.fecha_cotizacion.split('-')[1]}-${dataCotizacion.fecha_cotizacion.split('-')[0]}T00:00:00`;
        //const fechaHoyFormateada = new Date().toISOString().split('.')[0];
        let rutClienteFormateado = formatearRut(dataCotizacion.rut_cliente);

        let recargo = Number(data.aditivo_valor) + Number(data.sobre_estadia_valor) + Number(data.valor_traslado_bomba);

        //Documentos
        const detalleDocumentos = estadoPagoDocumentosBH.map(doc => {
          let tipoDocumento = doc.tipo_documento;
          let fechaDocumentoFormateada = `${doc.fecha_detalle.split('-')[2]}-${doc.fecha_detalle.split('-')[1]}-${doc.fecha_detalle.split('-')[0]}T00:00:00`;

          // Modifica el tipo de documento según corresponda
          if (doc.tipo_documento === "HES") {
            tipoDocumento = "HES (Hoja Entrada De Servicio)";
          } else if (doc.tipo_documento === "Orden de Trabajo") {
            tipoDocumento = "OT (Orden de Trabajo)";
          }
          return {
            TpoDocRef: tipoDocumento,
            FolioRef: doc.detalle,
            FechaRef: fechaDocumentoFormateada,
            RazonRef: data.folio
          };
        });

        const nuevoObjeto = [
          {
            'Folio': 0,
            'Usuario': "pamela.varas@vittamaq.cl", // Usuario de Kame
            'Documento': "Factura Electrónica",
            'Rut': rutClienteFormateado,
            'TipoDocumento': "VENTA",
            'RznSocial': dataCotizacion.razon_social.toUpperCase(),
            'Giro': dataCotizacion.giro.toUpperCase(),
            'Direccion': dataCotizacion.direccion.toUpperCase(),
            'Ciudad': dataCotizacion.ciudad.toUpperCase(),
            'Comuna': dataCotizacion.comuna.toUpperCase(),
            'Telefono': dataCotizacion.telefono_representante,
            'Email': dataCotizacion.email_solicitante,
            'Fecha': "",
            'Comentario': "FOLIO COTIZACION: " + dataCotizacion.folio,
            'FormaPago': "1",
            'Afecto': Number(data.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'Exento': 0,
            'Descuento': Number(data.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'TipoImpto1': "IVA",
            'ValorImpto1': Number(data.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'total': Number(data.total).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'FechaVencimiento': "",
            'Bodega': "",//data.bodega.toUpperCase(),
            'EsInventariable': "",
            'Vendedor': data.vendedor.toUpperCase(),
            'Recargo': recargo,
            'PorcDescuento': 0,
            'PorcRecargo': 0,
            'Contacto': dataCotizacion.email_solicitante,
            'Observacion': "",
            'Comision': null,
            'FormaCredito': "",
            'FichaDireccion': "",
            'Detalle': detalleCotizacion,
            'Referencias': detalleDocumentos
          }
        ];

        return nuevoObjeto;
      };

      // Agrupar por bomba
      const datosDescripcionAgrupados = estadoPagoReportsBH.reduce((acc, current) => {
        const bomba = current.bomba;

        // Convertir sobre_estadia_hora a segundos para comparación
        const [hours, minutes, seconds] = current.sobre_estadia_hora.split(':').map(Number);
        const totalSeconds = hours * 3600 + minutes * 60 + seconds;
        const thresholdSeconds = 2 * 3600; // 02:00:00 en segundos

        // Si la bomba no está en el acumulador, inicializa su entrada
        if (!acc[bomba]) {
          acc[bomba] = {
            ...current,
            m3_bombeados: parseFloat(current.m3_bombeados),
            valor_uf_total: parseFloat(current.valor_uf_total),
            aditivo: parseFloat(current.aditivo),
            sobre_estadia: 0, // Inicializar sobre_estadia,
            valor_total_bombeo_neto: parseFloat(current.valor_total_bombeo_neto)
          };
        } else {
          // Suma m3_bombeados y valor_uf_total
          acc[bomba].m3_bombeados += parseFloat(current.m3_bombeados);
          acc[bomba].valor_uf_total += parseFloat(current.valor_uf_total);
          acc[bomba].aditivo += parseFloat(current.aditivo);
          acc[bomba].valor_total_bombeo_neto += parseFloat(current.valor_total_bombeo_neto);
        }

        // Suma 1 a sobre_estadia si el tiempo es mayor a 02:00:00
        if (totalSeconds >= thresholdSeconds) {
          acc[bomba].sobre_estadia += 1;
        }

        return acc;
      }, {});

      // Formatea los resultados
      const datosDescripcion = Object.values(datosDescripcionAgrupados).map(item => {
        const totalM3 = item.m3_bombeados.toFixed(2).replace('.', ',');
        const totalM3UF = item.valor_uf_total.toFixed(2).replace('.', ',');
        const totalM3Pesos = Number(item.valor_total_bombeo_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const sobreEstadia = Number(item.sobre_estadia * (item.valor_m3 * Number((item.valor_uf / 1000).toFixed(5)))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const aditivo = (item.aditivo * 5500).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const trasladoBomba = (item.valor_traslado_bomba_uf * Number((item.valor_uf / 1000).toFixed(5))).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        //const totalPesos = Number(Number(item.valor_total_bombeo_neto) + Number(sobreEstadia) + Number(aditivo)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const totalPesos = Number(item.valor_total_bombeo_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const fechaReport = new Date(item.fecha_report.split('-').reverse().join('-'));

        // Verificar si el equipo ya existe en detalleEquipos antes de agregarlo
        setDetalleEquipos(prevDetalleEquipos => {
          const existeEquipo = prevDetalleEquipos.some(detalle => detalle.numero_equipo === item.bomba);

          if (!existeEquipo) {
            return [
              ...prevDetalleEquipos,
              {
                razon_social: data.razon_social,
                obra: data.nombre_obra,
                numero_equipo: item.bomba,
                total_m3_bombeados: totalM3,
                total_m3_valor_uf: totalM3UF,
                total_m3_valor_pesos: totalM3Pesos,
                total_aditivo: aditivo,
                total_sobre_estadia: sobreEstadia,
                total_traslado_bomba: trasladoBomba,
                total: totalPesos,
                fecha_report: fechaReport
              }
            ];
          }

          return prevDetalleEquipos; // No añadir duplicados
        });

        // Retornar el objeto con la estructura necesaria
        return {
          "Descripcion": `ARRIENDO BOMBA HORMIGON N° ${item.bomba}`,
          "Cantidad": 1.000000,
          "PrecioUnitario": totalPesos,
          "Descuento": 0,
          "Total": totalPesos,
          "UnidadMedida": "UN",
          "UnidadNegocio": "CASA MATRIZ",
          "Articulo": "ARRIENDO BOMBA HORMIGON",  //Si es inventariable entonces validará el sku o descripción del artículo
          "PorcDescuento": 0.00,
          "DescripcionDetallada": `ARRIENDO BOMBA HORMIGON N° ${item.bomba} - OBRA: ${data.nombre_obra.toUpperCase()}, ${totalM3} TOTAL M3 BOMBEADOS, ${totalM3UF} TOTAL UF${sobreEstadia > 0 ? " + SOBRESTADIA $" + Number(sobreEstadia).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""}${aditivo > 0 ? " + VITTECH $" + Number(aditivo).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""}${trasladoBomba > 0 ? " + TRASLADO BOMBA $" + Number(trasladoBomba).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""} - SEGUN REPORT ${fechaReport.toLocaleString('es-CL', { month: 'long' }).toUpperCase()} ${fechaReport.getFullYear()}`,
          "Exento": "",
          "TipoExento": "",
          "CuentaEmpresaVenta": "",
          "TipoArticulo": "" // Campo para determinar si es campo Articulo corresponde a artículo, pack o servicio. Los valores permitidos son "", "SERVICIO", "PACK", "ARTICULO", si es vacío el campo o nulo la API lo tomará como Artículo
        };
      });

      setJsonPIGT(objetoPIGT(data, datosDescripcion));

    };

    const handleDateFacturacionChange = (event) => {
      const selectedDate = event.target.value; // Obtiene la nueva fecha seleccionada (formato YYYY-MM-DD)

      // Convertir la fecha seleccionada a formato ISO 8601 (sin fracciones de segundo)
      const newDate = new Date(selectedDate).toISOString().split('.')[0];

      // Actualizar el estado del jsonPIGT
      setJsonPIGT((prevJsonPigT) =>
        prevJsonPigT.map((item, index) =>
          index === 0
            ? { ...item, Fecha: newDate, FechaVencimiento: newDate }
            : item
        )
      );
    };

    //Modificar estado EP
    const handleModificaEstado = (data_estado_pago, id_estado_pago_estado) => {
      if (id_estado_pago_estado === '3' && jsonPIGT[0].Fecha === "") {
        alert('Debe indicar una fecha de facturación');
        return false;
      } else {
        setEstadoPagoEstado(id_estado_pago_estado);

        setSecondModalOpen(true);

        setSecondModalContent(<ConfirmaModificaEstadoModalContent dataEstadoPago={data_estado_pago} idEstadoPagoEstado={id_estado_pago_estado} />);
      }
    };

    function ConfirmaModificaEstadoModalContent({ dataEstadoPago, idEstadoPagoEstado }) {
      const obtenerEstadoPorId = (idEstadoPagoEstado) => {
        const estadoEncontrado = estadosPagoEstado.find(estado => estado.id_estado_pago_estado === idEstadoPagoEstado);
        return estadoEncontrado ? estadoEncontrado.estado_pago_estado : 'Estado no encontrado';
      };

      const estado = obtenerEstadoPorId(Number(idEstadoPagoEstado));

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Modificar Estado: {dataEstadoPago.folio}</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5">¿Está seguro que desea modificar el estado del estado de pago a: {idEstadoPagoEstado === '2' ? <span className="text-red">{estado}</span> : <span className="text-orange">{estado}</span>} ?</p>
            </div>
            <div className="modal-footer">
              <button className={idEstadoPagoEstado === '2' ? "btn btn-danger" : "btn btn-yellow"} onClick={(e) => handleSubmitModificarEstado(e, dataEstadoPago.id_estado_pago_bh, idEstadoPagoEstado)}>
                {idEstadoPagoEstado === '2' ? (
                  <span>
                    <i className="bi bi-dash-circle"></i> Anular Estado de Pago
                  </span>
                ) : (
                  <span>
                    <i className="bi bi-check-circle"></i> Facturar Estado de Pago
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      );
    }

    const handleSubmitModificarEstado = async (event, idEstadoPagoBH, idEstadoPagoEstado) => {
      event.preventDefault();

      try {
        closeSecondModal();
        closeModal();

        if (idEstadoPagoEstado === "2") {
          const formModificarEstado = { id_estado_pago_bh: idEstadoPagoBH, id_estado_pago_estado: idEstadoPagoEstado, id_usuario_actualizacion: dataLogin.id_usuario };

          const responseModificarEstado = await fetch(
            `${config.apiBaseUrl}/estado_pago_bh.php`,
            {
              method: "PUT",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formModificarEstado),
            }
          );

          const dataModificarEstado = await responseModificarEstado.json();
          if (dataModificarEstado.message === "Estado de pago modificado con éxito.") {
            const habilitaReportsData = {
              habilita_report: 1,
              reports: estadoPagoReportsBH.map(item => ({
                id_report_bh: item.id_report_bh
              }))
            };

            const responseReportsActualizados = await fetch(
              `${config.apiBaseUrl}/report_bh.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(habilitaReportsData),
              }
            );

            const dataResponseReportsActualizados = await responseReportsActualizados.json();
            if (dataResponseReportsActualizados.message === "Report BH habilitado exitosamente.") {
              alert("Estado de pago anulado con éxito.");

              obtenerEstadosPagoBH();

              navigate("/dashboard", { state: dataLogin });
            }

          } else {
            throw new Error();
          }
        } else {
          if (jsonPIGT.length > 0) {
            const responseKame = await fetch(
              `https://app.pig-t.cl/vittamaq_Cotizaciones_Kame`,
              {
                method: "POST",
                headers: {
                  'Accept': 'application/json',
                },
                body: JSON.stringify(jsonPIGT),
              }
            );

            const dataResponseKame = await responseKame.json();

            if (dataResponseKame.phrase === "OK" && dataResponseKame.kameresponse.Estado === "Ok") {
              const fechaFacturacionFormateada = jsonPIGT[0].Fecha.split('T')[0];
              const formFolioKame = { id_estado_pago_bh: data.id_estado_pago_bh, folio_kame: dataResponseKame.kameresponse.Folio, fecha_facturacion: fechaFacturacionFormateada, id_estado_pago_estado: idEstadoPagoEstado, id_usuario_actualizacion: dataLogin.id_usuario };
              const responseActualizaFolioKame = await fetch(
                `${config.apiBaseUrl}/estado_pago_bh.php`,
                {
                  method: "PUT",
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formFolioKame),
                }
              );

              const dataActualizaFolioKame = await responseActualizaFolioKame.json();
              if (dataActualizaFolioKame.message === "Folio de Kame agregado con éxito.") {

                const facturaReportsData = estadoPagoReportsBH.map(item => ({
                  id_report_bh: item.id_report_bh,
                }));

                const responseReportsActualizados = await fetch(
                  `${config.apiBaseUrl}/report_bh.php`,
                  {
                    method: "PUT",
                    headers: {
                      'Accept': 'application/json', // Indica que esperas una respuesta JSON
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(facturaReportsData),
                  }
                );

                const dataResponseReportsActualizados = await responseReportsActualizados.json();
                if (dataResponseReportsActualizados.message === "Reports de estado de pago actualizados con éxito.") {
                  alert("Estado de pago facturado con éxito.");

                  obtenerEstadosPagoBH();

                  navigate("/dashboard", { state: dataLogin });
                }
              }
            } else {
              alert("Error al facturar el estado de pago, verifique la información.")
              throw new Error();
            }
          }
        }
      } catch (error) {
        obtenerEstadosPagoBH();
      }
    }

    //DOCUMENTOS
    const [activeTab, setActiveTab] = useState('resumen');
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };

    const filaPredeterminada = {
      id: 1,
      folio: data.folio,
      id_estado_pago_bh: data.id_estado_pago_bh,
      id_tipo_documento: '',
      detalle: '',
      fecha: '',
      id_usuario: dataLogin.id_usuario.toString()
    };
    const [filas, setFilas] = useState([filaPredeterminada]);

    const handleAgregarFila = () => {
      const nuevaFila = {
        id: filas.length + 1,
        folio: data.folio,
        id_estado_pago_bh: data.id_estado_pago_bh,
        id_tipo_documento: '',
        detalle: '',
        fecha: '',
        id_usuario: dataLogin.id_usuario.toString()
      };

      setFilas([...filas, nuevaFila]);
    };

    const handleInputChange = (id, campo, valor) => {
      const nuevasFilas = filas.map((fila) =>
        fila.id === id ? { ...fila, [campo]: valor } : fila
      );

      setFilas(nuevasFilas);
    };

    const handleEliminarFila = (id) => {
      if (filas.length > 1) {
        const nuevasFilas = filas.filter((fila) => fila.id !== id);
        setFilas(nuevasFilas);
      } else {
        alert("Debe agregar al menos un documento.");
      }
    };

    const handleConfirmaDocumentos = (e, filas) => {
      const esFormularioValido = validaFormularioDocumentos(filas);

      if (!esFormularioValido) {
        alert("Debe completar la información de los documentos.")
      } else {
        setSecondModalOpen(true);
        setSecondModalContent(<ConfirmaDocumentosModalContent documentos={filas} />);
      }
    };

    function ConfirmaDocumentosModalContent({ documentos }) {
      const tipoDocumentoMap = tiposDocumentos.reduce((acc, tipo) => {
        acc[tipo.id_tipo_documento] = tipo.tipo_documento;
        return acc;
      }, {});

      const documentosConTipo = documentos.map(doc => {
        return {
          ...doc,
          tipo_documento: tipoDocumentoMap[doc.id_tipo_documento]
        };
      });

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Confirmar Documentos</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5">¿Está seguro que desea ingresar los siguientes documentos?:</p>
              <table className="table table-hover table-sm mb-0">
                <thead>
                  <tr className="table-active">
                    <th className="ps-2">Tipo Documento</th>
                    <th>Número</th>
                    <th className="pe-2">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {documentosConTipo.length > 0 ? (
                    documentosConTipo.map((documento, index) => (
                      <tr key={index}>
                        <td className="ps-2">{documento.tipo_documento}</td>
                        <td>{documento.detalle}</td>
                        <td className="pe-2">{documento.fecha.split('-').reverse().join('-')}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center ps-1" colSpan={3}>No se encontraron documentos asociados</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button className="btn btn-yellow" onClick={handleSubmitDocumentos}><i className="bi bi-floppy"></i> Guardar</button>
            </div>
          </div>
        </div>
      );
    }

    const handleSubmitDocumentos = async (event) => {
      event.preventDefault();

      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_documentos_bh.php`,
          {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(filas),
          }
        );

        const dataResponse = await response.json();
        if (dataResponse.message === "Documentos BH ingresados con éxito.") {
          alert("Documentos agregados al estado de pago con éxito.");

          obtenerEstadosPagoBH();

          closeSecondModal();
          closeModal();

          navigate("/dashboard", { state: dataLogin });
        } else {
          throw new Error();
        }
      } catch (error) {
        obtenerEstadosPagoBH();
      }
    }

    const validaFormularioDocumentos = (datos_documentos) => {
      return datos_documentos.every(item => {
        return item.id && item.folio && item.id_estado_pago_bh &&
          item.id_tipo_documento && item.detalle &&
          item.fecha && item.id_usuario;
      });
    };

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xxl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Detalle Estado Pago: Bomba Hormigón (BH-{data.id_estado_pago_bh}) ({data.estado_pago_estado})</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body">
            <div className="row row-cols-md-2 mb-4">
              <div className="col">
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Folio</span>
                    <span className="label">{data.folio || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Fecha Estado Pago</span>
                    <span className="label">{data.fecha_estado_pago || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Equipo</span>
                    <span className="label">{data.nombre_equipo || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Lugar de Faena</span>
                    <span className="label">{data.nombre_obra || ""}</span>
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Rut</span>
                    <span className="label">{`${formatearRut(data.rut_cliente)}` || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Cliente</span>
                    <span className="label">{data.nombre_cliente || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Cliente Final</span>
                    <span className="label">{data.nombre_cliente_final || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Email Solicitante</span>
                    <span className="label">{data.email_solicitante || ""}</span>
                  </li>
                </ul>
              </div>
            </div>
            <h5 className="mb-3">Detalle Reports</h5>
            <div className="table-responsive border rounded mb-4">
              <table className="table text-center table-sm mb-0">
                <thead>
                  <tr className="table-active border-bottom">
                    <th scope="col">N° Report</th>
                    <th scope="col">N° Equipo</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Día</th>
                    <th scope="col">Mes</th>
                    <th scope="col">M3 Bombeados</th>
                    <th scope="col">Valor M3 (UF)</th>
                    <th scope="col">Valor UF Total</th>
                    <th scope="col">Valor UF</th>
                    <th scope="col">V.T. Bombeo Neto</th>
                    <th scope="col">Vittech</th>
                    <th scope="col">Valor Traslado BH</th>
                    <th scope="col">Sobre Estadía</th>
                  </tr>
                </thead>
                <tbody>
                  {estadoPagoReportsBH ? (
                    estadoPagoReportsBH.map((reportBH, index) => (
                      <tr key={index}>
                        <td>{reportBH.id_report_bh}</td>
                        <td>{reportBH.bomba}</td>
                        <td>{reportBH.fecha_report}</td>
                        <td>{capitalizeFirstLetter(reportBH.dia)}</td>
                        <td>{capitalizeFirstLetter(reportBH.mes)}</td>
                        <td>{reportBH.m3_bombeados}</td>
                        <td>{reportBH.valor_m3}</td>
                        <td>{reportBH.valor_uf_total}</td>
                        <td><small className="text-secondary">$</small> {parseFloat(reportBH.valor_uf).toLocaleString('es-CL', { useGrouping: true })}</td>
                        <td><small className="text-secondary">$</small> {parseFloat(reportBH.valor_total_bombeo_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                        <td>{reportBH.aditivo}</td>
                        <td>{reportBH.valor_traslado_bomba_uf}</td>
                        <td>{reportBH.sobre_estadia_hora.substring(0, 5)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center ps-1" colSpan={12}>No se encontraron reports asociados</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs mx-auto">
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === 'resumen' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('resumen')}>Resumen</a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === 'valores' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('valores')}>Valores</a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === 'documentos' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('documentos')}>Documentos</a>
                  </li>
                </ul>
              </div>
              <div className="card-body p-0">
                <div className="tab-content">
                  <div className={`tab-pane p-3 ${activeTab === 'resumen' ? 'active' : ''}`}>
                    <div className="d-flex justify-content-md-between align-items-md-center mb-3">
                      <h5 className="mb-0">Resumen Facturación</h5>
                      <div className="d-inline-flex align-items-center gap-2">
                        <label className="form-label mb-0">Fecha Facturación</label>
                        <input
                          className="form-control form-date-width"
                          type="date"
                          name="fecha_facturacion"
                          max={today.toISOString().split('T')[0]} // El máximo es el día de hoy
                          value={jsonPIGT && jsonPIGT.length > 0 && jsonPIGT[0]?.Fecha ? jsonPIGT[0].Fecha.split('T')[0] : ''} // Verificas el primer objeto y formateas la fecha
                          onChange={handleDateFacturacionChange}
                        />
                      </div>
                    </div>

                    {detalleEquipos.map((item, index) => (
                      <div key={index} className="border rounded mb-3">
                        <div className="row g-0">
                          <div className="col-md-8">
                            <ul className="list-group list-group-flush rounded-start border-end">
                              <li className="list-group-item fw-semibold">
                                Arriendo de Bomba Hormigón N° {item.numero_equipo}, Obra: {data.nombre_obra}<br />
                                {item.total_m3_bombeados} M3 Bombeados<br />
                                {item.total_m3_valor_uf} Total UF {Number(item.total_sobre_estadia) > 0 ? "+ Sobrestadia " + Number(item.total_sobre_estadia).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""} {Number(item.total_aditivo) > 0 ? "+ Vittech " + Number(item.total_aditivo).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""} {Number(item.total_traslado_bomba) > 0 ? "+ Traslado Bomba " + Number(item.total_traslado_bomba).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""} - Según report {new Date(item.fecha_report).toLocaleString('es-CL', { month: 'long' })} {new Date(item.fecha_report).getFullYear()}
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-4">
                            <ul className="list-group list-group-flush rounded-end">
                              <li className="list-group-item d-flex flex-column justify-content-center align-items-center pt-3">
                                <span className="form-label fw-semibold text-dark mb-0">Total</span>
                                <span className="label">
                                  <small className="text-secondary">$ </small>
                                  <span className="fs-5">{Number(item.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className={`tab-pane p-3 ${activeTab === 'valores' ? 'active' : ''}`}>
                    <div className="row row-cols-md-2">
                      <div className="col">
                        <h5 className="mb-3">Detalle</h5>
                        <ul className="list-group">
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">M3 Bombeados ({esServicioMensual ? <span className="fw-bold text-dark">Servicio Mensual: {data.m3_bombeado_uf || ""}</span> : <span className="fw-bold text-dark">{data.m3_bombeado_uf || ""}</span>})</span>
                            <span className="label"><small className="text-secondary">$ </small>{Number(data.m3_bombeado_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">Vittech (<span className="fw-bold text-dark">{data.aditivo_uf || ""}</span>)</span>
                            <span className="label"><small className="text-secondary">$ </small>{Number(data.aditivo_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">Valor Traslado Bomba (<span className="fw-bold text-dark">{data.valor_traslado_bomba_uf || ""}</span>)</span>
                            <span className="label"><small className="text-secondary">$ </small>{Number(data.valor_traslado_bomba).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">Sobre Estadia (<span className="fw-bold text-dark">{data.sobre_estadia_uf || ""}</span>)</span>
                            <span className="label"><small className="text-secondary">$ </small>{Number(data.sobre_estadia_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                          </li>
                        </ul>
                      </div>
                      <div className="col">
                        <h5 className="mb-3">Totales</h5>
                        <ul className="list-group">
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">Total Neto</span>
                            <span className="label">
                              <small className="text-secondary">$ </small>{Number(data.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">IVA</span>
                            <span className="label">
                              <small className="text-secondary">$ </small>{Number(data.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                            </span>
                          </li>
                          {Number(data.otros_descuentos) > 0 ? (
                            <li className="list-group-item">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="form-label mb-0">Descuentos</span>
                                <span className="label">
                                  <small className="text-red">- $ </small><span className="text-red">{Number(data.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                                </span>
                              </div>
                              <div className="border rounded table-active bg-body-secondary py-1 px-2">
                                <small>{data.detalle_otros_descuentos || ""}</small>
                              </div>
                            </li>
                          ) : (
                            <li className="list-group-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="form-label mb-0">Descuentos</span>
                                <span className="label">
                                  <small className="text-secondary">$ </small>0
                                </span>
                              </div>
                            </li>
                          )}
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0"><span className="fw-bold text-dark">Total Facturado</span></span>
                            <span className="label">
                              <small className="text-secondary">$ </small><span className="fs-5 text-dark">{Number(data.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane ${activeTab === 'documentos' ? 'active' : ''}`}>
                    <div className="d-flex justify-content-lg-between align-items-center p-3">
                      <h5 className="mb-0">Documentos Asociados</h5>
                      <div className="d-inline-flex gap-2">
                        <button type="button" className="btn btn-outline-dark btn-sm" onClick={handleAgregarFila}>
                          <i className="bi bi-plus-circle"></i> Agregar
                        </button>
                        <button type="button" className="btn btn-dark btn-sm" onClick={(e) => handleConfirmaDocumentos(e, filas)}>
                          <i className="bi bi-floppy"></i> Guardar
                        </button>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm table-hover mb-0">
                        <thead>
                          <tr className="table-active border-top border-bottom">
                            <th className="ps-3">Tipo Documento</th>
                            <th>Número</th>
                            <th className="pe-3">Fecha</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {estadoPagoDocumentosBH.length > 0 ? (
                            estadoPagoDocumentosBH.map((documento, index) => (
                              <tr key={index}>
                                <td className="ps-3">{documento.tipo_documento}</td>
                                <td>{documento.detalle}</td>
                                <td>{documento.fecha_detalle}</td>
                                <td className="pe-3"></td>
                              </tr>
                            ))
                          ) : (
                            <tr></tr>
                          )}
                          {filas.map((fila) => (
                            <tr key={fila.id}>
                              <td className="ps-3">
                                <select className="form-select form-select-sm" value={fila.id_tipo_documento} onChange={(e) => handleInputChange(fila.id, 'id_tipo_documento', e.target.value)}>
                                  <option value="">Seleccione Tipo de Documento</option>
                                  {tiposDocumentos.map((tipo_documento, index) => (
                                    <option key={index} value={tipo_documento.id_tipo_documento}>{tipo_documento.tipo_documento}</option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <input
                                  className="form-control form-control-sm"
                                  type="text"
                                  value={fila.detalle}
                                  onChange={(e) =>
                                    handleInputChange(fila.id, 'detalle', e.target.value)
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control form-control-sm"
                                  type="date"
                                  value={fila.fecha}
                                  onChange={(e) =>
                                    handleInputChange(fila.id, 'fecha', e.target.value)
                                  }
                                />
                              </td>
                              <td className="pe-3">
                                <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id)}>
                                  <i className="bi bi-trash3"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {dataLogin.id_perfil === 1 && (
            <div className="modal-footer justify-content-lg-between">
              <button className="btn btn-outline-primary" onClick={(e) => handleVerPDFep(data, estadoPagoReportsBH, detalleEquipos)}>
                <i className="bi bi-eye"></i> Ver Documento
              </button>
              <div className="d-inline-flex flex-lg-row gap-2">
                <button className="btn btn-outline-danger" onClick={(event) => handleModificaEstado(data, '2')}><i className="bi bi-dash-circle"></i> Anular</button>
                <button className="btn btn-outline-dark" onClick={(event) => handleEnviaEP(data, estadoPagoReportsBH, detalleEquipos)}><i className="bi bi-send"></i> Enviar</button>
                <button className="btn btn-yellow" onClick={(event) => handleModificaEstado(data, '3')} disabled={submitFacturarDisabled}><i className="bi bi-check-circle"></i> Facturar</button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  function AgregarEstadoPagoGHModalContent() {
    const [clientes, setClientes] = useState([]);
    useEffect(() => {
      obtenerClientes();
    }, []);

    const obtenerClientes = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente.php`
        );
        const data = await response.json();

        if (data && data[0].id_cliente) {
          setClientes(data);
        }
      } catch (error) {
        setClientes([]);
      }
    };

    const [clienteSelected, setClienteSelected] = useState('');
    const handleClienteSelect = async (clienteSelected) => {
      setClienteSelected(clienteSelected.value);
      await obtenerClienteObra(clienteSelected.value);

      setEstadoPagoData({
        ...dataEstadoPago,
        ["id_cliente_ep"]: clienteSelected.value,
        ["id_cliente_final_ep"]: clienteSelected.value,
        ["id_usuario"]: dataLogin.id_usuario
      });
    };

    const optionsClientes = clientes.map((cliente) => ({
      value: cliente.id_cliente,
      label: cliente.nombre_cliente,
    }));

    const handleObraSelect = async (obraSelected) => {
      await obtenerFolios(obraSelected);

      setDataConsultaReports({
        ...dataConsultaReports,
        ["id_obra_ep"]: obraSelected,
      });

      setEstadoPagoData({
        ...dataEstadoPago,
        ["id_obra_ep"]: obraSelected,
      });
    };

    const [clienteObra, setclienteObra] = useState([]);
    const obtenerClienteObra = async (cliente) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cliente_obra.php?id_cliente=${cliente}`
        );
        const data = await response.json();

        if (data && data[0].id_obra) {
          setclienteObra(data);
        }
      } catch (error) {

        setclienteObra([]);
      }
    };

    const [folios, setFolios] = useState([]);
    const obtenerFolios = async (obra) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/cabecera_cotizacion.php?id_obra=${obra}&id_maquinaria=2`
        );
        const data = await response.json();

        if (data && data[0].folio) {
          setFolios(data);
        }
      } catch (error) {
        setFolios([]);
        //alert("No hay Folios para mostrar.");
      }
    };

    const [dataEstadoPago, setEstadoPagoData] = useState({
      folio_ep: "",
      id_obra_ep: "",
      id_cliente_ep: "",
      id_cliente_final_ep: "",
      horas_trabajadas_cantidad: "",
      horas_trabajadas_valor: "",
      horas_trabajadas_valor_total: "",
      otros_descuentos_ep: 0,
      detalle_otros_descuentos_ep: "",
      total_neto: "",
      iva: "",
      total: "",
      id_usuario: ""
    });

    const handleFormEstadoPagoData = (e) => {
      const { name, value } = e.target;

      setEstadoPagoData({
        ...dataEstadoPago,
        [name]: value,
      });

      setDataConsultaReports({
        ...dataConsultaReports,
        [name]: value,
      });
    };

    const [dataConsultaReports, setDataConsultaReports] = useState({
      id_obra_ep: "",
      folio_ep: "",
      fecha_desde_ep: "",
      fecha_hasta_ep: ""
    });

    const [dataReports, setDataReports] = useState([]);
    const [horasTrabajadasValor, setHorasTrabajadasValor] = useState(0.00);
    const handleSubmitBuscarReports = async (event) => {
      event.preventDefault();

      try {
        const esFormularioValido = validaFormulario();

        if (esFormularioValido) {
          setDataReportsGH({});
          setCheckboxStates({});
          setSelectAll(false);

          const idObra = dataConsultaReports.id_obra_ep;
          const folio = dataConsultaReports.folio_ep;
          const fechaDesde = dataConsultaReports.fecha_desde_ep;
          const fechaHasta = dataConsultaReports.fecha_hasta_ep;

          const response = await fetch(
            `${config.apiBaseUrl}/estado_pago_gh.php?id_obra=${idObra}&folio=${folio}&fecha_desde=${fechaDesde}&fecha_hasta=${fechaHasta}`
          );
          const data = await response.json();

          if (data && data[0].id_report_gh) {
            const resultadoFormateado = data.map(item => {
              const fechaReportFormateada = `${item.fecha_report.split('-')[2]}-${item.fecha_report.split('-')[1]}-${item.fecha_report.split('-')[0]}`;

              const SalidaBodega = new Date(`${fechaReportFormateada}T${item.hora_salida_bodega}`);
              const LlegadaBodega = new Date(`${fechaReportFormateada}T${item.hora_llegada_bodega}`);
              const inicioColacion = new Date(`${fechaReportFormateada}T${item.hora_inicio_colacion}`);
              const terminoColacion = new Date(`${fechaReportFormateada}T${item.hora_termino_colacion}`);

              // Verifica si la hora de llegada es menor que la de salida (indica que es al día siguiente)
              if (LlegadaBodega < SalidaBodega) {
                LlegadaBodega.setDate(LlegadaBodega.getDate() + 1);
              }

              // Verifica si el inicio de colación es menor que la salida (indica que es al día siguiente)
              if (inicioColacion < SalidaBodega) {
                inicioColacion.setDate(inicioColacion.getDate() + 1);
              }

              // Verifica si el término de colación es menor que la salida (indica que es al día siguiente)
              if (terminoColacion < SalidaBodega) {
                terminoColacion.setDate(terminoColacion.getDate() + 1);
              }

              let horasTotalesFormateadas;
              let horasMananaFormateadas = "00:00:00";
              let horasTardeFormateadas = "00:00:00";

              if (item.hora_inicio_colacion === "00:00:00" && item.hora_termino_colacion === "00:00:00") {
                // No se tomó colación, calcular horas totales entre SalidaBodega y LlegadaBodega
                const horasTrabajadasTotales = (LlegadaBodega - SalidaBodega) / 3600000;
                const horasFinales = Math.floor(horasTrabajadasTotales);
                const minutosFinales = Math.floor((horasTrabajadasTotales - horasFinales) * 60);
                const segundosFinales = Math.floor(((horasTrabajadasTotales - horasFinales) * 60 - minutosFinales) * 60);
                horasTotalesFormateadas = `${String(horasFinales).padStart(2, '0')}:${String(minutosFinales).padStart(2, '0')}:${String(segundosFinales).padStart(2, '0')}`;
              } else {
                const horasTrabajadasManana = (inicioColacion - SalidaBodega) / 3600000;
                const horasManana = Math.floor(horasTrabajadasManana);
                const minutosManana = Math.floor((horasTrabajadasManana - horasManana) * 60);
                const segundosManana = Math.floor(((horasTrabajadasManana - horasManana) * 60 - minutosManana) * 60);
                horasMananaFormateadas = `${String(horasManana).padStart(2, '0')}:${String(minutosManana).padStart(2, '0')}:${String(segundosManana).padStart(2, '0')}`;

                const horasTrabajadasTarde = (LlegadaBodega - terminoColacion) / 3600000;
                const horasTarde = Math.floor(horasTrabajadasTarde);
                const minutosTarde = Math.floor((horasTrabajadasTarde - horasTarde) * 60);
                const segundosTarde = Math.floor(((horasTrabajadasTarde - horasTarde) * 60 - minutosTarde) * 60);
                horasTardeFormateadas = `${String(horasTarde).padStart(2, '0')}:${String(minutosTarde).padStart(2, '0')}:${String(segundosTarde).padStart(2, '0')}`;

                const minutosTotales = (horasTrabajadasManana + horasTrabajadasTarde) * 60;
                const horasFinales = Math.floor(minutosTotales / 60);
                const minutosFinales = minutosTotales % 60;
                horasTotalesFormateadas = `${String(horasFinales).padStart(2, '0')}:${String(minutosFinales).padStart(2, '0')}:00`;
              }

              //Obtener día y mes report
              const partesFecha = item.fecha_report.split('-');
              const date = new Date(`${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}`);

              const diasSemana = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
              const nombreMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

              const diaSemana = diasSemana[date.getDay()];
              const nombreMes = nombreMeses[date.getMonth()];

              return {
                id_report_gh: item.id_report_gh,
                numero: item.numero,
                fecha_report: item.fecha_report,
                dia: diaSemana,
                mes: nombreMes,
                requiere_traslado_grua: item.requiere_movilizacion_grua,
                requiere_traslado_contrapeso: item.requiere_traslado_contrapeso,
                hora_salida_bodega: item.hora_salida_bodega,
                hora_llegada_faena: item.hora_llegada_faena,
                hora_termino_faena: item.hora_termino_faena,
                hora_llegada_bodega: item.hora_llegada_bodega,
                minimo_horas: item.minimo_horas,
                hora_inicio_colacion: item.hora_inicio_colacion,
                hora_termino_colacion: item.hora_termino_colacion,
                horas_manana: horasMananaFormateadas,
                horas_tarde: horasTardeFormateadas,
                total_horas_trabajadas: horasTotalesFormateadas
              };
            });

            const resultadoFinal = resultadoFormateado.map(item => ({
              id_report_gh: item.id_report_gh,
              numero: item.numero,
              fecha_report: item.fecha_report,
              dia: item.dia,
              mes: item.mes,
              requiere_traslado_grua: item.requiere_traslado_grua,
              requiere_traslado_contrapeso: item.requiere_traslado_contrapeso,
              hora_salida_bodega: item.hora_salida_bodega,
              hora_llegada_faena: item.hora_llegada_faena,
              hora_termino_faena: item.hora_termino_faena,
              hora_llegada_bodega: item.hora_llegada_bodega,
              minimo_horas: item.minimo_horas,
              hora_inicio_colacion: item.hora_inicio_colacion,
              hora_termino_colacion: item.hora_termino_colacion,
              horas_manana: item.horas_manana,
              horas_tarde: item.horas_tarde,
              total_horas_trabajadas: item.total_horas_trabajadas
            }));

            setDataReports(resultadoFinal);

            setHorasTrabajadasValor(data[0].valor_horas_trabajadas);

            //Consulta otros servicios asociados desde cotización
            const responseServicios = await fetch(
              `${config.apiBaseUrl}/detalle_cotizacion.php?folio_rbh=${folio}`
            );

            const dataServicios = await responseServicios.json();

            if (dataServicios && dataServicios[0].id_servicio) {
              setServiciosEstadoPagoData(dataServicios);

              const serviciosConGlosa = dataServicios.filter(servicio => servicio.glosa_servicio !== "");
              setServiciosAsignadosData(serviciosConGlosa);

              const primerServicioSinGlosa = dataServicios.find(servicio => servicio.glosa_servicio === "") || {};
              setValorMinimoHorasData(primerServicioSinGlosa.cantidad_minima);
            }

          } else {
            setDataReports([]);
          }
        }
      } catch (error) {
        alert("No se encontró información para los filtros indicados.");
      }
    }

    const [dataReportsGH, setDataReportsGH] = useState({});
    const [checkboxStates, setCheckboxStates] = useState({});
    const [serviciosAsignadosData, setServiciosAsignadosData] = useState([]);
    const [serviciosEstadoPagoData, setServiciosEstadoPagoData] = useState([]);
    const [valorMinimoHorasData, setValorMinimoHorasData] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const toggleCheckbox = (index, isChecked, id_report_gh, requiere_traslado_grua, requiere_traslado_contrapeso, hora_inicio_manana, hora_termino_manana, total_horas_manana, hora_inicio_tarde, hora_termino_tarde, total_horas_tarde, total_horas_trabajadas) => {
      setCheckboxStates(prevState => {
        const newState = {
          ...prevState,
          [index]: !prevState[index]
        };

        setDataReportsGH(prevData => {
          const updatedData = { ...prevData };
          if (isChecked) {
            // Si el checkbox está marcado, actualizar los datos como de costumbre
            updatedData[id_report_gh] = {
              ...updatedData[id_report_gh],
              ["id_report_gh"]: id_report_gh,
              ["requiere_traslado_grua"]: requiere_traslado_grua,
              ["requiere_traslado_contrapeso"]: requiere_traslado_contrapeso,
              ["hora_inicio_manana"]: hora_inicio_manana,
              ["hora_termino_manana"]: hora_termino_manana,
              ["total_horas_manana"]: total_horas_manana,
              ["hora_inicio_tarde"]: hora_inicio_tarde,
              ["hora_termino_tarde"]: hora_termino_tarde,
              ["total_horas_tarde"]: total_horas_tarde,
              ["total_horas"]: total_horas_trabajadas
            };
          } else {
            // Si el checkbox está desmarcado, eliminar el elemento correspondiente
            delete updatedData[id_report_gh];
          }
          return updatedData;
        });

        return newState;
      });
    };

    //Checkbox seleccionar todos los reports GH
    const handleSelectAll = () => {
      const newSelectAll = !selectAll;
      setSelectAll(newSelectAll);

      dataReports.forEach((item, index) => {
        const isChecked = newSelectAll;
        if (checkboxStates[index] !== isChecked) {
          toggleCheckbox(
            index,
            isChecked,
            item.id_report_gh,
            item.requiere_traslado_grua,
            item.requiere_traslado_contrapeso,
            item.hora_llegada_faena,
            item.hora_inicio_colacion,
            item.horas_manana,
            item.hora_termino_colacion,
            item.hora_termino_faena,
            item.horas_tarde,
            item.total_horas_trabajadas
          );
        }
      });
    };

    function convertirHoraADecimal(hora) {
      const partes = hora.split(':');
      const horas = parseInt(partes[0]);
      const minutos = parseInt(partes[1]) / 60;
      const segundos = parseInt(partes[2]) / 3600;
      return horas + minutos + segundos;
    }

    useEffect(() => {
      const suma = Object.values(dataReportsGH).reduce(
        (accumulator, item) => {
          let totalHoras = convertirHoraADecimal(item.total_horas);

          totalHoras = totalHoras < Number(valorMinimoHorasData) ? Number(valorMinimoHorasData) : totalHoras;

          accumulator.traslados_grua += parseFloat(item.requiere_traslado_grua);
          accumulator.traslados_contrapesos += parseFloat(item.requiere_traslado_contrapeso);
          accumulator.total_horas += parseFloat(totalHoras);

          return accumulator;
        },
        { traslados_grua: 0, traslados_contrapesos: 0, total_horas: 0 }
      );

      const sumaServicios = Object.values(serviciosAsignadosData).reduce(
        (accumulator, item) => {
          // Si el id_servicio es 73 (Traslado Contrapesos), se suman los traslados
          if (item.id_servicio === 73) {
            item.cantidad_minima = Number(suma.traslados_contrapesos);
            item.valor_total = Number(suma.traslados_contrapesos) * Math.floor(item.valor_unitario_neto);
          }

          // Si el id_servicio es 74 (Traslado Grúa), se suman los traslados
          if (item.id_servicio === 74) {
            item.cantidad_minima = Number(suma.traslados_grua);
            item.valor_total = Number(suma.traslados_grua) * Math.floor(item.valor_unitario_neto);
          }

          // Si el id_servicio es 75 (Ayudante Grúa), se suman las horas trabajadas
          if (item.id_servicio === 75) {
            item.cantidad_minima = Number(suma.total_horas).toFixed(2);
            item.valor_total = Number(suma.total_horas).toFixed(2) * Math.floor(item.valor_unitario_neto);
          }

          accumulator.valor_total += parseFloat(item.valor_total);
          return accumulator;
        },
        { valor_total: 0 }
      );

      let hhTrabValor = Math.trunc(horasTrabajadasValor).toLocaleString('es-ES', { useGrouping: true }).replace('.', '');

      const nuevoArreglo = Object.entries(dataReportsGH).map(([id, item]) => ({
        total_horas_trabajadas: suma.total_horas,
        horas_trabajadas_valor: Number(hhTrabValor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        horas_trabajadas_valor_total: Number(Number(suma.total_horas) * Number(hhTrabValor)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        total_neto: Number(Number(Number(suma.total_horas) * Number(hhTrabValor)) + Number(sumaServicios.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        iva: Number(Number(Number(Number(suma.total_horas) * Number(hhTrabValor)) + Number(sumaServicios.valor_total)) * 0.19).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'),
        total: Number(Number(Number(Number(suma.total_horas) * Number(hhTrabValor)) + Number(sumaServicios.valor_total)) * 1.19).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')
      }));

      const resultadosUnicos = Array.from(
        new Set(nuevoArreglo.map(JSON.stringify)),
        JSON.parse
      );

      setDataTotales(resultadosUnicos);

      setTotalNetoInicial(0);

      setEstadoPagoData({
        ...dataEstadoPago,
        ["horas_trabajadas_cantidad"]: suma.total_horas.toFixed(2),
        ["horas_trabajadas_valor"]: Number(horasTrabajadasValor),
        ["horas_trabajadas_valor_total"]: Number(Number(suma.total_horas) * Number(horasTrabajadasValor)),
        ["total_neto"]: Number(Number(Number(suma.total_horas) * Number(horasTrabajadasValor)) + Number(sumaServicios.valor_total)),
        ["iva"]: Number(Number(Number(Number(suma.total_horas) * Number(horasTrabajadasValor)) + Number(sumaServicios.valor_total)) * 0.19),
        ["total"]: Number(Number(Number(Number(suma.total_horas) * Number(horasTrabajadasValor)) + Number(sumaServicios.valor_total)) * 1.19)
      });
    }, [dataReportsGH, serviciosAsignadosData]);

    const handleAgregarServicio = (folio_ep) => {
      setSecondModalOpen(true);
      setSecondModalContent(<AgregarServicioModalContent folio={folio_ep} />);
    };

    const [dataTotales, setDataTotales] = useState({
      total_horas_trabajadas: 0,
      horas_trabajadas_cantidad: 0,
      horas_trabajadas_valor: 0,
      horas_trabajadas_valor_total: 0,
      total_neto: 0,
      iva: 0,
      total: 0
    });

    const [dataOtrosDescuentos, setOtrosDescuentos] = useState(0);
    const [dataTotalNetoInicial, setTotalNetoInicial] = useState(0);
    const handleOtrosDescuentos = (otro_descuento, total_neto_valor) => {
      if (/^\d*$/.test(otro_descuento)) {
        const nuevoDescuento = Number(otro_descuento) || 0;
        setOtrosDescuentos(nuevoDescuento);

        dataEstadoPago.otros_descuentos_ep = nuevoDescuento;

        if (dataTotalNetoInicial === 0) {
          const totalNeto = Number(total_neto_valor.replace(/\./g, ''));
          setTotalNetoInicial(totalNeto);

          let totalNetoMostrado = nuevoDescuento === 0 ? totalNeto : totalNeto - nuevoDescuento;
          dataTotales[0].total_neto = totalNetoMostrado.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
          dataTotales[0].iva = Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
          dataTotales[0].total = Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');

          setEstadoPagoData({
            ...dataEstadoPago,
            ["total_neto"]: Number(totalNetoMostrado),
            ["iva"]: Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')),
            ["total"]: Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, ''))
          });
        } else {
          let totalNetoConDescuento = dataTotalNetoInicial - nuevoDescuento;
          let totalNetoMostrado = nuevoDescuento === 0 ? dataTotalNetoInicial : totalNetoConDescuento;
          dataTotales[0].total_neto = totalNetoMostrado.toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/,/g, '.');
          dataTotales[0].iva = Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');
          dataTotales[0].total = Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.');

          setEstadoPagoData({
            ...dataEstadoPago,
            ["total_neto"]: Number(totalNetoMostrado),
            ["iva"]: Number(Number(totalNetoMostrado * 0.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, '')),
            ["total"]: Number(Number(totalNetoMostrado * 1.19).toLocaleString('es-ES', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\./g, ''))
          });
        }
      }
    };

    function AgregarServicioModalContent({ folio }) {
      useEffect(() => {
        obtenerServicios(folio);
      }, []);

      const [servicios, setServicios] = useState([]);
      const obtenerServicios = async (folio) => {
        try {
          const response = await fetch(
            `${config.apiBaseUrl}/estado_pago_gh.php?folio=${folio}`
          );
          const data = await response.json();

          if (data && data[0].folio) {
            setServicios(data);
          }
        } catch (error) {
          setServicios([]);
        }
      };

      const [checkboxStates, setCheckboxStates] = useState({});
      const [formServiciosData, setFormServiciosData] = useState({});
      const toggleCheckbox = (index, id_servicio, glosa_servicio, cantidad_minima, id_unidad_medida, valor_unitario_neto) => {
        setCheckboxStates((prevState) => {
          const newState = {
            ...prevState,
            [index]: !prevState[index],
          };

          setOtrosDescuentos(0);

          setEstadoPagoData({
            ...dataEstadoPago,
            ["otros_descuentos_ep"]: 0,
            ["detalle_otros_descuentos_ep"]: ""
          });

          setFormServiciosData((prevData) => {
            if (!newState[index]) {
              setDataReports(prevReports =>
                prevReports.map(servicio =>
                  servicio.index === index
                    ? { ...servicio, id_servicio: id_servicio, glosa_servicio: glosa_servicio, cantidad_minima: cantidad_minima, id_unidad_medida: id_unidad_medida, valor_unitario_neto: valor_unitario_neto }
                    : servicio
                )
              );

              const { [index]: _, ...restData } = prevData;
              return restData;
            }

            return {
              ...prevData,
              [index]: {
                ...prevData[index],
                ["id_servicio"]: id_servicio,
                ["glosa_servicio"]: glosa_servicio,
                ["cantidad_minima"]: cantidad_minima,
                ["id_unidad_medida"]: id_unidad_medida,
                ["valor_unitario_neto"]: valor_unitario_neto,
                ["valor_total"]: 0
              },
            };
          });

          return newState;
        });
      };

      useEffect(() => {
        const nuevoArreglo = Object.keys(formServiciosData).map(key => {
          const item = formServiciosData[key];

          return {
            id_servicio: item.id_servicio,
            glosa_servicio: item.glosa_servicio,
            cantidad_minima: item.cantidad_minima,
            id_unidad_medida: item.id_unidad_medida,
            valor_unitario_neto: Number(item.valor_unitario_neto),
            valor_total: Number(item.cantidad_minima) * Number(item.valor_unitario_neto),
            id_usuario: dataLogin.id_usuario
          };
        });

        const resultadosUnicos = Array.from(
          new Set(nuevoArreglo.map(JSON.stringify)),
          JSON.parse
        );

        setServiciosAsignadosData(resultadosUnicos);

        setTotalNetoInicial(0);

      }, [formServiciosData]);

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Agregar Servicio: Grúa Hidráulica</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <div className="table-responsive">
                <table className="table table-hover mb-0">
                  <thead>
                    <tr className="table-active">
                      <th scope="col"></th>
                      <th scope="col">Servicio</th>
                      <th scope="col">Cantidad Mínima</th>
                      <th scope="col">Unidad Medida</th>
                      <th scope="col">Valor Unitario Neto más IVA</th>
                    </tr>
                  </thead>
                  <tbody>
                    {servicios.length > 0 ? (
                      servicios.map((servicio, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={checkboxStates[index] || false}
                              onChange={() => toggleCheckbox(index, servicio.id_servicio, servicio.glosa_servicio, servicio.cantidad_minima, servicio.id_unidad_medida, servicio.valor_unitario_neto)}
                            />
                          </td>
                          <td>{servicio.glosa_servicio}</td>
                          <td>{servicio.cantidad_minima}</td>
                          <td>{servicio.unidad_medida}</td>
                          <td><small className="text-secondary">$ </small>{Number(servicio.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center ps-1" colSpan={5}>No se encontraron servicios</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-yellow" onClick={closeSecondModal}>Cerrar</button>
            </div>
          </div>
        </div>
      );
    }

    const navigate = useNavigate();
    const handleSubmitEstadoPagoGH = async (event) => {
      event.preventDefault();

      try {
        const esFormularioValido = validaFormularioSubmit();

        if (Object.keys(dataReportsGH).length === 0) {
          alert('Debe agregar al menos un report');
        } else if (esFormularioValido) {
          const response = await fetch(
            `${config.apiBaseUrl}/estado_pago_gh.php`,
            {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(dataEstadoPago),
            }
          );

          const dataResponse = await response.json();
          if (dataResponse.message === "Estado de pago agregado con éxito.") {
            const estadoPagoReports = Object.keys(dataReportsGH).reduce((acc, key) => {
              if (typeof dataReportsGH[key] === 'object') {
                acc[key] = { ...dataReportsGH[key], id_estado_pago_gh: dataResponse.id_estado_pago_gh, id_usuario: dataLogin.id_usuario };
              } else {
                acc[key] = dataReportsGH[key];
              }
              return acc;
            }, {});

            const responseReports = await fetch(
              `${config.apiBaseUrl}/estado_pago_reports_gh.php`,
              {
                method: "POST",
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(estadoPagoReports),
              }
            );

            const dataResponseReports = await responseReports.json();
            if (dataResponseReports.message === "Reports de estado de pago agregados con éxito.") {
              const serviciosAsignadosEstadoPagoGH = serviciosEstadoPagoData.map(item => ({
                ...item,
                id_estado_pago_gh: dataResponse.id_estado_pago_gh,
                id_usuario: dataLogin.id_usuario
              }));

              const responseServicios = await fetch(
                `${config.apiBaseUrl}/estado_pago_servicios_gh.php`,
                {
                  method: "POST",
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(serviciosAsignadosEstadoPagoGH),
                }
              );

              const dataResponseServicios = await responseServicios.json();
              if (dataResponseServicios.message === "Servicios de estado de pago agregados con éxito.") {
                const responseReportsActualizados = await fetch(
                  `${config.apiBaseUrl}/report_gh.php`,
                  {
                    method: "PUT",
                    headers: {
                      'Accept': 'application/json', // Indica que esperas una respuesta JSON
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataReportsGH),
                  }
                );

                const dataResponseReportsActualizados = await responseReportsActualizados.json();
                if (dataResponseReportsActualizados.message === "Reports de estado de pago actualizados con éxito.") {
                  setEstadoPagoData({
                    folio_ep: "",
                    id_obra_ep: "",
                    id_cliente_ep: "",
                    id_cliente_final_ep: "",
                    horas_trabajadas_cantidad: "",
                    horas_trabajadas_valor: "",
                    horas_trabajadas_valor_total: "",
                    otros_descuentos_ep: "",
                    detalle_otros_descuentos_ep: "",
                    total_neto: "",
                    iva: "",
                    total: "",
                    id_usuario: ""
                  });

                  setDataReportsGH([]);
                  setServiciosAsignadosData([]);

                  alert("Estado de pago agregado con éxito.");

                  navigate("/dashboard", { state: dataLogin });

                  closeModal();
                }
              }
            }
          } else {
            throw new Error();
          }
        }
      } catch (error) {
        alert(error);
      }
    }

    const validaFormulario = () => {
      if (clienteSelected === "") {
        alert('Debe seleccionar un cliente');
        return false;
      }

      if (dataEstadoPago.folio_ep.trim() === '') {
        alert('Debe seleccionar un folio');
        return false;
      }

      if (dataConsultaReports.fecha_desde_ep.trim() === '') {
        alert('Debe indicar una fecha desde');
        return false;
      }

      if (dataConsultaReports.fecha_hasta_ep.trim() === '') {
        alert('Debe indicar una fecha hasta');
        return false;
      }

      return true;
    }

    const validaFormularioSubmit = () => {
      if (clienteSelected === "") {
        alert('Debe seleccionar un cliente');
        return false;
      }

      if (dataEstadoPago.folio_ep.trim() === '') {
        alert('Debe seleccionar un folio');
        return false;
      }

      if (dataConsultaReports.fecha_desde_ep.trim() === '') {
        alert('Debe indicar una fecha desde');
        return false;
      }

      if (dataConsultaReports.fecha_hasta_ep.trim() === '') {
        alert('Debe indicar una fecha hasta');
        return false;
      }

      if (dataEstadoPago.otros_descuentos_ep !== 0) {
        if (dataEstadoPago.detalle_otros_descuentos_ep.trim() === '') {
          alert('Debe indicar el detalle de otros descuentos, de lo contrario su valor debe ser 0');
          return false;
        }
      }

      return true;
    }

    // Inicializa los tooltips
    useEffect(() => {
      // Verifica si Bootstrap está disponible en window
      if (typeof window.bootstrap !== 'undefined') {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new window.bootstrap.Tooltip(tooltipTriggerEl);
        });
      }
    }, [dataReports]);

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xxl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Agregar Estado de Pago: Grúa Hidráulica</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body py-3 px-5">
            <div className="row row-cols-lg-4 mb-3">
              <div className="col">
                <label className="form-label">Cliente</label>
                <Select
                  name="id_cliente_ep"
                  value={clienteSelected.value}
                  onChange={handleClienteSelect}
                  options={optionsClientes}
                  isSearchable
                  className="react-select"
                  placeholder="Seleccione un cliente"
                />
              </div>
              <div className="col">
                <label className="form-label">Obra</label>
                <select className="form-select" name="id_obra_ep" value={dataConsultaReports.id_obra_ep} onChange={(e) => handleObraSelect(e.target.value)}>
                  <option value="">Seleccione una obra</option>
                  {clienteObra.map((obra, index) => (
                    <option key={index} value={obra.id_obra}>{obra.nombre}</option>
                  ))}
                </select>
              </div>
              <div className="col">
                <label className="form-label">Cliente Final</label>
                <select className="form-select" name="id_cliente_final_ep" value={dataEstadoPago.id_cliente_final_ep} disabled>
                  <option value="">Seleccione un cliente final</option>
                  {optionsClientes.map((cliente_final, index) => (
                    <option key={index} value={cliente_final.value}>{cliente_final.label}</option>
                  ))}
                </select>
              </div>
              {folios ? (
                <div className="col">
                  <label className="form-label">Folio</label>
                  <select className="form-select" name="folio_ep" value={dataEstadoPago.folio_ep} onChange={handleFormEstadoPagoData}>
                    <option value="">Seleccione un folio</option>
                    {folios.map((folio, index) => (
                      <option key={index} value={folio.folio}>{folio.folio} {folio.equipo !== "null null" ? "(" + folio.equipo + ")" : ""}</option>
                    ))}
                  </select>
                </div>
              ) : (
                <div className="col">
                  <label className="form-label">Folio</label>
                  <select className="form-select" name="folio_ep">
                    <option value="">No se encontraron folios</option>
                  </select>
                </div>
              )}
            </div>
            <div className="row row-cols-lg-4 align-items-end mb-4">
              <div className="col">
                <label className="form-label">Fecha Desde</label>
                <input
                  className="form-control"
                  type="date"
                  name="fecha_desde_ep"
                  value={dataConsultaReports.fecha_desde_ep}
                  max={today.toISOString().split('T')[0]}
                  onChange={(e) => setDataConsultaReports({
                    ...dataConsultaReports,
                    fecha_desde_ep: e.target.value
                  })}
                />
              </div>
              <div className="col">
                <label className="form-label">Fecha Hasta</label>
                <input
                  className="form-control"
                  type="date"
                  name="fecha_hasta_ep"
                  value={dataConsultaReports.fecha_hasta_ep}
                  max={today.toISOString().split('T')[0]}
                  onChange={(e) => setDataConsultaReports({
                    ...dataConsultaReports,
                    fecha_hasta_ep: e.target.value
                  })}
                />
              </div>
              <div className="col">
                <label className="form-label d-block">&nbsp;</label>
                <button className="btn btn-dark" onClick={handleSubmitBuscarReports}>
                  <i className="bi bi-search"></i> Buscar
                </button>
              </div>
            </div>
            <h5 className="mb-3">Detalle Reports</h5>
            <div className="table-responsive border rounded mb-4">
              <table className="table table-hover table-sm text-center mb-0">
                <thead>
                  <tr className="border-bottom">
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col" className="border-end"></th>
                    <th scope="col" className="border-end" colSpan={3}>Mañana</th>
                    <th scope="col" className="border-end" colSpan={3}>Tarde</th>
                    <th scope="col"></th>
                  </tr>
                  <tr className="table-active border-bottom">
                    <th scope="col">
                      {dataReports.length > 0 ? (
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAll}
                          />
                        </div>
                      ) : (
                        <span></span>
                      )}
                    </th>
                    <th scope="col">N° Report</th>
                    <th scope="col">N° Equipo</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Día</th>
                    <th scope="col">Mes</th>
                    <th scope="col">Hora Inicio</th>
                    <th scope="col">Hora Término</th>
                    <th scope="col">Horas Mañana</th>
                    <th scope="col">Hora Inicio</th>
                    <th scope="col">Hora Término</th>
                    <th scope="col">Horas Tarde</th>
                    <th scope="col">
                      Total Horas&nbsp;
                      <small data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Indica mínimo" title="Indica mínimo">
                        <i className="bi bi-info-circle text-secondary"></i>
                      </small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dataReports.length > 0 ? (
                    dataReports.map((report, index) => (
                      <tr key={index}>
                        <td>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={checkboxStates[index] || false}
                              onChange={(e) => toggleCheckbox(index, e.target.checked, report.id_report_gh, report.requiere_traslado_grua, report.requiere_traslado_contrapeso, report.hora_llegada_faena, report.hora_inicio_colacion, report.horas_manana, report.hora_termino_colacion, report.hora_llegada_bodega, report.horas_tarde, report.total_horas_trabajadas)}
                            />
                          </div>
                        </td>
                        <td>{report.id_report_gh}</td>
                        <td>{report.numero}</td>
                        <td>{report.fecha_report}</td>
                        <td>{report.dia}</td>
                        <td>{report.mes}</td>
                        <td>{report.hora_salida_bodega.substring(0, 5)}</td>
                        <td>{report.hora_inicio_colacion.substring(0, 5)}</td>
                        <td>{report.horas_manana.substring(0, 5)}</td>
                        <td>{report.hora_termino_colacion.substring(0, 5)}</td>
                        <td>{report.hora_llegada_bodega.substring(0, 5)}</td>
                        <td>{report.horas_tarde.substring(0, 5)}</td>
                        <td>
                          {report.total_horas_trabajadas.substring(0, 5)}&nbsp;
                          {report.total_horas_trabajadas.substring(0, 5) < report.minimo_horas.substring(0, 5) && (
                            <small data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={report.minimo_horas.substring(0, 5)} title={report.minimo_horas.substring(0, 5)}>
                              <i className="bi bi-info-circle text-secondary"></i>
                            </small>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center ps-1" colSpan={13}>No se encontraron reports</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-7">
                <div className="d-flex justify-content-between mb-3">
                  <h5 className="mb-0">Total Descripción</h5>
                </div>
                <div className="table-responsive border rounded">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr className="table-active border-bottom">
                        <th className="col-6 ps-2">Descripción</th>
                        <th className="col-2">Cantidad</th>
                        <th className="col-2">Valor</th>
                        <th className="col-2 pe-2">Valor Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataTotales.length > 0 ? (
                        <tr>
                          <td className="ps-2">Horas Trabajadas</td>
                          <td>{dataTotales[0].total_horas_trabajadas.toFixed(2)}</td>
                          <td><small className="text-secondary">$ </small>{dataTotales[0].horas_trabajadas_valor}</td>
                          <td className="pe-2"><small className="text-secondary">$ </small>{dataTotales[0].horas_trabajadas_valor_total}</td>
                        </tr>
                      ) : (
                        <tr>
                          <td className="ps-2">Horas Trabajadas</td>
                          <td>0.00</td>
                          <td><small className="text-secondary">$ </small>0</td>
                          <td className="pe-2"><small className="text-secondary">$ </small>0</td>
                        </tr>
                      )}
                      {serviciosAsignadosData.length > 0 && (
                        serviciosAsignadosData.map((servicio, index) => {
                          if (servicio.id_servicio === 75) { //Ayudante Diario
                            return (
                              <tr key={index}>
                                <td className="ps-2">{servicio.glosa_servicio}</td>
                                <td>{dataTotales.length > 0 ? dataTotales[0].total_horas_trabajadas.toFixed(2) : servicio.cantidad_minima}</td>
                                <td><small className="text-secondary">$ </small>{Number(servicio.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                                <td className="pe-2"><small className="text-secondary">$ </small>{Number(servicio.valor_total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                              </tr>
                            );
                          } else {
                            return (
                              <tr key={index}>
                                <td className="ps-2">{servicio.glosa_servicio}</td>
                                <td>{Number(servicio.cantidad_minima).toFixed(2)}</td>
                                <td><small className="text-secondary">$ </small>{Number(servicio.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                                <td className="pe-2"><small className="text-secondary">$ </small>{Number(servicio.valor_total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</td>
                              </tr>
                            );
                          }
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-md-5">
                <h5 className="mb-3">Valores Totales</h5>
                <div className="table-responsive border rounded mb-4">
                  <table className="table table-sm mb-0">
                    <thead>
                      <tr className="table-active border-bottom">
                        <th scope="col" className="ps-2">Total Neto</th>
                        <th scope="col">IVA</th>
                        <th scope="col" className="text-dark fw-semibold pe-2">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataTotales.length > 0 ? (
                        <tr>
                          <td className="ps-2"><small className="text-secondary">$ </small>{dataTotales[0].total_neto}</td>
                          <td><small className="text-secondary">$ </small>{dataTotales[0].iva}</td>
                          <td className="pe-2"><small className="text-secondary">$ </small><span className="text-orange">{dataTotales[0].total}</span></td>
                        </tr>
                      ) : (
                        <tr>
                          <td className="ps-2"><small className="text-secondary">$ </small>0</td>
                          <td><small className="text-secondary">$ </small>0</td>
                          <td className="pe-2"><small className="text-secondary">$ </small><span className="text-orange">0</span></td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="row row-cols-md-2">
                  <div className="col">
                    <label className="form-label">Otros Descuentos</label>
                    {dataTotales.length > 0 ? (
                      <input
                        className="form-control"
                        type="text"
                        name="otros_descuentos_ep"
                        value={dataOtrosDescuentos}
                        onChange={(e) => handleOtrosDescuentos(e.target.value, dataTotales[0].total_neto)}
                      />
                    ) : (
                      <input
                        className="form-control"
                        type="text"
                        name="otros_descuentos_ep"
                        disabled
                      />
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Detalle Descuentos</label>
                    <input
                      className="form-control"
                      type="text"
                      name="detalle_otros_descuentos_ep"
                      value={dataEstadoPago.detalle_otros_descuentos_ep}
                      onChange={(e) => setEstadoPagoData({
                        ...dataEstadoPago,
                        ["detalle_otros_descuentos_ep"]: e.target.value
                      })}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-yellow" onClick={handleSubmitEstadoPagoGH}><i className="bi bi-floppy"></i> Guardar</button>
          </div>
        </div>
      </div>
    );
  }

  function EstadoPagoGHModalContent({ data }) {
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [estadoPagoEstado, setEstadoPagoEstado] = useState(data.id_estado_pago_estado);
    const [estadoPagoReportsGH, setEstadoPagoReportsGH] = useState([]);
    const [estadoPagoServiciosGH, setEstadoPagoServiciosGH] = useState([]);
    const [estadoPagoDocumentosGH, setEstadoPagoDocumentosGH] = useState([]);
    const [detalleCotizacion, setDetalleCotizacion] = useState([]);
    const [submitFacturarDisabled, setSubmitFacturarDisabled] = useState(true);
    //const [serviciosGH, obtenerServiciosGH] = useState([]);


    useEffect(() => {
      obtenerTiposDocumentos();
      obtenerReportsGH(data.id_estado_pago_gh);
      obtenerServiciosGH(data.id_estado_pago_gh);
      obtenerDocumentosGH(data.id_estado_pago_gh);
      obtenerDetalleCotizacion(data.folio);

      if (data.id_estado_pago_estado === 4) {
        setSubmitFacturarDisabled(false);
      }
    }, []);

    const obtenerTiposDocumentos = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/tipo_documento.php`
        );
        const data = await response.json();

        if (data && data[0].id_tipo_documento) {
          setTiposDocumentos(data);
        }
      } catch (error) {
        setTiposDocumentos([]);
      }
    };

    const obtenerDocumentosGH = async (id_estado_pago_gh) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_documentos_gh.php?id_estado_pago_gh=${id_estado_pago_gh}`
        );
        const data = await response.json();

        if (data && data[0].id_estado_pago_documentos_gh) {
          setEstadoPagoDocumentosGH(data);
        }
      } catch (error) {
        setEstadoPagoDocumentosGH([]);
      }
    };

    const obtenerDetalleCotizacion = async (folio) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/detalle_cotizacion.php?folio=${folio}`
        );
        const data = await response.json();

        if (data && data[0].id_servicio) {
          setDetalleCotizacion(data);
        }
      } catch (error) {
        setDetalleCotizacion([]);
      }
    };

    const obtenerReportsGH = async (id_estado_pago_gh) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_reports_gh.php?id_estado_pago_gh=${id_estado_pago_gh}`
        );
        const data = await response.json();

        if (data && data[0].id_estado_pago_gh) {
          setEstadoPagoReportsGH(data);
        }
      } catch (error) {
        setEstadoPagoReportsGH([]);
      }
    };

    const obtenerServiciosGH = async (id_estado_pago_gh) => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_servicios_gh.php?id_estado_pago_gh=${id_estado_pago_gh}`
        );
        const data = await response.json();

        if (data && data[0].id_estado_pago_gh) {
          setEstadoPagoServiciosGH(data);
        }
      } catch (error) {
        setEstadoPagoServiciosGH([]);
      }
    };

    //Obtiene resumen a facturar
    const [jsonPIGT, setJsonPIGT] = useState([]);
    const [detalleEquipos, setDetalleEquipos] = useState([]);

    useEffect(() => {
      if (estadoPagoReportsGH.length > 0 && detalleCotizacion.length > 0) {
        obtenerResumenFacturar();
      }
    }, [estadoPagoReportsGH, detalleCotizacion, detalleEquipos]);

    const obtenerResumenFacturar = () => {
      //JSON para PIG-T
      const objetoPIGT = (dataCotizacion, detalleCotizacion) => {
        //let fechaCotizacionFormateada = `${dataCotizacion.fecha_cotizacion.split('-')[2]}-${dataCotizacion.fecha_cotizacion.split('-')[1]}-${dataCotizacion.fecha_cotizacion.split('-')[0]}T00:00:00`;
        //const fechaHoyFormateada = new Date().toISOString().split('.')[0];
        let rutClienteFormateado = formatearRut(dataCotizacion.rut_cliente);

        //Total Horas Trabajadas valor
        const totalHorasTrabajadasValor = detalleEquipos.reduce((acc, item) => acc + item.total_horas_trabajadas_valor, 0);

        //Traslado grúa valor recargo
        const totalTrasladoGruaValor = detalleEquipos.reduce((acc, item) => acc + item.total_traslado_grua_valor, 0);

        //Traslado contrapesos valor recargo
        const totalTrasladoContrapesosValor = detalleEquipos.reduce((acc, item) => acc + item.total_traslado_contrapeso_valor, 0);

        //Suma de otros recargos, excepto traslado grua y contrapesos
        const otrosRecargos = estadoPagoServiciosGH.reduce((acc, servicio) => {
          if (servicio.id_servicio !== 73 && servicio.id_servicio !== 74) {
            return acc + parseFloat(servicio.valor_total);
          }
          return acc;
        }, 0);

        const recargo = Number(otrosRecargos) + Number(totalTrasladoGruaValor) + Number(totalTrasladoContrapesosValor);
        const afecto = Number(totalHorasTrabajadasValor) + Number(recargo);

        const detalleDocumentos = estadoPagoDocumentosGH.map(doc => {
          let tipoDocumento = doc.tipo_documento;
          let fechaDocumentoFormateada = `${doc.fecha_detalle.split('-')[2]}-${doc.fecha_detalle.split('-')[1]}-${doc.fecha_detalle.split('-')[0]}T00:00:00`;

          // Modifica el tipo de documento según corresponda
          if (doc.tipo_documento === "HES") {
            tipoDocumento = "HES (Hoja Entrada De Servicio)";
          } else if (doc.tipo_documento === "Orden de Trabajo") {
            tipoDocumento = "OT (Orden de Trabajo)";
          }
          return {
            TpoDocRef: tipoDocumento,
            FolioRef: doc.detalle,
            FechaRef: fechaDocumentoFormateada,
            RazonRef: data.folio
          };
        });

        const nuevoObjeto = [
          {
            'Folio': 0,
            'Usuario': "pamela.varas@vittamaq.cl", // Usuario de Kame
            'Documento': "Factura Electrónica",
            'Rut': rutClienteFormateado,
            'TipoDocumento': "VENTA",
            'RznSocial': dataCotizacion.razon_social.toUpperCase(),
            'Giro': dataCotizacion.giro.toUpperCase(),
            'Direccion': dataCotizacion.direccion.toUpperCase(),
            'Ciudad': dataCotizacion.ciudad.toUpperCase(),
            'Comuna': dataCotizacion.comuna.toUpperCase(),
            'Telefono': dataCotizacion.telefono_representante,
            'Email': dataCotizacion.email_solicitante,
            'Fecha': "",
            'Comentario': "FOLIO COTIZACION: " + dataCotizacion.folio,
            'FormaPago': "1",
            'Afecto': afecto,//Number(Math.round(data.total_neto)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'Exento': 0,
            'Descuento': Number(Math.round(data.otros_descuentos)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'TipoImpto1': "IVA",
            'ValorImpto1': Number(Math.round(data.iva)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'total': Number(Math.round(data.total)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, ''),
            'FechaVencimiento': "",
            'Bodega': "",//data.bodega.toUpperCase(),
            'EsInventariable': "",
            'Vendedor': data.vendedor.toUpperCase(),
            'Recargo': 0,//recargo,
            'PorcDescuento': 0,
            'PorcRecargo': 0,
            'Contacto': dataCotizacion.email_solicitante,
            'Observacion': "",
            'Comision': null,
            'FormaCredito': "",
            'FichaDireccion': "",
            'Detalle': detalleCotizacion,
            'Referencias': detalleDocumentos
          }
        ];

        return nuevoObjeto;
      };

      // Agrupar por numero de equipo
      const convertirHorasADecimales = (horas) => {
        const [hh, mm, ss] = horas.split(':').map(Number);
        return hh + (mm / 60) + (ss / 3600); // Convierte minutos y segundos a fracciones de hora
      };

      const datosDescripcionAgrupados = estadoPagoReportsGH.reduce((acc, current) => {
        const numero = current.numero;

        // Si el número de equipo no está en el acumulador, inicializa su entrada
        if (!acc[numero]) {
          acc[numero] = {
            ...current,
            total_horas: convertirHorasADecimales(current.total_horas),
          };
        } else {
          // Aseguramos que acc[numero].total_horas es un número
          acc[numero].total_horas = parseFloat(acc[numero].total_horas) + convertirHorasADecimales(current.total_horas);
        }

        // Redondea a dos decimales
        acc[numero].total_horas = acc[numero].total_horas.toFixed(2);

        return acc;
      }, {});

      // Suma los valores de 'valor_unitario_neto'
      const totalValorUnitarioNeto = estadoPagoServiciosGH.reduce((sum, item) => {
        return sum + parseFloat(item.valor_unitario_neto);
      }, 0);

      // Formatea los resultados
      const datosDescripcion = Object.values(datosDescripcionAgrupados).map(item => {
        const totalHorasTrabajadas = Number(item.total_horas).toFixed(2).replace('.', ',');
        const valorHorasTrabajadas = Number(Math.round(data.horas_trabajadas_valor) + Number(totalValorUnitarioNeto)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const totalValorHT = Number((item.total_horas < Number(8.00) ? Number(8).toFixed(2) : item.total_horas) * Math.round(data.horas_trabajadas_valor)).toLocaleString('es-ES', { useGrouping: true }).replace(/[\.,]/g, '');
        const fechaReport = new Date(item.fecha_report.split('-').reverse().join('-'));

        const requiereTrasladoGrua = item.requiere_movilizacion_grua;
        const requiereTrasladoContrapeso = item.requiere_traslado_contrapeso;

        //Valores Traslado grúa y contrapeso
        let recargoTrasladoGruaValor = 0;
        let recargoTrasladoContrapesoValor = 0;

        //Suma traslado grúa
        if (requiereTrasladoGrua) {
          recargoTrasladoGruaValor = estadoPagoServiciosGH
            .filter(servicio => servicio.id_servicio === 74)
            .reduce((acc, servicio) => {
              return acc + parseFloat(servicio.valor_total);
            }, 0);
        }

        //Suma traslado contrapeso
        if (requiereTrasladoContrapeso) {
          recargoTrasladoContrapesoValor = estadoPagoServiciosGH
            .filter(servicio => servicio.id_servicio === 73)
            .reduce((acc, servicio) => {
              return acc + parseFloat(servicio.valor_total);
            }, 0);
        }

        // Verificar si el equipo ya existe en detalleEquipos antes de agregarlo
        setDetalleEquipos(prevDetalleEquipos => {
          const existeEquipo = prevDetalleEquipos.some(detalle => detalle.numero_equipo === item.numero);

          if (!existeEquipo) {
            return [
              ...prevDetalleEquipos,
              {
                razon_social: data.razon_social,
                obra: data.nombre_obra,
                numero_equipo: item.numero,
                total_traslado_grua_valor: recargoTrasladoGruaValor,
                total_traslado_contrapeso_valor: recargoTrasladoContrapesoValor,
                total_horas_trabajadas: totalHorasTrabajadas,
                horas_trabajadas_valor: valorHorasTrabajadas,
                total_horas_trabajadas_valor: totalValorHT,
                fecha_report: fechaReport
              }
            ];
          }

          return prevDetalleEquipos; // No añadir duplicados
        });

        const totalValorHTconRecargo = Number(totalValorHT) + Number(valorHorasTrabajadas);

        return {
          "Descripcion": `ARRIENDO GRUA HIDRAULICA N° ${item.numero}`,
          "Cantidad": 1.000000,
          "PrecioUnitario": totalValorHTconRecargo,
          "Descuento": 0,
          "Total": totalValorHTconRecargo,
          "UnidadMedida": "UN",
          "UnidadNegocio": "CASA MATRIZ",
          "Articulo": "ARRIENDO GRUA HIDRAULICA",  //Si es inventariable entonces validará el sku o descripción del artículo
          "PorcDescuento": 0.00,
          "DescripcionDetallada": `ARRIENDO GRUA HIDRAULICA N° ${item.numero} - OBRA: ${data.nombre_obra.toUpperCase()}, ${totalHorasTrabajadas} ${item.total_horas < Number(8.00) ? "(MINIMO 8,00) " : ""}TOTAL HORAS, ${Number(valorHorasTrabajadas).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')} TOTAL VALOR HORAS TRABAJADAS${recargoTrasladoGruaValor > 0 ? " + TRASLADO GRUA $" + Number(Math.round(recargoTrasladoGruaValor)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""}${recargoTrasladoContrapesoValor > 0 ? " + TRASLADO CONTRAPESOS $" + Number(Math.round(recargoTrasladoContrapesoValor)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""} - SEGUN REPORT ${fechaReport.toLocaleString('es-CL', { month: 'long' }).toUpperCase()} ${fechaReport.getFullYear()}`,
          "Exento": "",
          "TipoExento": "",
          "CuentaEmpresaVenta": "",
          "TipoArticulo": "" // Campo para determinar si es campo Articulo corresponde a artículo, pack o servicio. Los valores permitidos son "", "SERVICIO", "PACK", "ARTICULO", si es vacío el campo o nulo la API lo tomará como Artículo
        };
      });

      setJsonPIGT(objetoPIGT(data, datosDescripcion));
    };

    const handleDateFacturacionChange = (event) => {
      const selectedDate = event.target.value; // Obtiene la nueva fecha seleccionada (formato YYYY-MM-DD)

      // Convertir la fecha seleccionada a formato ISO 8601 (sin fracciones de segundo)
      const newDate = new Date(selectedDate).toISOString().split('.')[0];

      // Actualizar el estado del jsonPIGT
      setJsonPIGT((prevJsonPigT) =>
        prevJsonPigT.map((item, index) =>
          index === 0
            ? { ...item, Fecha: newDate, FechaVencimiento: newDate }
            : item
        )
      );
    };

    const handleModificaEstado = (data_estado_pago, id_estado_pago_estado) => {
      if (id_estado_pago_estado === '3' && jsonPIGT[0].Fecha === "") {
        alert('Debe indicar una fecha de facturación');
        return false;
      } else {
        setEstadoPagoEstado(id_estado_pago_estado);

        setSecondModalOpen(true);

        setSecondModalContent(<ConfirmaModificaEstadoModalContent dataEstadoPago={data_estado_pago} idEstadoPagoEstado={id_estado_pago_estado} />);
      }
    };

    function ConfirmaModificaEstadoModalContent({ dataEstadoPago, idEstadoPagoEstado }) {
      const obtenerEstadoPorId = (idEstadoPagoEstado) => {
        const estadoEncontrado = estadosPagoEstado.find(estado => estado.id_estado_pago_estado === idEstadoPagoEstado);
        return estadoEncontrado ? estadoEncontrado.estado_pago_estado : 'Estado no encontrado';
      };

      const estado = obtenerEstadoPorId(Number(idEstadoPagoEstado));

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Modificar Estado: {dataEstadoPago.folio}</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5">¿Está seguro que desea modificar el estado del estado de pago a: {idEstadoPagoEstado === '2' ? <span className="text-red">{estado}</span> : <span className="text-orange">{estado}</span>} ?</p>
            </div>
            <div className="modal-footer">
              <button className={idEstadoPagoEstado === '2' ? "btn btn-danger" : "btn btn-yellow"} onClick={(e) => handleSubmitModificarEstado(e, dataEstadoPago.id_estado_pago_gh, idEstadoPagoEstado)}>
                {idEstadoPagoEstado === '2' ? (
                  <span>
                    <i className="bi bi-dash-circle"></i> Anular Estado de Pago
                  </span>
                ) : (
                  <span>
                    <i className="bi bi-check-circle"></i> Facturar Estado de Pago
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      );
    }

    const handleSubmitModificarEstado = async (event, idEstadoPagoGH, idEstadoPagoEstado) => {
      event.preventDefault();

      try {
        closeSecondModal();
        closeModal();

        if (idEstadoPagoEstado === "2") {
          const formModificarEstado = { id_estado_pago_gh: idEstadoPagoGH, id_estado_pago_estado: idEstadoPagoEstado, id_usuario_actualizacion: dataLogin.id_usuario };

          const responseModificarEstado = await fetch(
            `${config.apiBaseUrl}/estado_pago_gh.php`,
            {
              method: "PUT",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formModificarEstado),
            }
          );

          const dataModificarEstado = await responseModificarEstado.json();
          if (dataModificarEstado.message === "Estado de pago modificado con éxito.") {
            const habilitaReportsData = {
              habilita_report: 1,
              reports: estadoPagoReportsGH.map(item => ({
                id_report_gh: item.id_report_gh
              }))
            };

            const responseReportsActualizados = await fetch(
              `${config.apiBaseUrl}/report_gh.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(habilitaReportsData),
              }
            );

            const dataResponseReportsActualizados = await responseReportsActualizados.json();
            if (dataResponseReportsActualizados.message === "Report GH habilitado exitosamente.") {
              alert("Estado de pago modificado con éxito.");

              obtenerEstadosPagoGH();

              navigate("/dashboard", { state: dataLogin });
            }
          } else {
            throw new Error();
          }
        } else {
          if (jsonPIGT.length > 0) {
            const responseKame = await fetch(
              `https://app.pig-t.cl/vittamaq_Cotizaciones_Kame`,
              {
                method: "POST",
                headers: {
                  'Accept': 'application/json',
                },
                body: JSON.stringify(jsonPIGT),
              }
            );

            const dataResponseKame = await responseKame.json();

            if (dataResponseKame.phrase === "OK" && dataResponseKame.kameresponse.Estado === "Ok") {
              const fechaFacturacionFormateada = jsonPIGT[0].Fecha.split('T')[0];
              const formFolioKame = { id_estado_pago_gh: data.id_estado_pago_gh, folio_kame: dataResponseKame.kameresponse.Folio, fecha_facturacion: fechaFacturacionFormateada, id_estado_pago_estado: idEstadoPagoEstado, id_usuario_actualizacion: dataLogin.id_usuario };
              const responseActualizaFolioKame = await fetch(
                `${config.apiBaseUrl}/estado_pago_gh.php`,
                {
                  method: "PUT",
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formFolioKame),
                }
              );

              const dataActualizaFolioKame = await responseActualizaFolioKame.json();
              if (dataActualizaFolioKame.message === "Folio de Kame agregado con éxito.") {
                const facturaReportsData = estadoPagoReportsGH.map(item => ({
                  id_report_gh: item.id_report_gh,
                }));

                const responseReportsActualizados = await fetch(
                  `${config.apiBaseUrl}/report_gh.php`,
                  {
                    method: "PUT",
                    headers: {
                      'Accept': 'application/json', // Indica que esperas una respuesta JSON
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(facturaReportsData),
                  }
                );

                const dataResponseReportsActualizados = await responseReportsActualizados.json();
                if (dataResponseReportsActualizados.message === "Reports de estado de pago actualizados con éxito.") {
                  alert("Estado de pago facturado con éxito.");

                  obtenerEstadosPagoGH();

                  navigate("/dashboard", { state: dataLogin });
                }
              }
            } else {
              alert("Error al facturar el estado de pago, verifique la información.")
              throw new Error();
            }
          }

          obtenerEstadosPagoGH();

          closeSecondModal();
          closeModal();

          navigate("/dashboard", { state: dataLogin });
        }
      } catch (error) {
        obtenerEstadosPagoGH();
      }
    }

    //DOCUMENTOS
    const [activeTab, setActiveTab] = useState('resumen');
    const handleTabClick = (tab) => {
      setActiveTab(tab);
    };

    const filaPredeterminada = {
      id: 1,
      folio: data.folio,
      id_estado_pago_gh: data.id_estado_pago_gh,
      id_tipo_documento: '',
      detalle: '',
      fecha: '',
      id_usuario: dataLogin.id_usuario.toString()
    };
    const [filas, setFilas] = useState([filaPredeterminada]);

    const handleAgregarFila = () => {
      const nuevaFila = {
        id: filas.length + 1,
        folio: data.folio,
        id_estado_pago_gh: data.id_estado_pago_gh,
        id_tipo_documento: '',
        detalle: '',
        fecha: '',
        id_usuario: dataLogin.id_usuario.toString()
      };

      setFilas([...filas, nuevaFila]);
    };

    const handleInputChange = (id, campo, valor) => {
      const nuevasFilas = filas.map((fila) =>
        fila.id === id ? { ...fila, [campo]: valor } : fila
      );

      setFilas(nuevasFilas);
    };

    const handleEliminarFila = (id) => {
      if (filas.length > 1) {
        const nuevasFilas = filas.filter((fila) => fila.id !== id);
        setFilas(nuevasFilas);
      } else {
        alert("Debe agregar al menos un documento.");
      }
    };

    const handleConfirmaDocumentos = (e, filas) => {
      const esFormularioValido = validaFormularioDocumentos(filas);

      if (!esFormularioValido) {
        alert("Debe completar la información de los documentos.")
      } else {
        setSecondModalOpen(true);
        setSecondModalContent(<ConfirmaDocumentosModalContent documentos={filas} />);
      }
    };

    function ConfirmaDocumentosModalContent({ documentos }) {
      const tipoDocumentoMap = tiposDocumentos.reduce((acc, tipo) => {
        acc[tipo.id_tipo_documento] = tipo.tipo_documento;
        return acc;
      }, {});

      const documentosConTipo = documentos.map(doc => {
        return {
          ...doc,
          tipo_documento: tipoDocumentoMap[doc.id_tipo_documento]
        };
      });

      return (
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="mb-0">Confirmar Documentos</h4>
              <button onClick={closeSecondModal} className="btn-close"></button>
            </div>
            <div className="modal-body">
              <p className="fs-5">¿Está seguro que desea ingresar los siguientes documentos?:</p>
              <table className="table table-hover table-sm mb-0">
                <thead>
                  <tr className="table-active">
                    <th className="ps-2">Tipo Documento</th>
                    <th>Número</th>
                    <th className="pe-2">Fecha</th>
                  </tr>
                </thead>
                <tbody>
                  {documentosConTipo.length > 0 ? (
                    documentosConTipo.map((documento, index) => (
                      <tr key={index}>
                        <td className="ps-2">{documento.tipo_documento}</td>
                        <td>{documento.detalle}</td>
                        <td className="pe-2">{documento.fecha.split('-').reverse().join('-')}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center ps-1" colSpan={3}>No se encontraron documentos asociados</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button className="btn btn-yellow" onClick={handleSubmitDocumentos}><i className="bi bi-floppy"></i> Guardar</button>
            </div>
          </div>
        </div>
      );
    }

    const handleSubmitDocumentos = async (event) => {
      event.preventDefault();

      try {
        const response = await fetch(
          `${config.apiBaseUrl}/estado_pago_documentos_gh.php`,
          {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(filas),
          }
        );

        const dataResponse = await response.json();
        if (dataResponse.message === "Documentos GH ingresados con éxito.") {
          alert("Documentos agregados al estado de pago con éxito.");

          obtenerEstadosPagoGH();

          closeSecondModal();
          closeModal();

          navigate("/dashboard", { state: dataLogin });
        } else {
          throw new Error();
        }
      } catch (error) {
        obtenerEstadosPagoBH();
      }
    }

    const validaFormularioDocumentos = (datos_documentos) => {
      return datos_documentos.every(item => {
        return item.id && item.folio && item.id_estado_pago_gh &&
          item.id_tipo_documento && item.detalle &&
          item.fecha && item.id_usuario;
      });
    };

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xxl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Detalle Estado Pago: Grúa Hidráulica (GH-{data.id_estado_pago_gh}) ({data.estado_pago_estado})</h4>
            <button onClick={closeModal} className="btn-close"></button>
          </div>
          <div className="modal-body">
            <div className="row row-cols-md-2 mb-4">
              <div className="col">
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Folio</span>
                    <span className="label">{data.folio || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Fecha Estado Pago</span>
                    <span className="label">{data.fecha_estado_pago || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Equipo</span>
                    <span className="label">{data.nombre_equipo || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Lugar de Faena</span>
                    <span className="label">{data.nombre_obra || ""}</span>
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul className="list-group">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Rut</span>
                    <span className="label">{`${formatearRut(data.rut_cliente)}` || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Cliente</span>
                    <span className="label">{data.nombre_cliente || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Cliente Final</span>
                    <span className="label">{data.nombre_cliente_final || ""}</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="form-label mb-0">Email Solicitante</span>
                    <span className="label">{data.email_solicitante || ""}</span>
                  </li>
                </ul>
              </div>
            </div>
            <h5 className="mb-3">Detalle Reports</h5>
            <div className="table-responsive border rounded mb-4">
              <table className="table text-center table-sm mb-0">
                <thead>
                  <tr className="border-bottom">
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                    <th scope="col" className="border-end"></th>
                    <th scope="col" className="border-end" colSpan={3}>Mañana</th>
                    <th scope="col" className="border-end" colSpan={3}>Tarde</th>
                    <th scope="col"></th>
                  </tr>
                  <tr className="table-active border-bottom">
                    <th scope="col">N° Report</th>
                    <th scope="col">N° Equipo</th>
                    <th scope="col">Fecha</th>
                    <th scope="col">Día</th>
                    <th scope="col">Mes</th>
                    <th scope="col">Hora Inicio</th>
                    <th scope="col">Hora Término</th>
                    <th scope="col">Horas Mañana</th>
                    <th scope="col">Hora Inicio</th>
                    <th scope="col">Hora Término</th>
                    <th scope="col">Horas Tarde</th>
                    <th scope="col">Total Horas</th>
                  </tr>
                </thead>
                <tbody>
                  {estadoPagoReportsGH ? (
                    //let feriados = 0
                    estadoPagoReportsGH.map((reportGH, index) => (
                      //feriados += reportGH.feriado
                      <tr key={index}>
                        <td>{reportGH.id_report_gh}</td>
                        <td>{reportGH.numero}</td>
                        <td>{reportGH.fecha_report}</td>
                        <td>{capitalizeFirstLetter(reportGH.dia)}</td>
                        <td>{capitalizeFirstLetter(reportGH.mes)}</td>
                        <td>{reportGH.hora_inicio_manana.substring(0, 5)}</td>
                        <td>{reportGH.hora_termino_manana.substring(0, 5)}</td>
                        <td>{reportGH.total_horas_manana.substring(0, 5)}</td>
                        <td>{reportGH.hora_inicio_tarde.substring(0, 5)}</td>
                        <td>{reportGH.hora_termino_tarde.substring(0, 5)}</td>
                        <td>{reportGH.total_horas_tarde.substring(0, 5)}</td>
                        <td>{reportGH.total_horas.substring(0, 5)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="text-center ps-1" colSpan={12}>No se encontraron reports asociados</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="card">
              <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs mx-auto">
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === 'resumen' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('resumen')}>Resumen</a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === 'valores' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('valores')}>Valores</a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === 'documentos' ? 'nav-link active' : 'nav-link'}`} onClick={() => handleTabClick('documentos')}>Documentos</a>
                  </li>
                </ul>
              </div>
              <div className="card-body p-0">
                <div className="tab-content">
                  <div className={`tab-pane p-3 ${activeTab === 'resumen' ? 'active' : ''}`}>
                    <div className="d-flex justify-content-md-between align-items-md-center mb-3">
                      <h5 className="mb-0">Resumen Facturación</h5>
                      <div className="d-inline-flex align-items-center gap-2">
                        <label className="form-label mb-0">Fecha Facturación</label>
                        <input
                          className="form-control form-date-width"
                          type="date"
                          name="fecha_facturacion"
                          max={today.toISOString().split('T')[0]}
                          value={jsonPIGT && jsonPIGT.length > 0 && jsonPIGT[0]?.Fecha ? jsonPIGT[0].Fecha.split('T')[0] : ''}
                          onChange={handleDateFacturacionChange}
                        />
                      </div>
                    </div>
                    {detalleEquipos.map((item, index) => (
                      <div key={index} className="border rounded mb-3">
                        <div className="row g-0">
                          <div className="col-md-8">
                            <ul className="list-group list-group-flush rounded-start border-end">
                              <li className="list-group-item fw-semibold">
                                Arriendo de Grúa Hidráulica N° {item.numero_equipo}, Obra: {data.nombre_obra}<br />
                                {item.total_horas_trabajadas} {Number(item.total_horas_trabajadas.replace(",", ".")) < Number(8.00) ? "(Mínimo 8,00)" : ""} Horas Trabajadas<br />
                                {Number(item.total_horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')} Total Valor{Number(item.total_traslado_grua_valor) > 0 ? " + Traslado Grúa " + Number(item.total_traslado_grua_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""}{Number(item.total_traslado_contrapeso_valor) > 0 ? " + Traslado Contrapesos " + Number(item.total_traslado_contrapeso_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') : ""} - Según report {new Date(item.fecha_report).toLocaleString('es-CL', { month: 'long' })} {new Date(item.fecha_report).getFullYear()}
                              </li>
                            </ul>
                          </div>
                          <div className="col-md-4">
                            <ul className="list-group list-group-flush rounded-end">
                              <li className="list-group-item d-flex flex-column justify-content-center align-items-center pt-3">
                                <span className="form-label fw-semibold text-dark mb-0">Total</span>
                                <span className="label">
                                  <small className="text-secondary">$ </small>
                                  <span className="fs-5">{Number(item.total_horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}</span>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className={`tab-pane p-3 ${activeTab === 'valores' ? 'active' : ''}`}>
                    <div className="row row-cols-md-2">
                      <div className="col">
                        <h5 className="mb-3">Detalle</h5>
                        <ul className="list-group">
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0 flex-fill">Horas Trabajadas (<span className="fw-bold text-dark">{data.horas_trabajadas_cantidad || ""}</span> * {Number(Math.round(data.horas_trabajadas_valor)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""})</span>
                            <span className="label">
                              <small className="text-secondary">$ </small>{Number(Math.round(data.horas_trabajadas_valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                            </span>
                          </li>
                          {estadoPagoServiciosGH && estadoPagoServiciosGH.length > 0 && estadoPagoServiciosGH.map((servicioGH, index) => (
                            <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                              <span className="form-label mb-0">{servicioGH.nombre_servicio} (<span className="fw-bold text-dark">{servicioGH.cantidad_minima}</span> * {Number(Math.round(servicioGH.valor_unitario_neto)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')})</span>
                              <span className="label text-nowrap">
                                <small className="text-secondary">$ </small>{Number(Math.round(servicioGH.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.')}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col">
                        <h5 className="mb-3">Totales</h5>
                        <ul className="list-group">
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">Total Neto</span>
                            <span className="label">
                              <small className="text-secondary">$ </small>{Number(Math.round(data.total_neto)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0">IVA</span>
                            <span className="label">
                              <small className="text-secondary">$ </small>{Number(Math.round(data.iva)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}
                            </span>
                          </li>
                          {Number(data.otros_descuentos) > 0 ? (
                            <li className="list-group-item">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="form-label mb-0">Descuentos</span>
                                <span className="label">
                                  <small className="text-red">- $ </small><span className="text-red">{Number(Math.round(data.otros_descuentos)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                                </span>
                              </div>
                              <div className="border rounded table-active bg-body-secondary py-1 px-2">
                                <small>{data.detalle_otros_descuentos || ""}</small>
                              </div>
                            </li>
                          ) : (
                            <li className="list-group-item">
                              <div className="d-flex justify-content-between align-items-center">
                                <span className="form-label mb-0">Descuentos</span>
                                <span className="label">
                                  <small className="text-secondary">$ </small>0
                                </span>
                              </div>
                            </li>
                          )}
                          <li className="list-group-item d-flex justify-content-between align-items-center">
                            <span className="form-label mb-0"><span className="fw-bold text-dark">Total Facturado</span></span>
                            <span className="label">
                              <small className="text-secondary">$ </small><span className="fs-5 text-dark">{Number(Math.round(data.total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.') || ""}</span>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className={`tab-pane ${activeTab === 'documentos' ? 'active' : ''}`}>
                    <div className="d-flex justify-content-lg-between align-items-center p-3">
                      <h5 className="mb-0">Documentos Asociados</h5>
                      <div className="d-inline-flex gap-2">
                        <button type="button" className="btn btn-outline-dark btn-sm" onClick={handleAgregarFila}>
                          <i className="bi bi-plus-circle"></i> Agregar
                        </button>
                        <button type="button" className="btn btn-dark btn-sm" onClick={(e) => handleConfirmaDocumentos(e, filas)}>
                          <i className="bi bi-floppy"></i> Guardar
                        </button>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-sm table-hover mb-0">
                        <thead>
                          <tr className="table-active border-top border-bottom">
                            <th className="ps-3">Tipo Documento</th>
                            <th>Número</th>
                            <th className="pe-3">Fecha</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {estadoPagoDocumentosGH.length > 0 ? (
                            estadoPagoDocumentosGH.map((documento, index) => (
                              <tr key={index}>
                                <td className="ps-3">{documento.tipo_documento}</td>
                                <td>{documento.detalle}</td>
                                <td>{documento.fecha_detalle}</td>
                                <td className="pe-3"></td>
                              </tr>
                            ))
                          ) : (
                            <tr></tr>
                          )}
                          {filas.map((fila) => (
                            <tr key={fila.id}>
                              <td className="ps-3">
                                <select className="form-select form-select-sm" value={fila.id_tipo_documento} onChange={(e) => handleInputChange(fila.id, 'id_tipo_documento', e.target.value)}>
                                  <option value="">Seleccione Tipo de Documento</option>
                                  {tiposDocumentos.map((tipo_documento, index) => (
                                    <option key={index} value={tipo_documento.id_tipo_documento}>{tipo_documento.tipo_documento}</option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <input
                                  className="form-control form-control-sm"
                                  type="text"
                                  value={fila.detalle}
                                  onChange={(e) =>
                                    handleInputChange(fila.id, 'detalle', e.target.value)
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  className="form-control form-control-sm"
                                  type="date"
                                  value={fila.fecha}
                                  onChange={(e) =>
                                    handleInputChange(fila.id, 'fecha', e.target.value)
                                  }
                                />
                              </td>
                              <td className="pe-3">
                                <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id)}>
                                  <i className="bi bi-trash3"></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {dataLogin.id_perfil === 1 && (
            <div className="modal-footer justify-content-lg-between">
              <button className="btn btn-outline-primary" onClick={(e) => handleVerPDFep(data, estadoPagoReportsGH, detalleEquipos, estadoPagoServiciosGH)}>
                <i className="bi bi-eye"></i> Ver Documento
              </button>
              <div className="d-inline-flex flex-lg-row gap-2">
                <button className="btn btn-outline-danger" onClick={(event) => handleModificaEstado(data, '2')}><i className="bi bi-dash-circle"></i> Anular</button>
                <button className="btn btn-outline-dark" onClick={(event) => handleEnviaEP(data, estadoPagoReportsGH, detalleEquipos, estadoPagoServiciosGH)}><i className="bi bi-send"></i> Enviar</button>
                <button className="btn btn-yellow" onClick={(event) => handleModificaEstado(data, '3')} disabled={submitFacturarDisabled}><i className="bi bi-check-circle"></i> Facturar</button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  const navigate = useNavigate();

  // Ver documento PDF  
  const handleVerPDFep = (data, reports, detalleEquipos, estadoPagoServicios) => {
    setSecondModalOpen(true);
    setSecondModalContent(<VerPDFepModalContent datos={data} reports={reports} detalle_equipos={detalleEquipos} detalle_servicios={estadoPagoServicios} />);
  };

  function VerPDFepModalContent({ datos, reports, detalle_equipos, detalle_servicios = [] }) {
    console.info('detalle_equipos: ', detalle_equipos)
    const [pdfBase64, setPdfBase64] = useState('');

    const obtenerFechaHoy = (fechaStr) => {
      let fecha;

      if (fechaStr) {
        // Divido el string en partes: dd-mm-yyyy
        const [dia, mes, año] = fechaStr.split('-');
        // Ojo: en JS los meses van de 0 a 11
        fecha = new Date(año, mes - 1, dia);
      } else {
        fecha = new Date();
      }

      const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
      return fecha.toLocaleDateString('es-ES', opciones);
    };

    const obtenerFechaMasReciente = (report) => {
      const masReciente = report.reduce((max, item) => {
        const [dia, mes, año] = item.fecha_report.split('-');
        const fecha = new Date(año, mes - 1, dia);

        if (!max || fecha > max.fecha) {
          return { ...item, fecha };
        }
        return max;
      }, null);

      // Formateamos la fecha encontrada al estilo "31 de julio de 2025"
      const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
      return masReciente.fecha.toLocaleDateString('es-ES', opciones);
    };

    const fechaEP = obtenerFechaHoy(datos.fecha_estado_pago);

    const fechaUltimoReport = reports.length > 0 ? obtenerFechaMasReciente(reports) : fechaEP

    useEffect(() => {
      const generatePDF = async () => {
        try {
          const existingPdfBytes = await fetch(
            `${config.apiBaseUrl}/obtienePlantillaEP.php?id_maquinaria=${datos.id_maquinaria}`
          ).then((res) => res.arrayBuffer());

          const pdfDoc = await PDFDocument.load(existingPdfBytes);

          // Obtener el formulario del PDF
          const form = pdfDoc.getForm();

          // Fecha Estado Pago
          let fechaActual = new Date();
          const formatDate = (date) => {
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear().toString();
            return `${day}-${month}-${year}`;
          };

          const fechaEP = obtenerFechaHoy(datos.fecha_estado_pago);

          // Cabecera Estado Pago
          form.getTextField('Rut_Cliente').setText(formatearRut(datos.rut_cliente));
          form.getTextField('Razon_Social').setText(datos.razon_social.toUpperCase());
          form.getTextField('Giro_Cliente').setText(datos.giro.toUpperCase());
          form.getTextField('Direccion_Cliente').setText(datos.direccion.toUpperCase());
          form.getTextField('Obra_Cliente').setText(datos.nombre_obra.toUpperCase());
          form.getTextField('Direccion_Obra').setText(datos.direccion.toUpperCase() + " (" + datos.ciudad.toUpperCase() + ")");
          form.getTextField('Folio').setText(datos.folio.toUpperCase());
          form.getTextField('Fecha_EP').setText(fechaEP);
          form.getTextField('Contacto').setText(datos.nombre_contacto.toUpperCase());
          form.getTextField('Cargo_Contacto').setText(datos.cargo.toUpperCase());
          form.getTextField('Telefono_Contacto').setText(datos.telefono);
          form.getTextField('Email_Contacto').setText(datos.email);

          // Equipo Cotizado
          if (datos.id_maquinaria === 1) {
            const totalBombeoNeto = reports.reduce(
              (sum, item) => sum + parseFloat(item.valor_total_bombeo_neto),
              0
            );

            form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_bh.toString());
            form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
            form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase());
            form.getTextField('Aditivo').setText("VITTECH");
            form.getTextField('Aditivo_Valor_UF').setText(Number(datos.aditivo_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Aditivo_Valor_Neto').setText("$ " + Number(datos.aditivo_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_Traslado_Bomba').setText("VALOR TRASLADO BOMBA");
            form.getTextField('Valor_Traslado_Bomba_UF').setText(Number(datos.valor_traslado_bomba_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_Traslado_Bomba_Neto').setText("$ " + Number(datos.valor_traslado_bomba).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Sobre_Estadia').setText("SOBRE ESTADIA");
            form.getTextField('Sobre_Estadia_UF').setText(Number(datos.sobre_estadia_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Sobre_Estadia_Neto').setText("$ " + Number(datos.sobre_estadia_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_Total_Neto').setText("$ " + Number(totalBombeoNeto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
          } else if (datos.id_maquinaria === 2) {
            form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_gh.toString());
            form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} - ${datos.nombre_equipo.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
            form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase());

            //Totales Horas
            const sumTotalHoras = () => {
              const totalMinutes = reports.reduce((acc, item) => {
                const [hours, minutes] = item.total_horas.split(":").map(Number);
                return acc + hours * 60 + minutes;
              }, 0);

              // Convertir a formato HH:MM
              const totalHours = Math.floor(totalMinutes / 60);
              const totalMinutesRemainder = totalMinutes % 60;
              const totalHorasHHMM = `${String(totalHours).padStart(2, "0")}:${String(totalMinutesRemainder).padStart(2, "0")}`;

              // Convertir a decimal
              const totalHorasDecimal = (totalMinutes / 60).toFixed(2);

              return {
                totalHorasHHMM,
                totalHorasDecimal: parseFloat(totalHorasDecimal),
              };
            };

            const horasTotales = sumTotalHoras();
            form.getTextField('Horas_Totales_HHMM').setText(horasTotales.totalHorasHHMM.toString());
            form.getTextField('Horas_Totales_Decimal').setText(horasTotales.totalHorasDecimal.toString());

          } else if (datos.id_maquinaria === 3) {
            const cantidadMinimaGT = detalle_servicios.find(s => s.id_servicio === 208)?.cantidad_minima ?? 220;
            form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_gt.toString());
            form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} - ${datos.nombre_equipo.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
            form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase() + " - " + datos.nombre_equipo.toUpperCase());
            form.getTextField('Horas_Incluidas_Operador').setText(datos.horas_incluidas_operador.toString());
            form.getTextField('Horas_Adicionales_Operador').setText(datos.horas_adicionales_operador.toString());
            form.getTextField('Valor_Hora_Adicional_Operador').setText(datos.valor_hora_adicional_uf_operador.toString());
            form.getTextField('Valor_Hora_Adicional_SD_Operador').setText(datos.horas_adicionales_domingos_festivos_operador.toString());
            form.getTextField('Valor_Hora_Adicional_UF_Operador').setText(Number(datos.valor_hora_adicional_domingos_festivos_uf_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_UF_Fecha_Facturacion').setText("$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_Total_HH_Adicionales_Operador').setText("$ " + Number(datos.valor_total_horas_adicionales_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Horas_Incluidas_Grua').setText(datos.horas_incluidas_grua.toString());
            form.getTextField('Horas_Adicionales_Grua').setText(datos.horas_adicionales_grua.toString());
            form.getTextField('Valor_Hora_Adicional_Grua').setText(datos.valor_hora_adicional_uf_grua.toString());
            form.getTextField('Valor_Total_HH_Adicionales_Grua').setText("$ " + Number(Math.round(datos.horas_adicionales_grua * datos.valor_hora_adicional_uf_grua * datos.valor_uf_fecha_facturacion)).toLocaleString('es-ES', { useGrouping: true }));
            form.getTextField('Valor_Total_HH_Adicionales_UF_Grua').setText("$ " + Number(datos.horas_adicionales_grua * datos.valor_hora_adicional_uf_grua).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

            //Totales Horas
            const sumTotalHoras = () => {
              const totalMinutes = reports.reduce((acc, item) => {
                const [hours, minutes] = item.total_horas.split(":").map(Number);
                return acc + hours * 60 + minutes;
              }, 0);

              // Convertir a formato HH:MM
              const totalHours = Math.floor(totalMinutes / 60);
              const totalMinutesRemainder = totalMinutes % 60;
              const totalHorasHHMM = `${String(totalHours).padStart(2, "0")}:${String(totalMinutesRemainder).padStart(2, "0")}`;

              // Convertir a decimal
              const totalHorasDecimal = (totalMinutes / 60).toFixed(2);

              return {
                totalHorasHHMM,
                totalHorasDecimal: parseFloat(totalHorasDecimal),
              };
            };

            const horasTotales = sumTotalHoras();
            form.getTextField('Horas_Totales_HHMM').setText(horasTotales.totalHorasHHMM.toString());
            form.getTextField('Horas_Totales_Decimal').setText(horasTotales.totalHorasDecimal.toString());

            // Fecha y UF Hoy
            const fechaEEPP = fechaUltimoReport ? fechaUltimoReport : obtenerFechaHoy()
            form.getTextField('Fecha_Hoy').setText("VALOR UF AL " + fechaEEPP.toUpperCase());
            form.getTextField('UF_Dia').setText(
              "$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            );

            // Valor total horas adicionales UF
            const HHAdicionalesOperadorUF = (Number(datos.valor_total_horas_adicionales_operador) / indicadorUF).toFixed(2).replace('.', ',');
            const HHAdicionalesGruaUF = (Number(datos.valor_total_horas_adicionales_grua) / indicadorUF).toFixed(2).replace('.', ',');

            form.getTextField('Valor_Total_HH_Adicionales_UF_Operador').setText(HHAdicionalesOperadorUF.toString());
            // form.getTextField('Valor_Total_HH_Adicionales_UF_Grua').setText(HHAdicionalesGruaUF.toString());

            // Días y horas del mes
            function obtenerDiasDelMes(fecha) {
              const [dia, mes, anio] = fecha.split("-").map(Number);

              const ultimoDia = new Date(anio, mes, 0).getDate();

              return ultimoDia;
            }
            // A trabajar Mes
            const diasDelMes = obtenerDiasDelMes(datos.fecha_estado_pago);

            if (reports.length > 0) form.getTextField('Dias_Trabajar_Mes').setText(reports[0].dias_mes.toString()); else form.getTextField('Dias_Trabajar_Mes').setText('');

            form.getTextField('Horas_Trabajar_Mes_OP').setText('180');
            form.getTextField('Horas_Trabajar_Mes_GT').setText(String(parseInt(cantidadMinimaGT)));

            // Trabajado Mes
            // form.getTextField('Dias_Trabajado_Mes_OP').setText(String(Math.ceil(reports[0].dias_facturables)));
            // form.getTextField('Dias_Trabajado_Mes_GT').setText(String(Math.ceil(reports[0].dias_facturables)));
            if (reports.length > 0) form.getTextField('Dias_Trabajado_Mes_OP').setText(diasEntreFechas(reports[0].fecha_report, reports[reports.length-1].fecha_report).toString()); else form.getTextField('Dias_Trabajado_Mes_OP').setText('0')
            if (reports.length > 0) form.getTextField('Dias_Trabajado_Mes_GT').setText(diasEntreFechas(reports[0].fecha_report, reports[reports.length-1].fecha_report).toString()); else form.getTextField('Dias_Trabajado_Mes_GT').setText('0');

            form.getTextField('Horas_Trabajado_Mes_OP').setText(horasTotales.totalHorasDecimal.toString());
            form.getTextField('Horas_Trabajado_Mes_GT').setText(datos.horas_incluidas_grua.toString());//.setText((reports[0].horas_facturables_grua).toString());

            // Valores UF Operador y Grúa
            form.getTextField('Valor_UF_Operador').setText(Number(datos.valor_operador_uf).toString());
            form.getTextField('Valor_UF_Grua').setText(Number(datos.valor_grua_uf).toString());
          } else {
            form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_gt.toString());
            form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} - ${datos.nombre_equipo.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
            form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase() + " - " + datos.nombre_equipo.toUpperCase());
            form.getTextField('Horas_Incluidas_Operador').setText(datos.horas_incluidas_operador.toString());
            form.getTextField('Horas_Adicionales_Operador').setText(datos.horas_adicionales_operador.toString());
            form.getTextField('Valor_Hora_Adicional_Operador').setText(datos.valor_hora_adicional_uf_operador.toString());
            form.getTextField('Valor_Hora_Adicional_SD_Operador').setText(datos.horas_adicionales_domingos_festivos_operador.toString());
            form.getTextField('Valor_Hora_Adicional_UF_Operador').setText(Number(datos.valor_hora_adicional_domingos_festivos_uf_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_UF_Fecha_Facturacion').setText("$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Valor_Total_HH_Adicionales_Operador').setText("$ " + Number(datos.valor_total_horas_adicionales_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
            form.getTextField('Horas_Incluidas_Grua').setText(datos.horas_incluidas_grua.toString());
            form.getTextField('Horas_Adicionales_Grua').setText(datos.horas_adicionales_grua.toString());
            form.getTextField('Valor_Hora_Adicional_Grua').setText(datos.valor_hora_adicional_uf_grua.toString());
            form.getTextField('Valor_Total_HH_Adicionales_Grua').setText("$ " + Number(datos.valor_total_horas_adicionales_grua).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

            //Totales Horas
            const sumTotalHoras = () => {
              const totalMinutes = reports.reduce((acc, item) => {
                const [hours, minutes] = item.total_horas.split(":").map(Number);
                return acc + hours * 60 + minutes;
              }, 0);

              // Convertir a formato HH:MM
              const totalHours = Math.floor(totalMinutes / 60);
              const totalMinutesRemainder = totalMinutes % 60;
              const totalHorasHHMM = `${String(totalHours).padStart(2, "0")}:${String(totalMinutesRemainder).padStart(2, "0")}`;

              // Convertir a decimal
              const totalHorasDecimal = (totalMinutes / 60).toFixed(2);

              return {
                totalHorasHHMM,
                totalHorasDecimal: parseFloat(totalHorasDecimal),
              };
            };

            const horasTotales = sumTotalHoras();
            form.getTextField('Horas_Totales_HHMM').setText(horasTotales.totalHorasHHMM.toString());
            form.getTextField('Horas_Totales_Decimal').setText(horasTotales.totalHorasDecimal.toString());

            // Fecha y UF Hoy
            const fechaEEPP = fechaUltimoReport ? fechaUltimoReport : obtenerFechaHoy()
            form.getTextField('Fecha_Hoy').setText("VALOR UF AL " + fechaEEPP.toUpperCase());
            form.getTextField('UF_Dia').setText(
              "$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            );

            // Valor total horas adicionales UF
            const HHAdicionalesOperadorUF = (Number(datos.valor_total_horas_adicionales_operador) / indicadorUF).toFixed(2).replace('.', ',');
            const HHAdicionalesGruaUF = (Number(datos.valor_total_horas_adicionales_grua) / indicadorUF).toFixed(2).replace('.', ',');

            form.getTextField('Valor_Total_HH_Adicionales_UF_Operador').setText(HHAdicionalesOperadorUF.toString());
            form.getTextField('Valor_Total_HH_Adicionales_UF_Grua').setText(HHAdicionalesGruaUF.toString());

            // Días y horas del mes
            function obtenerDiasDelMes(fecha) {
              const [dia, mes, anio] = fecha.split("-").map(Number);

              const ultimoDia = new Date(anio, mes, 0).getDate();

              return ultimoDia;
            }

            const diasDelMes = obtenerDiasDelMes(datos.fecha_estado_pago);
            if (reports.length > 0) form.getTextField('Dias_Trabajar_Mes').setText(reports[0].dias_mes.toString()); else form.getTextField('Dias_Trabajar_Mes').setText('');

            function obtenerHorasSemanales() {
              const diasPorSemana = 7;
              const horasPorDia = 24;
              return diasPorSemana * horasPorDia;
            }

            const horasSemanales = obtenerHorasSemanales();
            form.getTextField('Horas_Trabajar_Mes').setText(horasSemanales.toString());

            // Valores UF Operador y Grúa
            form.getTextField('Valor_UF_Operador').setText(Number(datos.valor_operador_uf).toString());
            form.getTextField('Valor_UF_Grua').setText(Number(datos.valor_grua_uf).toString());
          }

          // Equipos Utilizados
          detalle_equipos.forEach((detalle, index) => {
            if (datos.id_maquinaria === 1) {
              form.getTextField(`Item_${index + 1}`).setText("M3 BOMBEADOS - BH # " + detalle.numero_equipo);
              form.getTextField(`Valor_UF_${index + 1}`).setText(detalle.total_m3_valor_uf);
              form.getTextField(`Valor_Neto_${index + 1}`).setText("$ " + Number(detalle.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              form.getTextField(`Mes_Year_1`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));
            } else if (datos.id_maquinaria === 2) {
              form.getTextField(`Item_${index + 1}`).setText("HORAS TRABAJADAS - GH # " + detalle.numero_equipo);
              form.getTextField(`Total_Horas_${index + 1}`).setText(detalle.total_horas_trabajadas);
              form.getTextField(`Valor_Hora_${index + 1}`).setText("$ " + Number(detalle.horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              form.getTextField(`Valor_Total_${index + 1}`).setText("$ " + Number(detalle.total_horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              form.getTextField(`Mes_Year_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));

            } else if (datos.id_maquinaria === 3) {
              form.getTextField(`Mes_Year_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));
            } else {
              // Valor total horas adicionales UF
              const valorHHTotalesUF = (Number(detalle.total_horas_trabajadas_valor) / indicadorUF).toFixed(2).replace('.', ',');

              form.getTextField(`Item_${index + 1}`).setText("HORAS TRABAJADAS - GT # " + detalle.numero_equipo);
              form.getTextField(`Valor_Hora_UF_${index + 1}`).setText(valorHHTotalesUF.toString());
              form.getTextField(`Valor_Hora_${index + 1}`).setText("$ " + Number(detalle.total_horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              form.getTextField(`Mes_LV_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " (Lunes a Viernes)");
              form.getTextField(`Mes_Year_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));
            }
            form.getTextField(`Mes_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase());
          });

          // Se agregan detalles de servicios
          if (detalle_servicios.length > 0) {
            if (datos.id_maquinaria === 2) {
              detalle_servicios.forEach((detalle, index) => {
                form.getTextField(`Serv_${index + 1}`).setText(detalle.nombre_servicio);
                form.getTextField(`Serv_Total_${index + 1}`).setText(Number(detalle.cantidad_minima).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
                form.getTextField(`Serv_Valor_${index + 1}`).setText("$ " + Number(Math.round(detalle.valor_unitario_neto)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
                form.getTextField(`Serv_Valor_Total_${index + 1}`).setText("$ " + Number(Math.round(detalle.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              });
            } else if (datos.id_maquinaria === 3) {
              // Valor total horas adicionales UF
              const HHAdicionalesOperadorUF = (Number(datos.valor_total_horas_adicionales_operador) / indicadorUF).toFixed(2).replace('.', ',');
              const HHAdicionalesGruaUF = (Number(datos.valor_total_horas_adicionales_grua) / indicadorUF).toFixed(2).replace('.', ',');
              const pdfArrayServicios = [...detalle_servicios];

              let valorSrvUF = 0
              pdfArrayServicios.forEach((detalle, index) => {
                valorSrvUF = detalle.tipo_facturacion === 'completa' ? detalle.valor_unitario_neto : detalle.valor_parcial_neto
                if (detalle.id_servicio === 207) form.getTextField(`Valor_Hora_Adicional_Grua`).setText(Number(detalle.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
                let servicio_glosa = detalle.detalle ? detalle.glosa_servicio + ': ' + detalle.detalle : detalle.glosa_servicio
                form.getTextField(`Serv_${index + 1}`).setText(servicio_glosa);
                form.getTextField(`Serv_Dscto_${index + 1}`).setText(parseFloat(detalle.dscto).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                form.getTextField(`Serv_Vmax_${index + 1}`).setText(parseFloat(detalle.valor_maximo).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                form.getTextField(`Serv_Total_${index + 1}`).setText(Number(detalle.cantidad_minima).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
                form.getTextField(`Serv_Valor_${index + 1}`).setText(parseFloat(valorSrvUF).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                form.getTextField(`Serv_Valor_Total_${index + 1}`).setText("$ " + Number(Math.round(detalle.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              });
            }
          }
          // Fin se agregan detalles de servicios          

          // Totales Estado de Pago
          form.getTextField('Total_Neto').setText("$ " + Number(datos.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
          form.getTextField('IVA').setText("$ " + Number(datos.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
          form.getTextField('Descuentos').setText("DESCUENTOS");
          form.getTextField('Descuentos_Valor').setText("$ " + Number(datos.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
          form.getTextField('Total').setText("$ " + Number(datos.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

          // Reports Estado de Pago
          reports.forEach((report, index) => {
            form.getTextField(`Dia_Report_${index + 1}`).setText(report.dia.toUpperCase());
            if (datos.id_maquinaria === 1) {
              form.getTextField(`Fecha_Report_${index + 1}`).setText(report.fecha_report);
              form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_bh.toString());
              form.getTextField(`Equipo_Report_${index + 1}`).setText(report.bomba.toString());
              form.getTextField(`M3_Reales_Report_${index + 1}`).setText(report.m3_bombeados_reales.toString().replace('.', ','));
              form.getTextField(`M3_Bombeados_Report_${index + 1}`).setText(report.m3_bombeados.replace('.', ','));
              form.getTextField(`Valor_M3_Report_${index + 1}`).setText(report.valor_m3.toString().replace('.', ','));
              form.getTextField(`Valor_UF_Total_Report_${index + 1}`).setText(report.valor_uf_total.toString().replace('.', ','));
              form.getTextField(`Valor_UF_Report_${index + 1}`).setText(Number(report.valor_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              form.getTextField(`Valor_Total_Neto_Report_${index + 1}`).setText(Number(report.valor_total_bombeo_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
              form.getTextField(`Lugar_Faena_Report_${index + 1}`).setText(datos.nombre_obra.toUpperCase());
            } else if (datos.id_maquinaria === 2) {
              form.getTextField(`Fecha_Report_${index + 1}`).setText(report.fecha_report);
              form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_gh.toString());
              form.getTextField(`Equipo_Report_${index + 1}`).setText(report.numero.toString());
              form.getTextField(`Hora_Inicio_Manana_Report_${index + 1}`).setText(report.hora_inicio_manana.slice(0, 5).toString());
              form.getTextField(`Hora_Termino_Manana_Report_${index + 1}`).setText(report.hora_termino_manana.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Manana_Report_${index + 1}`).setText(report.total_horas_manana.slice(0, 5).toString());
              form.getTextField(`Hora_Inicio_Tarde_Report_${index + 1}`).setText(report.hora_inicio_tarde.slice(0, 5).toString());
              form.getTextField(`Hora_Termino_Tarde_Report_${index + 1}`).setText(report.hora_termino_tarde.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Tarde_Report_${index + 1}`).setText(report.total_horas_tarde.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Report_${index + 1}`).setText(report.total_horas.slice(0, 5).toString());
              form.getTextField(`Lugar_Faena_Report_${index + 1}`).setText(datos.nombre_obra.toUpperCase());
            } else if (datos.id_maquinaria === 3) {
              form.getTextField(`Fecha_Report_${index + 1}`).setText(report.fecha_report);
              form.getTextField(`Mes_Report_${index + 1}`).setText(report.mes.toUpperCase());
              form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_gt.toString());
              form.getTextField(`Hora_Inicio_Manana_Report_${index + 1}`).setText(report.hora_inicio_manana.slice(0, 5).toString());
              form.getTextField(`Hora_Termino_Manana_Report_${index + 1}`).setText(report.hora_termino_manana.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Manana_Report_${index + 1}`).setText(report.total_horas_manana.slice(0, 5).toString());
              form.getTextField(`Hora_Inicio_Tarde_Report_${index + 1}`).setText(report.hora_inicio_tarde.slice(0, 5).toString());
              form.getTextField(`Hora_Termino_Tarde_Report_${index + 1}`).setText(report.hora_termino_tarde.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Tarde_Report_${index + 1}`).setText(report.total_horas_tarde.slice(0, 5).toString());
              // form.getTextField(`Total_Horas_Report_${index + 1}`).setText(report.total_horas.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Form_Report_${index + 1}`).setText(Number(parseInt(report.total_horas.split(':')[0]) + parseInt(report.total_horas.split(':')[1]) / 60).toString().slice(0, 5));
            } else {
              form.getTextField(`Mes_Report_${index + 1}`).setText(report.mes.toUpperCase());
              form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_gt.toString());
              form.getTextField(`Hora_Inicio_Manana_Report_${index + 1}`).setText(report.hora_inicio_manana.slice(0, 5).toString());
              form.getTextField(`Hora_Termino_Manana_Report_${index + 1}`).setText(report.hora_termino_manana.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Manana_Report_${index + 1}`).setText(report.total_horas_manana.slice(0, 5).toString());
              form.getTextField(`Hora_Inicio_Tarde_Report_${index + 1}`).setText(report.hora_inicio_tarde.slice(0, 5).toString());
              form.getTextField(`Hora_Termino_Tarde_Report_${index + 1}`).setText(report.hora_termino_tarde.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Tarde_Report_${index + 1}`).setText(report.total_horas_tarde.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Report_${index + 1}`).setText(report.total_horas.slice(0, 5).toString());
              form.getTextField(`Total_Horas_Form_Report_${index + 1}`).setText(Number(parseInt(report.total_horas.split(':')[0]) + parseInt(report.total_horas.split(':')[1]) / 60).toString().slice(0, 5));
            }
          });

          const modifiedPdfBytes = await pdfDoc.save();

          const arrayBufferToBase64 = (buffer) => {
            let binary = '';
            const bytes = new Uint8Array(buffer);
            const len = bytes.byteLength;
            for (let i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            return window.btoa(binary);
          };

          const pdfBase64 = arrayBufferToBase64(modifiedPdfBytes);
          setPdfBase64(`data:application/pdf;base64,${pdfBase64}`);
        } catch (error) {
          console.error('Error generating PDF:', error);
        }
      };

      generatePDF();
    }, [datos, reports, detalle_equipos]);

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Estado de Pago</h4>
            <button onClick={closeSecondModal} className="btn-close"></button>
          </div>
          <div className="modal-body pt-0">
            <iframe
              src={pdfBase64}
              title="Estado de Pago"
              style={{ width: "100%", height: "700px", border: "none" }}
            />
          </div>
        </div>
      </div>
    );
  }

  /* Envía por correo el estado de pago */
  const [submitEPDisabled, setSubmitEPDisabled] = useState(false);
  const handleEnviaEP = (data, reports, detalleEquipos, estadoPagoServiciosGH) => {
    let idEstadoPago;
    let tipoMaquinaria;

    switch (data.id_maquinaria) {
      case 1:
        tipoMaquinaria = "BH";
        idEstadoPago = data.id_estado_pago_bh;
        break;
      case 2:
        tipoMaquinaria = "GH";
        idEstadoPago = data.id_estado_pago_gh;
        break;
      default:
        tipoMaquinaria = "GT";
        idEstadoPago = data.id_estado_pago_gt;
    }

    setSecondModalOpen(true);
    setSecondModalContent(<ConfirmaEnviarEPModalContent tipo_maquinaria={tipoMaquinaria} id_estado_pago={idEstadoPago} datos={data} reports={reports} detalle_equipos={detalleEquipos} detalle_servicios={estadoPagoServiciosGH} />);
  };

  function ConfirmaEnviarEPModalContent({ tipo_maquinaria, id_estado_pago, datos, reports, detalle_equipos, detalle_servicios = [] }) {
    const [filas, setFilas] = useState([]);

    useEffect(() => {
      obtenerEmailCC();
    }, []);

    const obtenerEmailCC = async () => {
      try {
        const response = await fetch(
          `${config.apiBaseUrl}/email_cc.php`
        );
        const data = await response.json();
        if (data && data[0].id_email_cc) {
          setFilas(data);
        }
      } catch (error) {
        setFilas([]);
      }
    };

    /* Agregar CC */
    const [mostrarTablaCC, setMostrarTablaCC] = useState(true);
    const [mostrarBotonCC, setMostrarBotonCC] = useState(true);

    const handleRadioChange = (event) => {
      setMostrarTablaCC(event.target.value === "1");

      setMostrarBotonCC(!mostrarBotonCC);

      setFilas([{
        "id_email_cc": 1,
        "email_cc": ""
      }]);
    }

    const handleAgregarFila = () => {
      let siguienteId = 1;

      while (filas.some(fila => fila.id_email_cc === siguienteId)) {
        siguienteId++;
      }

      const nuevaFila = {
        id_email_cc: siguienteId,
        email_cc: ''
      };

      setFilas([...filas, nuevaFila]);
    };

    const handleInputChange = (id, campo, valor) => {
      const nuevasFilas = filas.map((fila) =>
        fila.id_email_cc === id ? { ...fila, [campo]: valor } : fila
      );

      setFilas(nuevasFilas);
    };

    const handleEliminarFila = (id) => {
      // Verificar que haya más de una fila antes de eliminar
      if (filas.length > 1) {
        const nuevasFilas = filas.filter((fila) => fila.id_email_cc !== id);
        setFilas(nuevasFilas);
      } else {
        alert("Debe agregar al menos un email, de lo contrario seleccione 'NO'.");
      }
    };

    return (
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="mb-0">Enviar Estado de Pago</h4>
            <button onClick={closeSecondModal} className="btn-close"></button>
          </div>
          <div className="modal-body">
            <p className="fs-5 mb-2">¿Está seguro que desea enviar el estado de pago: <span className="text-orange">{tipo_maquinaria}-{id_estado_pago}</span> ({datos.folio})?</p>
            <p>Se enviará mediante correo electrónico a la dirección: <span className="text-orange">{datos.email_solicitante}.</span></p>
            <p>¿Requiere copiar cotización a otras direcciones de correo electrónico (CC)?</p>
            <div className="d-flex justify-content-md-between">
              <div>
                <input
                  type="radio"
                  className="btn-check"
                  name="email_cc"
                  id="email-cc-si"
                  autoComplete="off"
                  value="1"
                  checked={mostrarTablaCC}
                  onChange={handleRadioChange}
                />
                <label className="btn" htmlFor="email-cc-si">Si</label>
                <input
                  type="radio"
                  className="btn-check"
                  name="email_cc"
                  id="email-cc-no"
                  autoComplete="off"
                  value="0"
                  checked={!mostrarTablaCC}
                  onChange={handleRadioChange}
                />
                <label className="btn" htmlFor="email-cc-no">No</label>
              </div>
              {mostrarBotonCC && (
                <button type="button" className="btn btn-dark btn-sm" onClick={handleAgregarFila}>
                  <i className="bi-plus-circle"></i> Agregar
                </button>
              )}
            </div>
            {mostrarTablaCC && (
              <div className="mt-3">
                <table className="table mb-0">
                  <thead>
                    <tr className="table-active">
                      <th>Email</th>
                      <th>Eliminar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filas.map((fila, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            className="form-control form-control-sm"
                            type="text"
                            id={"email_cc_" + index}
                            value={fila.email_cc}
                            onChange={(e) =>
                              handleInputChange(fila.id_email_cc, 'email_cc', e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <button className="btn btn-outline-danger btn-sm" onClick={() => handleEliminarFila(fila.id_email_cc)}>
                            <i className="bi bi-trash3"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button className="btn btn-yellow" onClick={(e) => handleSubmitEP(e, tipo_maquinaria, mostrarBotonCC, filas, datos, reports, detalle_equipos, detalle_servicios)} disabled={submitEPDisabled}>
              <i className="bi bi-send"></i> Enviar
            </button>
          </div>
        </div>
      </div>
    );
  }

  //Valida email estados de pago
  const validarEmailEP = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmitEP = async (event, tipo_maquinaria, mostrarTablaCC, filas, datos, reports, detalle_equipos, detalle_servicios = []) => {
    event.preventDefault();

    setSubmitEPDisabled(true);

    try {
      //Valida los email ingresados
      const validaEmail = filas.every(item => validarEmailEP(item.email_cc));

      if (mostrarTablaCC && !validaEmail) {
        alert('Debe ingresar el o los email y comprobar si están correctos');
      } else {
        crearPDFep(tipo_maquinaria, filas, mostrarTablaCC, datos, reports, detalle_equipos, detalle_servicios);
      }
    } catch (error) {
      console.log("Error");
    }
  }

const  diasEntreFechas = (fechaDesde, fechaHasta) => {
  // Convertir formato "dd-mm-yyyy" a objeto Date
  const [d1, m1, y1] = fechaDesde.split("-");
  const [d2, m2, y2] = fechaHasta.split("-");
  const inicio = new Date(`${y1}-${m1}-${d1}`);
  const fin = new Date(`${y2}-${m2}-${d2}`);

  // Diferencia en milisegundos
  const diffMs = fin - inicio;
  // Convertir a días (+1 para incluir ambos extremos)
  const diffDias = diffMs / (1000 * 60 * 60 * 24) + 1;

  return diffDias;
}

  const [pdfEPBytes, setPdfEPBytes] = useState(null);
  const crearPDFep = async (tipo_maquinaria, filas, mostrarTablaCC, datos, reports, detalle_equipos, detalle_servicios = []) => {

    //Agrega Datos Email
    formCorreoEP.para = datos.email_solicitante;
    formCorreoEP.cliente = datos.nombre_cliente;
    formCorreoEP.razon_social = datos.razon_social;

    if (!mostrarTablaCC) {
      formCorreoEP.cc = [];
    } else {
      const filasEmail = filas.map(({ email_cc, ...rest }) => ({
        ...rest,
        email: email_cc
      }));
      formCorreoEP.cc = filasEmail;
    }

    const obtenerFechaHoy = (fechaStr) => {
      let fecha;

      if (fechaStr) {
        // Divido el string en partes: dd-mm-yyyy
        const [dia, mes, año] = fechaStr.split('-');
        // Ojo: en JS los meses van de 0 a 11
        fecha = new Date(año, mes - 1, dia);
      } else {
        fecha = new Date();
      }

      const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
      return fecha.toLocaleDateString('es-ES', opciones);
    };

    const existingPdfBytes = await fetch(`${config.apiBaseUrl}/obtienePlantillaEP.php?id_maquinaria=${datos.id_maquinaria}`).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Obtener el formulario del PDF
    const form = pdfDoc.getForm();

    // Fecha Estado Pago
    let fechaActual = new Date();

    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      return `${day}-${month}-${year}`;
    };

    const obtenerFechaMasReciente = (report) => {
      const masReciente = report.reduce((max, item) => {
        const [dia, mes, año] = item.fecha_report.split('-');
        const fecha = new Date(año, mes - 1, dia);

        if (!max || fecha > max.fecha) {
          return { ...item, fecha };
        }
        return max;
      }, null);

      // Formateamos la fecha encontrada al estilo "31 de julio de 2025"
      const opciones = { day: 'numeric', month: 'long', year: 'numeric' };
      return masReciente.fecha.toLocaleDateString('es-ES', opciones);
    };

    const fechaEP = obtenerFechaHoy(datos.fecha_estado_pago);

    const fechaUltimoReport = reports.length > 0 ? obtenerFechaMasReciente(reports) : fechaEP

    // Cabecera Estado Pago
    form.getTextField('Rut_Cliente').setText(formatearRut(datos.rut_cliente));
    form.getTextField('Razon_Social').setText(datos.razon_social.toUpperCase());
    form.getTextField('Giro_Cliente').setText(datos.giro.toUpperCase());
    form.getTextField('Direccion_Cliente').setText(datos.direccion.toUpperCase());
    form.getTextField('Obra_Cliente').setText(datos.nombre_obra.toUpperCase());
    form.getTextField('Direccion_Obra').setText(datos.direccion.toUpperCase() + " (" + datos.ciudad.toUpperCase() + ")");
    form.getTextField('Folio').setText(datos.folio.toUpperCase());
    form.getTextField('Fecha_EP').setText(fechaEP);
    form.getTextField('Contacto').setText(datos.nombre_contacto.toUpperCase());
    form.getTextField('Cargo_Contacto').setText(datos.cargo.toUpperCase());
    form.getTextField('Telefono_Contacto').setText(datos.telefono);
    form.getTextField('Email_Contacto').setText(datos.email);

    // Equipo Cotizado
    if (datos.id_maquinaria === 1) {
      formCorreoEP.asunto = "Estado Pago N°: " + datos.id_estado_pago_bh + " - Vittamaq / " + datos.nombre_obra + " / " + datos.ciudad + " / " + datos.nombre_cliente;

      const totalBombeoNeto = reports.reduce(
        (sum, item) => sum + parseFloat(item.valor_total_bombeo_neto),
        0
      );

      form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_bh.toString());
      form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
      form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase());
      form.getTextField('Aditivo').setText("VITTECH");
      form.getTextField('Aditivo_Valor_UF').setText(Number(datos.aditivo_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Aditivo_Valor_Neto').setText("$ " + Number(datos.aditivo_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_Traslado_Bomba').setText("VALOR TRASLADO BOMBA");
      form.getTextField('Valor_Traslado_Bomba_UF').setText(Number(datos.valor_traslado_bomba_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_Traslado_Bomba_Neto').setText("$ " + Number(datos.valor_traslado_bomba).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Sobre_Estadia').setText("SOBRE ESTADIA");
      form.getTextField('Sobre_Estadia_UF').setText(Number(datos.sobre_estadia_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Sobre_Estadia_Neto').setText("$ " + Number(datos.sobre_estadia_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_Total_Neto').setText("$ " + Number(totalBombeoNeto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
    } else if (datos.id_maquinaria === 2) {
      formCorreoEP.asunto = "Estado Pago N°: " + datos.id_estado_pago_gh + " - Vittamaq / " + datos.nombre_obra + " / " + datos.ciudad + " / " + datos.nombre_cliente;

      form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_gh.toString());
      form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} - ${datos.nombre_equipo.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
      form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase());

      //Totales Horas
      const sumTotalHoras = () => {
        const totalMinutes = reports.reduce((acc, item) => {
          const [hours, minutes] = item.total_horas.split(":").map(Number);
          return acc + hours * 60 + minutes;
        }, 0);

        // Convertir a formato HH:MM
        const totalHours = Math.floor(totalMinutes / 60);
        const totalMinutesRemainder = totalMinutes % 60;
        const totalHorasHHMM = `${String(totalHours).padStart(2, "0")}:${String(totalMinutesRemainder).padStart(2, "0")}`;

        // Convertir a decimal
        const totalHorasDecimal = (totalMinutes / 60).toFixed(2);

        return {
          totalHorasHHMM,
          totalHorasDecimal: parseFloat(totalHorasDecimal),
        };
      };

      const horasTotales = sumTotalHoras();
      form.getTextField('Horas_Totales_HHMM').setText(horasTotales.totalHorasHHMM.toString());
      form.getTextField('Horas_Totales_Decimal').setText(horasTotales.totalHorasDecimal.toString());

    } else if (datos.id_maquinaria === 3) {
      const cantidadMinimaGT = detalle_servicios.find(s => s.id_servicio === 208)?.cantidad_minima ?? 220;
      formCorreoEP.asunto = "Estado Pago N°: " + datos.id_estado_pago_gt + " - Vittamaq / " + datos.nombre_obra + " / " + datos.ciudad + " / " + datos.nombre_cliente;

      form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_gt.toString());
      form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} - ${datos.nombre_equipo.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
      form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase() + " - " + datos.nombre_equipo.toUpperCase());
      form.getTextField('Horas_Incluidas_Operador').setText(datos.horas_incluidas_operador.toString());
      form.getTextField('Horas_Adicionales_Operador').setText(datos.horas_adicionales_operador.toString());
      form.getTextField('Valor_Hora_Adicional_Operador').setText(datos.valor_hora_adicional_uf_operador.toString());
      form.getTextField('Valor_Hora_Adicional_SD_Operador').setText(datos.horas_adicionales_domingos_festivos_operador.toString());
      form.getTextField('Valor_Hora_Adicional_UF_Operador').setText(Number(datos.valor_hora_adicional_domingos_festivos_uf_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_UF_Fecha_Facturacion').setText("$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_Total_HH_Adicionales_Operador').setText("$ " + Number(datos.valor_total_horas_adicionales_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Horas_Incluidas_Grua').setText(datos.horas_incluidas_grua.toString());
      form.getTextField('Horas_Adicionales_Grua').setText(datos.horas_adicionales_grua.toString());
      form.getTextField('Valor_Hora_Adicional_Grua').setText(datos.valor_hora_adicional_uf_grua.toString());
      form.getTextField('Valor_Total_HH_Adicionales_Grua').setText("$ " + Number(Math.round(datos.horas_adicionales_grua * datos.valor_hora_adicional_uf_grua * datos.valor_uf_fecha_facturacion)).toLocaleString('es-ES', { useGrouping: true }));
      form.getTextField('Valor_Total_HH_Adicionales_UF_Grua').setText("$ " + Number(datos.horas_adicionales_grua * datos.valor_hora_adicional_uf_grua).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

      //Totales Horas
      const sumTotalHoras = () => {
        const totalMinutes = reports.reduce((acc, item) => {
          const [hours, minutes] = item.total_horas.split(":").map(Number);
          return acc + hours * 60 + minutes;
        }, 0);

        // Convertir a formato HH:MM
        const totalHours = Math.floor(totalMinutes / 60);
        const totalMinutesRemainder = totalMinutes % 60;
        const totalHorasHHMM = `${String(totalHours).padStart(2, "0")}:${String(totalMinutesRemainder).padStart(2, "0")}`;

        // Convertir a decimal
        const totalHorasDecimal = (totalMinutes / 60).toFixed(2);

        return {
          totalHorasHHMM,
          totalHorasDecimal: parseFloat(totalHorasDecimal),
        };
      };

      const horasTotales = sumTotalHoras();
      form.getTextField('Horas_Totales_HHMM').setText(horasTotales.totalHorasHHMM.toString());
      form.getTextField('Horas_Totales_Decimal').setText(horasTotales.totalHorasDecimal.toString());

      // Fecha y UF Hoy
      const fechaEEPP = fechaUltimoReport ? fechaUltimoReport : obtenerFechaHoy()
      form.getTextField('Fecha_Hoy').setText("VALOR UF AL " + fechaEEPP.toUpperCase());
      form.getTextField('UF_Dia').setText(
        "$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      );

      // Valor total horas adicionales UF
      const HHAdicionalesOperadorUF = (Number(datos.valor_total_horas_adicionales_operador) / indicadorUF).toFixed(2).replace('.', ',');
      const HHAdicionalesGruaUF = (Number(datos.valor_total_horas_adicionales_grua) / indicadorUF).toFixed(2).replace('.', ',');

      form.getTextField('Valor_Total_HH_Adicionales_UF_Operador').setText(HHAdicionalesOperadorUF.toString());
      // form.getTextField('Valor_Total_HH_Adicionales_UF_Grua').setText(HHAdicionalesGruaUF.toString());

      // Días y horas del mes
      function obtenerDiasDelMes(fecha) {
        const [dia, mes, anio] = fecha.split("-").map(Number);

        const ultimoDia = new Date(anio, mes, 0).getDate();

        return ultimoDia;
      }

      // A trabajar Mes
      const diasDelMes = obtenerDiasDelMes(datos.fecha_estado_pago);
      form.getTextField('Dias_Trabajar_Mes').setText(diasDelMes.toString());

      form.getTextField('Horas_Trabajar_Mes_GT').setText(String(parseInt(cantidadMinimaGT)));
      form.getTextField('Horas_Trabajar_Mes_OP').setText('180');

      // Trabajado Mes
      if (reports.length > 0) {
        form.getTextField('Dias_Trabajado_Mes_OP').setText(diasEntreFechas(reports[0].fecha_report, reports[reports.length-1].fecha_report).toString()) // .setText(reports[0].dias_facturables);
        form.getTextField('Dias_Trabajado_Mes_GT').setText(diasEntreFechas(reports[0].fecha_report, reports[reports.length-1].fecha_report).toString()) // .setText(reports[0].dias_facturables)

        form.getTextField('Horas_Trabajado_Mes_OP').setText(horasTotales.totalHorasDecimal.toString());
        form.getTextField('Horas_Trabajado_Mes_GT').setText((reports[0].horas_facturables_grua).toString());
      }
      // Valores UF Operador y Grúa
      form.getTextField('Valor_UF_Operador').setText(Number(datos.valor_operador_uf).toString());
      form.getTextField('Valor_UF_Grua').setText(Number(datos.valor_grua_uf).toString());
    } else {
      formCorreoEP.asunto = "Estado Pago N°: " + datos.id_estado_pago_gt + " - Vittamaq / " + datos.nombre_obra + " / " + datos.ciudad + " / " + datos.nombre_cliente;

      form.getTextField('Id_Estado_Pago').setText(datos.id_estado_pago_gt.toString());
      form.getTextField('Equipo').setText(`${datos.nombre_maquinaria.toUpperCase()} - ${datos.nombre_equipo.toUpperCase()} (${datos.nombre_requerimiento.toUpperCase()})`);
      form.getTextField('Detalle_Facturacion').setText(datos.razon_social.toUpperCase() + " - " + datos.nombre_obra.toUpperCase() + " - " + datos.nombre_equipo.toUpperCase());
      form.getTextField('Horas_Incluidas_Operador').setText(datos.horas_incluidas_operador.toString());
      form.getTextField('Horas_Adicionales_Operador').setText(datos.horas_adicionales_operador.toString());
      form.getTextField('Valor_Hora_Adicional_Operador').setText(datos.valor_hora_adicional_uf_operador.toString());
      form.getTextField('Valor_Hora_Adicional_SD_Operador').setText(datos.horas_adicionales_domingos_festivos_operador.toString());
      form.getTextField('Valor_Hora_Adicional_UF_Operador').setText(Number(datos.valor_hora_adicional_domingos_festivos_uf_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_UF_Fecha_Facturacion').setText("$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Valor_Total_HH_Adicionales_Operador').setText("$ " + Number(datos.valor_total_horas_adicionales_operador).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      form.getTextField('Horas_Incluidas_Grua').setText(datos.horas_incluidas_grua.toString());
      form.getTextField('Horas_Adicionales_Grua').setText(datos.horas_adicionales_grua.toString());
      form.getTextField('Valor_Hora_Adicional_Grua').setText(datos.valor_hora_adicional_uf_grua.toString());
      form.getTextField('Valor_Total_HH_Adicionales_Grua').setText("$ " + Number(datos.valor_total_horas_adicionales_grua).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

      //Totales Horas
      const sumTotalHoras = () => {
        const totalMinutes = reports.reduce((acc, item) => {
          const [hours, minutes] = item.total_horas.split(":").map(Number);
          return acc + hours * 60 + minutes;
        }, 0);

        // Convertir a formato HH:MM
        const totalHours = Math.floor(totalMinutes / 60);
        const totalMinutesRemainder = totalMinutes % 60;
        const totalHorasHHMM = `${String(totalHours).padStart(2, "0")}:${String(totalMinutesRemainder).padStart(2, "0")}`;

        // Convertir a decimal
        const totalHorasDecimal = (totalMinutes / 60).toFixed(2);

        return {
          totalHorasHHMM,
          totalHorasDecimal: parseFloat(totalHorasDecimal),
        };
      };

      const horasTotales = sumTotalHoras();
      form.getTextField('Horas_Totales_HHMM').setText(horasTotales.totalHorasHHMM.toString());
      form.getTextField('Horas_Totales_Decimal').setText(horasTotales.totalHorasDecimal.toString());

      // Fecha y UF Hoy
      const fechaEEPP = fechaUltimoReport ? fechaUltimoReport : obtenerFechaHoy()
      form.getTextField('Fecha_Hoy').setText("VALOR UF AL " + fechaEEPP.toUpperCase());
      form.getTextField('UF_Dia').setText(
        "$ " + Number(datos.valor_uf_fecha_facturacion).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      );

      // Valor total horas adicionales UF
      const HHAdicionalesOperadorUF = (Number(datos.valor_total_horas_adicionales_operador) / indicadorUF).toFixed(2).replace('.', ',');
      const HHAdicionalesGruaUF = (Number(datos.valor_total_horas_adicionales_grua) / indicadorUF).toFixed(2).replace('.', ',');

      form.getTextField('Valor_Total_HH_Adicionales_UF_Operador').setText(HHAdicionalesOperadorUF.toString());
      form.getTextField('Valor_Total_HH_Adicionales_UF_Grua').setText(HHAdicionalesGruaUF.toString());

      // Días y horas del mes
      function obtenerDiasDelMes(fecha) {
        const [dia, mes, anio] = fecha.split("-").map(Number);

        const ultimoDia = new Date(anio, mes, 0).getDate();

        return ultimoDia;
      }

      const diasDelMes = obtenerDiasDelMes(datos.fecha_estado_pago);
      form.getTextField('Dias_Trabajar_Mes').setText(diasDelMes.toString());

      function obtenerHorasSemanales() {
        const diasPorSemana = 7;
        const horasPorDia = 24;
        return diasPorSemana * horasPorDia;
      }

      const horasSemanales = obtenerHorasSemanales();
      form.getTextField('Horas_Trabajar_Mes').setText(horasSemanales.toString());

      // Valores UF Operador y Grúa
      form.getTextField('Valor_UF_Operador').setText(Number(datos.valor_operador_uf).toString());
      form.getTextField('Valor_UF_Grua').setText(Number(datos.valor_grua_uf).toString());
    }

    // Equipos Utilizados
    detalle_equipos.forEach((detalle, index) => {
      if (datos.id_maquinaria === 1) {
        form.getTextField(`Item_${index + 1}`).setText("M3 BOMBEADOS - BH #" + detalle.numero_equipo);
        form.getTextField(`Valor_UF_${index + 1}`).setText(detalle.total_m3_valor_uf);
        form.getTextField(`Valor_Neto_${index + 1}`).setText("$ " + Number(detalle.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Mes_Year_1`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));
      } else if (datos.id_maquinaria === 2) {
        form.getTextField(`Item_${index + 1}`).setText("HORAS TRABAJADAS - GH # " + detalle.numero_equipo);
        form.getTextField(`Total_Horas_${index + 1}`).setText(detalle.total_horas_trabajadas);
        form.getTextField(`Valor_Hora_${index + 1}`).setText("$ " + Number(detalle.horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Valor_Total_${index + 1}`).setText("$ " + Number(detalle.total_horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Mes_Year_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));

      } else if (datos.id_maquinaria === 3) {
        form.getTextField(`Mes_Year_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));
      } else {
        // Valor total horas adicionales UF
        const valorHHTotalesUF = (Number(detalle.total_horas_trabajadas_valor) / indicadorUF).toFixed(2).replace('.', ',');

        form.getTextField(`Item_${index + 1}`).setText("HORAS TRABAJADAS - GT # " + detalle.numero_equipo);
        form.getTextField(`Valor_Hora_UF_${index + 1}`).setText(valorHHTotalesUF.toString());
        form.getTextField(`Valor_Hora_${index + 1}`).setText("$ " + Number(detalle.total_horas_trabajadas_valor).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Mes_LV_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " (Lunes a Viernes)");
        form.getTextField(`Mes_Year_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase() + " - " + new Intl.DateTimeFormat('es', { year: 'numeric' }).format(new Date(detalle.fecha_report)));
      }
      form.getTextField(`Mes_${index + 1}`).setText(new Intl.DateTimeFormat('es', { month: 'long' }).format(new Date(detalle.fecha_report)).toUpperCase());
    });

    // Se agregan detalles de servicios
    if (datos.id_maquinaria === 2 && detalle_servicios.length > 0) {

      detalle_servicios.forEach((detalle, index) => {
        form.getTextField(`Serv_${index + 1}`).setText(detalle.nombre_servicio);
        form.getTextField(`Serv_Total_${index + 1}`).setText(Number(detalle.cantidad_minima).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Serv_Valor_${index + 1}`).setText("$ " + Number(Math.round(detalle.valor_unitario_neto)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Serv_Valor_Total_${index + 1}`).setText("$ " + Number(Math.round(detalle.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

      });
    } else if (datos.id_maquinaria === 3) {
      const HHAdicionalesOperadorUF = (Number(datos.valor_total_horas_adicionales_operador) / indicadorUF).toFixed(2).replace('.', ',');
      const HHAdicionalesGruaUF = (Number(datos.valor_total_horas_adicionales_grua) / indicadorUF).toFixed(2).replace('.', ',');

      const pdfArrayServicios = [...detalle_servicios];

      let valorSrvUF = 0
      pdfArrayServicios.forEach((detalle, index) => {
        valorSrvUF = detalle.tipo_facturacion === 'completa' ? detalle.valor_unitario_neto : detalle.valor_parcial_neto
        if (detalle.id_servicio === 207) form.getTextField(`Valor_Hora_Adicional_Grua`).setText(Number(detalle.valor_unitario_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        let servicio_glosa = detalle.detalle ? detalle.glosa_servicio + ': ' + detalle.detalle : detalle.glosa_servicio
        form.getTextField(`Serv_${index + 1}`).setText(servicio_glosa);
        form.getTextField(`Serv_Dscto_${index + 1}`).setText(parseFloat(detalle.dscto).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        form.getTextField(`Serv_Vmax_${index + 1}`).setText(parseFloat(detalle.valor_maximo).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        form.getTextField(`Serv_Total_${index + 1}`).setText(Number(detalle.cantidad_minima).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Serv_Valor_${index + 1}`).setText(parseFloat(valorSrvUF).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        form.getTextField(`Serv_Valor_Total_${index + 1}`).setText("$ " + Number(Math.round(detalle.valor_total)).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
      });

    }
    // Fin se agregan detalles de servicios

    // Totales Estado de Pago
    form.getTextField('Total_Neto').setText("$ " + Number(datos.total_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
    form.getTextField('IVA').setText("$ " + Number(datos.iva).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
    form.getTextField('Descuentos').setText("DESCUENTOS");
    form.getTextField('Descuentos_Valor').setText("$ " + Number(datos.otros_descuentos).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
    form.getTextField('Total').setText("$ " + Number(datos.total).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));

    // Reports Estado de Pago
    reports.forEach((report, index) => {
      form.getTextField(`Dia_Report_${index + 1}`).setText(report.dia.toUpperCase());
      if (datos.id_maquinaria === 1) {
        form.getTextField(`Fecha_Report_${index + 1}`).setText(report.fecha_report);
        form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_bh.toString());
        form.getTextField(`Equipo_Report_${index + 1}`).setText(report.bomba.toString());
        form.getTextField(`M3_Reales_Report_${index + 1}`).setText(report.m3_bombeados_reales.toString().replace('.', ','));
        form.getTextField(`M3_Bombeados_Report_${index + 1}`).setText(report.m3_bombeados.replace('.', ','));
        form.getTextField(`Valor_M3_Report_${index + 1}`).setText(report.valor_m3.toString().replace('.', ','));
        form.getTextField(`Valor_UF_Total_Report_${index + 1}`).setText(report.valor_uf_total.toString().replace('.', ','));
        form.getTextField(`Valor_UF_Report_${index + 1}`).setText(Number(report.valor_uf).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Valor_Total_Neto_Report_${index + 1}`).setText(Number(report.valor_total_bombeo_neto).toLocaleString('es-ES', { useGrouping: true }).replace(/,/g, '.'));
        form.getTextField(`Lugar_Faena_Report_${index + 1}`).setText(datos.nombre_obra.toUpperCase());
      } else if (datos.id_maquinaria === 2) {
        form.getTextField(`Fecha_Report_${index + 1}`).setText(report.fecha_report);
        form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_gh.toString());
        form.getTextField(`Equipo_Report_${index + 1}`).setText(report.numero.toString());
        form.getTextField(`Hora_Inicio_Manana_Report_${index + 1}`).setText(report.hora_inicio_manana.slice(0, 5).toString());
        form.getTextField(`Hora_Termino_Manana_Report_${index + 1}`).setText(report.hora_termino_manana.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Manana_Report_${index + 1}`).setText(report.total_horas_manana.slice(0, 5).toString());
        form.getTextField(`Hora_Inicio_Tarde_Report_${index + 1}`).setText(report.hora_inicio_tarde.slice(0, 5).toString());
        form.getTextField(`Hora_Termino_Tarde_Report_${index + 1}`).setText(report.hora_termino_tarde.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Tarde_Report_${index + 1}`).setText(report.total_horas_tarde.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Report_${index + 1}`).setText(report.total_horas.slice(0, 5).toString());
        form.getTextField(`Lugar_Faena_Report_${index + 1}`).setText(datos.nombre_obra.toUpperCase());
      } else if (datos.id_maquinaria === 3) {
        form.getTextField(`Fecha_Report_${index + 1}`).setText(report.fecha_report);
        form.getTextField(`Mes_Report_${index + 1}`).setText(report.mes.toUpperCase());
        form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_gt.toString());
        form.getTextField(`Hora_Inicio_Manana_Report_${index + 1}`).setText(report.hora_inicio_manana.slice(0, 5).toString());
        form.getTextField(`Hora_Termino_Manana_Report_${index + 1}`).setText(report.hora_termino_manana.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Manana_Report_${index + 1}`).setText(report.total_horas_manana.slice(0, 5).toString());
        form.getTextField(`Hora_Inicio_Tarde_Report_${index + 1}`).setText(report.hora_inicio_tarde.slice(0, 5).toString());
        form.getTextField(`Hora_Termino_Tarde_Report_${index + 1}`).setText(report.hora_termino_tarde.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Tarde_Report_${index + 1}`).setText(report.total_horas_tarde.slice(0, 5).toString());
        // form.getTextField(`Total_Horas_Report_${index + 1}`).setText(report.total_horas.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Form_Report_${index + 1}`).setText(Number(parseInt(report.total_horas.split(':')[0]) + parseInt(report.total_horas.split(':')[1]) / 60).toString().slice(0, 5));
      } else {
        form.getTextField(`Mes_Report_${index + 1}`).setText(report.mes.toUpperCase());
        form.getTextField(`Numero_Report_${index + 1}`).setText(report.id_report_gt.toString());
        form.getTextField(`Hora_Inicio_Manana_Report_${index + 1}`).setText(report.hora_inicio_manana.slice(0, 5).toString());
        form.getTextField(`Hora_Termino_Manana_Report_${index + 1}`).setText(report.hora_termino_manana.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Manana_Report_${index + 1}`).setText(report.total_horas_manana.slice(0, 5).toString());
        form.getTextField(`Hora_Inicio_Tarde_Report_${index + 1}`).setText(report.hora_inicio_tarde.slice(0, 5).toString());
        form.getTextField(`Hora_Termino_Tarde_Report_${index + 1}`).setText(report.hora_termino_tarde.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Tarde_Report_${index + 1}`).setText(report.total_horas_tarde.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Report_${index + 1}`).setText(report.total_horas.slice(0, 5).toString());
        form.getTextField(`Total_Horas_Form_Report_${index + 1}`).setText(Number(parseInt(report.total_horas.split(':')[0]) + parseInt(report.total_horas.split(':')[1]) / 60).toString().slice(0, 5));
      }
    });

    // Guardar el PDF modificado
    const modifiedPdfBytes = await pdfDoc.save();

    // Convierte los bytes en base64
    const arrayBufferToBase64 = (buffer) => {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    };

    // Convertir a base64 el PDF modificado y añadirlo al Email como adjunto
    const pdfBase64 = arrayBufferToBase64(modifiedPdfBytes);
    //formCorreo.adjunto[0].Base64 = pdfBase64;

    const IdEstadoPago = Number(datos.id_maquinaria === 1 ? datos.id_estado_pago_bh : datos.id_maquinaria === 2 ? datos.id_estado_pago_gh : datos.id_estado_pago_gt);

    const adjuntoEP = {
      NombreAdjunto: "Estado Pago Vittamaq " + tipo_maquinaria + "-" + IdEstadoPago,
      TipoDocumento: "pdf",
      Base64: pdfBase64
    };

    //Condiciones Generales
    const existingPdfBytesCG = await fetch(`${config.apiBaseUrl}/obtienePlantillaCondicionesGenerales.php?id_maquinaria=${datos.id_maquinaria}`).then((res) => res.arrayBuffer());

    const pdfDocCG = await PDFDocument.load(existingPdfBytesCG);

    // Obtener el formulario del PDF
    const formCG = pdfDocCG.getForm();

    formCG.getTextField('FOLIO').setText(datos.folio.toUpperCase());

    const modifiedPdfBytesCG = await pdfDocCG.save();

    const pdfBase64CG = arrayBufferToBase64(modifiedPdfBytesCG);

    const adjuntoCondGen = {
      NombreAdjunto: "Condiciones Generales " + datos.folio.toUpperCase(),
      TipoDocumento: "pdf",
      Base64: pdfBase64CG
    };

    formCorreoEP.adjuntos = [adjuntoEP,adjuntoCondGen];

    // Actualizar el estado para que React renderice el PDF modificado
    setPdfEPBytes(modifiedPdfBytes);

    // Crear un objeto Blob con los bytes del PDF modificado
    const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });

    // Descarga PDF

    guardarPDFep(blob, tipo_maquinaria + "-" + IdEstadoPago);

    handleEnviarCorreoEP(datos.id_maquinaria, IdEstadoPago, datos.email_solicitante);
  };

  const guardarPDFep = async (blob, idEstadoPago) => {
    const formData = new FormData();
    formData.append('pdf', blob, idEstadoPago);

    const tipoMaquinaria = idEstadoPago.split("-")[0];

    try {
      const response = await fetch(`${config.apiBaseUrl}/guardar_pdf_ep.php?tipo_maquinaria=${tipoMaquinaria}`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const responseData = await response.text();
      } else {
        console.error('Error al enviar el PDF al servidor:', response.status);
      }
    } catch (error) {
      console.error('Error de red:', error);
    }
  };

  /* Envío de Correo: Estado de Pago */
  const [formCorreoEP, setFormCorreoEP] = useState({
    para: "",
    asunto: "Estado de Pago: ",
    cliente: "",
    razon_social: "",
    texto_cuerpo: "A continuación, adjuntamos el estado de pago detallado que hemos preparado para proporcionarles la información completa de la maquinaria utilizada. Por favor, revisar y no dude en ponerse en contacto con nosotros si tiene alguna pregunta o necesita más información.",
    cc: {},
  });

  const handleEnviarCorreoEP = async (IdMaquinaria, IdEstadoPago, emailEnviado) => {
    try {
      closeSecondModal();
      closeModal();

      const response = await fetch(
        `${config.apiBaseUrl}/envio_correos.php`,
        {
          method: "POST",
          headers: {
            'Accept': 'application/json', // Indica que esperas una respuesta JSON
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formCorreoEP),
        }
      );

      const data = await response.json();

      if (data.message === "El correo electrónico ha sido enviado correctamente.") {
        let responseActualizaEP;
        let epData;

        // Actualización de estado de pago
        switch (IdMaquinaria) {
          case 1:
            epData = {
              id_estado_pago_bh: IdEstadoPago,
              id_estado_pago_estado: 4,
              email_enviado: emailEnviado,
              id_usuario_actualizacion: dataLogin.id_usuario
            };

            responseActualizaEP = await fetch(
              `${config.apiBaseUrl}/estado_pago_bh.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(epData),
              }
            );
            break;
          case 2:
            epData = {
              id_estado_pago_gh: IdEstadoPago,
              id_estado_pago_estado: 4,
              email_enviado: emailEnviado,
              id_usuario_actualizacion: dataLogin.id_usuario
            };

            responseActualizaEP = await fetch(
              `${config.apiBaseUrl}/estado_pago_gh.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(epData),
              }
            );
            break;
          default:
            epData = {
              id_estado_pago_gt: IdEstadoPago,
              id_estado_pago_estado: 4,
              email_enviado: emailEnviado,
              id_usuario_actualizacion: dataLogin.id_usuario
            };

            responseActualizaEP = await fetch(
              `${config.apiBaseUrl}/estado_pago_gt.php`,
              {
                method: "PUT",
                headers: {
                  'Accept': 'application/json', // Indica que esperas una respuesta JSON
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(epData),
              }
            );
        }

        const dataActualizaEP = await responseActualizaEP.json();
        if (dataActualizaEP.message === "Estado de pago modificado con éxito.") {
          alert("Estado de pago enviado con éxito.");

          obtenerEstadosPagoBH();
          obtenerEstadosPagoGH();
          obtenerEstadosPagoGT();

          setSubmitEPDisabled(false);

          navigate("/dashboard", { state: dataLogin });
        } else {
          throw new Error();
        }

      }
    } catch (error) {
      alert("Hubo un error al enviar el correo electrónico: " + error);
    }
  };

  return (
    <div className="d-flex" style={styles.mainContainer}>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        style={modalStyles}
        contentLabel="Modal"
        className="modal"
      >
        {modalContent}
      </Modal>
      <Modal
        isOpen={isSecondModalOpen}
        onRequestClose={closeSecondModal}
        style={modalStyles}
        contentLabel="Modal"
        className="modal"
      >
        {secondModalContent}
      </Modal>
      <SideMenu dataLogin={dataLogin} />
      <div className="w-100">
        <Header dataLogin={dataLogin} />
        <div className="container-fluid">
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {data.map((columnData, index) => (
              <div className="col" key={index}>
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center border-bottom-0 p-3 bg-white">
                    <h4>{columnData.title}</h4>
                    {columnData.title === "Estado de pago" ? (
                      <div className="btn-group">
                        <button type="button" className="btn btn-yellow dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                          <i className="bi-plus-circle"></i> Agregar
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <li>
                            <button className="dropdown-item" type="button" onClick={() => handleAddButtonClick("Estado de Pago BH")}>Bomba Hormigón</button>
                          </li>
                          <li>
                            <button className="dropdown-item" type="button" onClick={() => handleAddButtonClick("Estado de Pago GH")}>Grúa Hidráulica</button>
                          </li>
                          <li>
                            <button className="dropdown-item" type="button" onClick={() => handleAddButtonClick("Estado de Pago GT")}>Grúa Torre</button>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <button className="btn btn-yellow" key={index} onClick={() => handleAddButtonClick(columnData.title)}>
                        <i className="bi-plus-circle"></i> Agregar
                      </button>
                    )}
                  </div>
                  <div className="card-search px-3 pb-3">
                    <div className="input-group">
                      <span className="input-group-text">
                        <i className="bi bi-search"></i>
                      </span>
                      <input type="text" className="form-control" placeholder="Cliente..." onChange={(e) => handleFiltrosDashboard(e, columnData.title)} />
                    </div>
                  </div>
                  <div className="card-body card-body-fh pt-0">
                    {isLoading ? (
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border text-warning" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {columnData.cards.length > 0 ? (
                          columnData.cards.map((cardData, cardIndex) => (
                            columnData.title === "Cotización" ? (
                              <div
                                className="card-inside c-pointer"
                                key={cardIndex}
                                onClick={() => handleCardClick(columnData.title, cardData)}
                              >
                                <div className="card-title border-bottom bg-light p-2 mb-1">
                                  <span className="label">{cardData.nombre_cliente}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Rut</label>
                                  <span className="label">{`${formatearRut(cardData.rut_cliente)}`}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Folio</label>
                                  <span className="label">{cardData.folio}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Obra</label>
                                  <span className="label">{cardData.obra}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 pb-1">
                                  <label className="form-label mb-0">Fecha Cotización</label>
                                  <span className="label">{cardData.fecha_cotizacion}</span>
                                </div>
                              </div>
                            ) : columnData.title === "Requerimientos" ? (
                              <div
                                className="card-inside c-pointer"
                                key={cardIndex}
                                onClick={() => handleCardClick(columnData.title, cardData)}
                              >
                                <div className="card-title border-bottom bg-light p-2 mb-1">
                                  <span className="label">{cardData.nombre_cliente}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Rut</label>
                                  <span className="label">{`${formatearRut(cardData.rut_cliente)}`}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Obra</label>
                                  <span className="label">{cardData.nombre_obra}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Solicitante</label>
                                  <span className="label">{cardData.nombre_contacto}</span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                  <label className="form-label mb-0">Fecha Requerimiento</label>
                                  <span className="label">{cardData.fecha_requerimiento}</span>
                                </div>
                              </div>
                            ) : (
                              <div key={cardIndex}>
                                {estadosPagoFiltrados && estadosPagoFiltrados.length > 0 ? (
                                  <div>
                                    {estadosPagoFiltrados.map((item, index) => (
                                      <div
                                        className="card-inside c-pointer"
                                        key={index}
                                        onClick={
                                          () => handleCardClick(
                                            `${columnData.title} ${item.id_maquinaria === 1 ? "BH" : item.id_maquinaria === 2 ? "GH" : "GT"}`,
                                            item
                                          )
                                        }
                                      >
                                        <div className="card-title d-inline-flex justify-content-lg-between border-bottom bg-light p-2 mb-1">
                                          <span className="label">{item.nombre_cliente}</span>
                                          <span className="label">
                                            {item.id_estado_pago_bh
                                              ? `BH-${item.id_estado_pago_bh} (${item.estado_pago_estado})`
                                              : item.id_estado_pago_gh
                                                ? `GH-${item.id_estado_pago_gh} (${item.estado_pago_estado})`
                                                : `GT-${item.id_estado_pago_gt} (${item.estado_pago_estado})`}
                                          </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                          <label className="form-label mb-0">Rut</label>
                                          <span className="label">{`${formatearRut(item.rut_cliente)}`}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                          <label className="form-label mb-0">Folio</label>
                                          <span className="label">{item.folio}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center px-2 mb-1">
                                          <label className="form-label mb-0">Obra</label>
                                          <span className="label">{item.nombre_obra}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center px-2 pb-1">
                                          <label className="form-label mb-0">Fecha Estado Pago</label>
                                          <span className="label">{item.fecha_estado_pago}</span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="alert alert-warning" role="alert">
                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                    No se ha encontrado información.
                                  </div>
                                )}
                              </div>
                            )
                          ))
                        ) : (
                          <div className="alert alert-warning" role="alert">
                            <i className="bi bi-exclamation-triangle me-2"></i>
                            No se ha encontrado información.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const modalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

const styles = {
  mainContainer: {
    height: "100vh",
  },
};

export default Dashboard;
